<template>
  <div class="col-span-12 min-h-screen">
    <!-- 欢迎页面 - 未关联直播间状态 -->
    <div v-if="!hasRoomConnected" class="flex flex-col items-center justify-center text-center gap-8">
      <div class="bg-surface-light dark:bg-surface-dark rounded-xl p-8 flex flex-col items-center gap-8 max-w-2xl mt-6">
        <div class="flex flex-col items-center gap-4">
          <h2 class="text-slate-900 dark:text-white text-3xl font-bold">{{ $t('onAir.welcome') }}</h2>
          <p class="text-slate-600 dark:text-slate-300 text-lg leading-relaxed max-w-md">{{ $t('onAir.readyToConnect') }}
            <button name="go-live-inline-button" @click="goToOnboarding"
              class="inline-flex items-center gap-2 h-10 px-6 bg-primary text-white text-base font-bold rounded-lg hover:bg-primary/90 transition-colors ml-2 -mb-1">
              <span class="material-symbols-outlined" style="font-size: 22px;">podcasts</span>
              <span>{{ $t('onAir.goLive') }}</span>
            </button>
            {{ $t('onAir.nowAndLetYourAICoachAssistYou') }}
          </p>
        </div>
        <div class="border-t border-slate-200 dark:border-slate-700 w-full"></div>
        <div class="flex flex-col items-start gap-4 text-left self-stretch">
          <p class="text-text-secondary dark:text-slate-300 font-medium">{{ $t('onAir.yourAICoachWill') }}</p>
          <ul class="space-y-3">
            <li class="flex items-start gap-3">
              <span class="material-symbols-outlined text-primary mt-1" style="font-size: 20px;">check_circle</span>
              <span class="text-text-secondary dark:text-slate-400">{{ $t('onAir.fullyParticipate') }}</span>
            </li>
            <li class="flex items-start gap-3">
              <span class="material-symbols-outlined text-primary mt-1" style="font-size: 20px;">check_circle</span>
              <span class="text-text-secondary dark:text-slate-400">{{ $t('onAir.recordHistory') }}</span>
            </li>
            <li class="flex items-start gap-3">
              <span class="material-symbols-outlined text-primary mt-1" style="font-size: 20px;">check_circle</span>
              <span class="text-text-secondary dark:text-slate-400">{{ $t('onAir.identifyPatrons') }}</span>
            </li>
          </ul>
        </div>
      </div>

      <!-- 脚本生成器 -->
      <div class="w-full max-w-xl">
        <div class="relative">
          <input v-model="scriptPrompt"
            class="w-full h-12 px-4 pr-28 bg-surface-light dark:bg-surface-dark border border-slate-200 dark:border-slate-700 text-text-main dark:text-white rounded-lg placeholder:text-slate-400 dark:placeholder:text-slate-400 cursor-pointer focus:outline-none focus:ring-2 focus:ring-primary"
            :placeholder="$t('onAir.generateScriptFor')" type="text" readonly @focus="goToScriptGenerator" />
          <button @click="generateScript"
            class="absolute right-2 top-1/2 -translate-y-1/2 flex items-center justify-center gap-2 h-9 px-4 bg-primary hover:bg-[#00A065] text-white text-sm font-bold rounded-md transition-colors">
            <span class="material-symbols-outlined" style="font-size: 18px;">auto_awesome</span>
            <span>{{ $t('onAir.generate') }}</span>
          </button>
        </div>
      </div>
    </div>

      <!-- 已关联直播间状态 -->
      <div v-else>
        <!-- 无直播状态 -->
        <div v-if="!actualIsLive" class="flex flex-col items-center justify-center text-center gap-6">
          <!-- 直播间状态卡片 -->
          <div class="bg-surface-light dark:bg-surface-dark rounded-xl p-8 flex flex-col items-center gap-4 mt-6">
            <span class="material-symbols-outlined text-slate-400 dark:text-slate-600 text-6xl">history_toggle_off</span>
                <h2 class="text-text-main dark:text-white text-2xl font-bold">{{ $t('onAir.noPastStreams') }}</h2>
                <p class="text-text-secondary dark:text-slate-400 max-w-sm">{{ $t('onAir.startFirstBroadcast') }}</p>
            <button name="go-live-button" @click="goToOnboarding"
              class="flex items-center justify-center gap-2 h-12 px-8 mt-2 bg-primary text-white text-lg font-bold rounded-lg hover:bg-primary/90 transition-colors">
              <span class="material-symbols-outlined" style="font-size: 28px;">podcasts</span>
              <span>{{ $t('onAir.goLiveExclamation') }}</span>
            </button>
          </div>

          <!-- 脚本生成器 -->
          <div class="w-full max-w-xl">
            <div class="relative">
              <input v-model="scriptPrompt"
                class="w-full h-12 px-4 pr-28 bg-surface-light dark:bg-surface-dark border border-slate-200 dark:border-slate-700 text-text-main dark:text-white rounded-lg placeholder:text-slate-400 dark:placeholder:text-slate-400 cursor-pointer focus:outline-none focus:ring-2 focus:ring-primary"
                :placeholder="$t('onAir.generateScriptFor')" type="text" readonly @focus="goToScriptGenerator" />
            <button @click="generateScript"
              class="absolute right-2 top-1/2 -translate-y-1/2 flex items-center justify-center gap-2 h-9 px-4 bg-primary hover:bg-[#00A065] text-white text-sm font-bold rounded-md transition-colors">
              <span class="material-symbols-outlined" style="font-size: 18px;">auto_awesome</span>
              <span>{{ $t('onAir.generate') }}</span>
            </button>
            </div>
          </div>
        </div>

      <!-- 有直播状态 - 移动端优化布局 -->
      <main id="live-dashboard" v-if="actualIsLive" class="relative">
        <!-- 移动端：优先显示话术建议区域 -->
        <div class="block lg:hidden">
            <!-- 移动端浮动按钮组 - 侧边栏展开时隐藏 -->
            <div v-if="!sidebarExpanded()" class="fixed bottom-6 right-6 flex flex-col gap-3 z-50">
              <!-- 聊天浮层按钮 -->
              <button @click="toggleChatOverlay"
                :class="[
                  'flex items-center justify-center w-14 h-14 border-2 border-primary rounded-full shadow-lg hover:bg-primary hover:text-white transition-all duration-200',
                  showChatOverlay ? 'bg-primary text-white' : 'bg-white dark:bg-[#111722] text-primary'
                ]">
                <span class="material-symbols-outlined" style="font-size: 28px;">chat</span>
              </button>

              <!-- 赞助者列表按钮 -->
              <button @click="togglePatronsOverlay"
                :class="[
                  'flex items-center justify-center w-14 h-14 border-2 border-yellow-500 rounded-full shadow-lg hover:bg-yellow-500 hover:text-white transition-all duration-200',
                  showPatronsOverlay ? 'bg-yellow-500 text-white' : 'bg-white dark:bg-[#111722] text-yellow-500'
                ]">
                <span class="material-symbols-outlined" style="font-size: 28px;">local_fire_department</span>
              </button>
            </div>

          <!-- TikTok风格聊天浮层 -->
          <div v-if="showChatOverlay"
            class="fixed bottom-0 left-4 right-4 md:left-1/2 md:-translate-x-1/2 md:right-auto md:w-96 md:max-w-sm bg-black/5 rounded-t-xl border border-white/10 shadow-2xl max-h-96 overflow-hidden z-30">
            <!-- 聊天头部 -->
            <div class="p-3 border-b border-white/10 bg-black/10">
              <div class="flex items-center justify-between">
                <button @click="toggleChatOverlay"
                  class="text-white/60 hover:text-white/80 transition-colors">
                  <span class="material-symbols-outlined text-sm">close</span>
                </button>
              </div>
            </div>

            <!-- 自动滚动聊天内容区域 -->
            <div ref="chatScrollContainer"
              class="max-h-80 overflow-y-auto custom-scrollbar p-2 space-y-1"
              style="scroll-behavior: smooth;">
              <div v-for="(activity) in filteredActivities.slice(0, 20)" :key="activity.id"
                class="animate-fade-in">
                <!-- 消息类型 - TikTok风格 -->
                <div v-if="activity.type === 'message'"
                  :class="activity.isHistorical ? 'opacity-60' : 'opacity-90'"
                  class="flex items-start gap-2 p-2 rounded-lg hover:bg-white/5 transition-colors cursor-pointer"
                  @click="handleSingleMessageSuggestion(activity)">
                  <div class="bg-center bg-no-repeat aspect-square bg-cover rounded-full w-5 shrink-0 mt-0.5 border border-white/20"
                    :data-alt="'User avatar for ' + activity.name"
                    :style="{ backgroundImage: 'url(' + activity.avatar + ')' }"></div>
                  <div class="flex-1 min-w-0">
                    <div class="flex items-baseline gap-1.5 mb-0.5">
                      <p class="text-text-main dark:text-white text-xs font-bold truncate">{{ activity.name }}</p>
                      <p class="text-text-secondary dark:text-slate-400 text-xs flex-shrink-0">{{ activity.time }}</p>
                    </div>
                    <p class="text-text-secondary dark:text-slate-300 text-xs leading-relaxed break-words">{{ activity.content }}</p>
                    <p v-if="activity.translatedContent && languageMode === 'different'"
                      class="text-green-600 dark:text-green-300/80 text-xs italic mt-0.5 break-words">
                      {{ activity.translatedContent }}
                    </p>
                  </div>
                </div>

                <!-- 礼物类型 - TikTok风格 -->
                <div v-else-if="activity.type === 'gift'"
                  :class="activity.isHistorical ? 'opacity-60' : 'opacity-90'"
                  class="flex items-start gap-2 p-2 rounded-lg hover:bg-white/5 transition-colors cursor-pointer"
                  @click="handleSingleMessageSuggestion(activity)">
                  <div class="bg-center bg-no-repeat aspect-square bg-cover rounded-full w-5 shrink-0 mt-0.5 border border-white/20"
                    :data-alt="'User avatar for ' + activity.name"
                    :style="{ backgroundImage: 'url(' + activity.avatar + ')' }"></div>
                  <div class="flex-1 min-w-0">
                    <div class="flex items-baseline gap-1.5 mb-0.5">
                      <p class="text-text-main dark:text-white text-xs font-bold truncate">{{ activity.name }}</p>
                      <p class="text-text-secondary dark:text-slate-400 text-xs flex-shrink-0">{{ activity.time }}</p>
                    </div>
                    <div class="flex items-center gap-1.5 text-xs">
                      <span class="text-yellow-400">🎁</span>
                      <span class="text-white/90">{{ $t('onAir.sent') }}</span>
                      <span class="text-yellow-400 font-medium">{{ activity.giftName }}</span>
                      <span class="text-white/80">x{{ activity.giftCount }}</span>
                      <span class="text-yellow-500 font-bold">🪙{{ activity.giftValue }}</span>
                    </div>
                  </div>
                </div>

                <!-- 互动类型 - TikTok风格 -->
                <div v-else-if="['enter', 'follow', 'like', 'share'].includes(activity.type)"
                  :class="activity.isHistorical ? 'opacity-60' : 'opacity-90'"
                  class="flex items-start gap-2 p-2 rounded-lg hover:bg-white/5 transition-colors cursor-pointer border-b border-slate-200 dark:border-slate-700"
                  @click="handleSingleMessageSuggestion(activity)">
                  <div class="bg-center bg-no-repeat aspect-square bg-cover rounded-full w-5 shrink-0 mt-0.5 border border-white/20"
                    :data-alt="'User avatar for ' + activity.name"
                    :style="{ backgroundImage: 'url(' + activity.avatar + ')' }"></div>
                  <div class="flex-1 min-w-0">
                    <div class="flex items-baseline gap-1.5 mb-0.5">
                      <p class="text-text-main dark:text-white text-xs font-bold truncate">{{ activity.name }}</p>
                      <p class="text-text-secondary dark:text-slate-400 text-xs flex-shrink-0">{{ activity.time }}</p>
                    </div>
                    <p class="text-text-secondary dark:text-slate-300 text-xs leading-relaxed break-words">{{ activity.content }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 赞助者列表浮层 -->
          <div v-if="showPatronsOverlay"
            class="fixed top-20 left-4 right-4 bg-surface-light dark:bg-[#111722] rounded-xl border border-slate-200 dark:border-slate-800 shadow-2xl max-h-96 overflow-hidden z-30">
            <div class="p-4 border-b border-slate-200 dark:border-slate-800">
              <div class="flex items-center justify-between">
                <h3 class="text-white font-bold text-lg">{{ $t('onAir.topPatrons') }}</h3>
                <button @click="togglePatronsOverlay"
                  class="text-slate-400 hover:text-white">
                  <span class="material-symbols-outlined">{{ $t('onAir.close') }}</span>
                </button>
              </div>
            </div>
            <div class="max-h-64 overflow-y-auto custom-scrollbar">
              <div v-if="potentialPatrons.length === 0" class="p-8 text-center">
                <div class="w-6 h-6 border-2 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-3"></div>
                <p class="text-slate-400 text-sm">{{ $t('onAir.loadingPotentialPatrons') }}</p>
              </div>
              <ul v-else class="divide-y divide-slate-200 dark:divide-slate-800">
                <li v-for="(patron, index) in potentialPatrons.slice(0, 10)" :key="patron.userInfoId || index"
                  class="p-3 flex items-center gap-3 hover:bg-white/5">
                  <span class="text-sm font-bold text-slate-400 w-4 text-center">{{ index + 1 }}</span>
                  <div class="bg-center bg-no-repeat aspect-square bg-cover rounded-full size-8"
                    :data-alt="'User avatar for ' + (patron.userName || $t('onAir.unknownUser'))"
                    :style="{ backgroundImage: 'url(' + getUserAvatarUrl(patron.userInfoId) + ')' }"></div>
                  <div class="flex-1">
                    <p class="text-white font-semibold text-sm">{{ patron.userName || $t('onAir.unknownUser') }}</p>
                    <p class="text-slate-400 text-xs truncate">{{ patron.rewardUserType || $t('onAir.potentialPatron') }}</p>
                  </div>
                  <div class="text-right">
                    <p class="text-green-400 font-bold text-sm">{{ formatProbability(patron.rewardProbability) }}</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <!-- 优先目标 - 移动端全屏显示 -->
          <div id="priority-target-mobile"
            class="bg-surface-light dark:bg-surface-dark rounded-xl border border-primary/50 shadow-lg shadow-primary/10 mx-4 mt-4 mb-32">
            <h2 class="text-text-main dark:text-white text-xl font-bold leading-tight tracking-[-0.015em] px-4 pb-3 pt-5 lg:block hidden">{{ $t('onAir.priorityTarget') }}</h2>
            <div class="p-4 flex flex-col gap-4">
              <div class="flex items-start gap-4">
                <div class="bg-center bg-no-repeat aspect-square bg-cover rounded-full size-12 shrink-0"
                  :data-alt="'User avatar for ' + selectedUser.name"
                  :style="{ backgroundImage: 'url(' + selectedUser.avatar + ')' }"></div>
                <div class="flex-1">
                  <p class="text-text-main dark:text-white text-base font-bold">{{ selectedUser.name }}</p>
                  <div class="flex items-center gap-4 text-sm text-text-secondary dark:text-slate-300 mb-2">
                    <span>{{ $t('onAir.interactionProbability') }}: <span class="font-bold text-primary">{{
                        selectedUser.interactionProbability }}</span></span>
                  </div>
                  <button @click="openHistoryModal"
                    class="flex items-center gap-1.5 text-sm text-text-secondary dark:text-slate-300 hover:text-primary dark:hover:text-white lg:flex lg:items-center lg:gap-1.5 hidden:flex hidden:items-center hidden:gap-1.5 flex:items-center flex:justify-start lg:block hidden">
                    <span class="material-symbols-outlined text-base">history</span>
                    <span class="lg:inline hidden:inline block">{{ $t('onAir.viewHistoricalContext') }}</span>
                  </button>
                </div>
                <!-- 桌面端显示话术建议标记，移动端显示历史记录按钮 -->
                <div class="lg:block hidden">
                  <div class="bg-primary/20 text-primary px-3 py-1 rounded-full text-xs font-semibold">{{
                    selectedUser.tag }}</div>
                </div>
                <div class="lg:hidden block">
                  <button @click="openHistoryModal"
                    class="flex items-center justify-center w-8 h-8 bg-slate-200 dark:bg-slate-700 hover:bg-slate-300 dark:hover:bg-slate-600 text-text-secondary dark:text-slate-300 hover:text-primary dark:hover:text-white rounded-full transition-colors">
                    <span class="material-symbols-outlined text-sm">history</span>
                  </button>
                </div>
              </div>

              <!-- 语言模式切换 -->
              <div class="flex justify-between items-center mb-3">
                <div class="flex border-b border-slate-300 dark:border-slate-700">
                  <button @click="setLanguageMode('same')"
                    :class="languageMode === 'same' ? 'text-primary dark:text-white border-b-2 border-primary' : 'text-text-secondary dark:text-slate-400 border-b-2 border-transparent hover:text-primary dark:hover:text-white'"
                    class="px-3 py-2 text-sm font-medium">
                    {{ $t('onAir.sameLanguage') }}
                  </button>
                  <button @click="setLanguageMode('different')"
                    :class="languageMode === 'different' ? 'text-primary dark:text-white border-b-2 border-primary' : 'text-text-secondary dark:text-slate-400 border-b-2 border-transparent hover:text-primary dark:hover:text-white'"
                    class="px-3 py-2 text-sm font-medium">
                    {{ $t('onAir.differentLanguage') }}
                  </button>
                </div>
                <div class="flex items-center gap-2">
                  <button @click="decreaseFontSize"
                    class="flex items-center justify-center size-6 rounded-md bg-slate-100 dark:bg-slate-800 text-text-secondary dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-700"
                    :disabled="fontSize <= minFontSize">
                    <span class="material-symbols-outlined" style="font-size: 18px;">zoom_out</span>
                  </button>
                  <button @click="increaseFontSize"
                    class="flex items-center justify-center size-6 rounded-md bg-slate-100 dark:bg-slate-800 text-text-secondary dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-700"
                    :disabled="fontSize >= maxFontSize">
                    <span class="material-symbols-outlined" style="font-size: 18px;">zoom_in</span>
                  </button>
                </div>
              </div>

              <!-- Same Language Response -->
              <div v-if="languageMode === 'same'" class="bg-slate-100 dark:bg-slate-800 p-3 rounded-lg space-y-3">
                <div>
                  <p class="text-primary text-sm font-semibold mb-1">{{ $t('onAir.originalMessageLabel') }}</p>
                  <p class="text-text-main dark:text-white text-sm" :style="{ fontSize: fontSize + 'px' }">{{ selectedUser.message }}</p>
                </div>
                <div class="border-t border-slate-300/50 dark:border-slate-700/50 pt-3">
                  <div class="flex justify-between items-start mb-1">
                    <p class="text-text-secondary dark:text-slate-300 text-sm font-semibold">{{ $t('onAir.suggestedResponseLabel') }}</p>
                    <div class="flex items-center gap-2">
                      <div v-if="selectedUser.priorityRating > 0" class="flex items-center gap-1 text-yellow-500 dark:text-yellow-400">
                        <span class="text-xs font-semibold">{{ selectedUser.priorityRating }}/5</span>
                        <span class="text-sm">{{ '★'.repeat(selectedUser.priorityRating) }}{{ '☆'.repeat(5 -
                          selectedUser.priorityRating) }}</span>
                      </div>
                      <button @click="copySuggestedResponse('same')" class="flex items-center gap-1 text-xs text-text-secondary dark:text-slate-400 hover:text-primary dark:hover:text-white transition-colors">
                        <span class="material-symbols-outlined text-sm">content_copy</span>
                        <span>{{ $t('common.copy') }}</span>
                      </button>
                    </div>
                  </div>
                  <div class="text-text-main dark:text-white text-sm" :style="{ fontSize: fontSize + 'px' }"
                    v-html="selectedUser.sameLanguageResponse"></div>
                  <div v-if="selectedUser.phoneticGuide && selectedUser.phoneticGuide.trim()"
                    class="mt-2 pt-2 border-t border-slate-300/50 dark:border-slate-700/50">
                    <p class="text-text-secondary dark:text-slate-400 text-xs font-medium mb-1">{{ $t('onAir.phoneticGuideLabel') }}</p>
                    <p class="text-green-600 dark:text-green-300/80 text-xs" :style="{ fontSize: (fontSize - 2) + 'px' }">{{
                      selectedUser.phoneticGuide }}</p>
                  </div>
                </div>
              </div>

              <!-- Different Language Response -->
              <div v-else class="flex flex-col gap-3">
                <div class="bg-slate-100 dark:bg-slate-800 p-3 rounded-lg">
                  <div class="flex justify-between items-center mb-2">
                    <p class="text-primary text-sm font-semibold">{{ $t('onAir.originalMessageLabel') }}</p>
                    <div class="flex items-center gap-2">
                      <select v-model="selectedSourceLanguage" @change="handleLanguageChange"
                        class="bg-white dark:bg-slate-900 border-slate-300 dark:border-slate-700 text-text-main dark:text-white text-xs rounded-md p-1 pr-6 focus:ring-primary focus:border-primary">
                        <option value="ja">{{ $t('onAir.japanese') }}</option>
                        <option value="zh">{{ $t('onAir.chinese') }}</option>
                        <option value="en">{{ $t('onAir.english') }}</option>
                      </select>
                      <span class="text-text-secondary dark:text-slate-400 text-xs">{{ $t('onAir.to') }}</span>
                      <select v-model="selectedTargetLanguage" @change="handleLanguageChange"
                        class="bg-white dark:bg-slate-900 border-slate-300 dark:border-slate-700 text-text-main dark:text-white text-xs rounded-md p-1 pr-6 focus:ring-primary focus:border-primary">
                        <option value="zh">{{ $t('onAir.chinese') }}</option>
                        <option value="en">{{ $t('onAir.english') }}</option>
                        <option value="ja">{{ $t('onAir.japanese') }}</option>
                      </select>
                    </div>
                  </div>
                  <p class="text-text-main dark:text-white text-sm" :style="{ fontSize: fontSize + 'px' }">{{ selectedUser.message }}</p>
                  <div class="border-t border-slate-300/50 dark:border-slate-700/50 mt-2 pt-2">
                    <p class="text-text-secondary dark:text-slate-400 text-xs mb-1">{{ $t('onAir.translationLabel') }}</p>
                    <p class="text-text-main dark:text-white text-sm" :style="{ fontSize: fontSize + 'px' }">{{ selectedUser.originalTranslation
                      || $t('onAir.gettingTranslation')
                      }}</p>
                  </div>
                </div>
                <div class="bg-slate-100 dark:bg-[#232f48] p-3 rounded-lg">
                  <p class="text-text-secondary dark:text-slate-300 text-sm font-semibold mb-2">{{ $t('onAir.recommendedResponseLabel') }}</p>
                  <p class="text-text-main dark:text-white font-semibold leading-snug text-sm" :style="{ fontSize: fontSize + 'px' }">{{
                    selectedUser.differentLanguageResponse }}</p>
                  <div class="mt-2">
                    <p class="text-text-secondary dark:text-slate-400 text-xs font-medium">{{ $t('onAir.phoneticGuideLabel') }}</p>
                    <p class="text-green-600 dark:text-green-300/80 text-xs" :style="{ fontSize: fontSize + 'px' }">{{
                      selectedUser.phoneticGuide }}</p>
                  </div>
                  <div class="border-t border-slate-300/50 dark:border-slate-700/50 pt-2 mt-2">
                    <p class="text-text-secondary dark:text-slate-400 text-xs mb-1">{{ $t('onAir.translationLabel') }}</p>
                    <p class="text-text-main dark:text-white text-sm" :style="{ fontSize: fontSize + 'px' }">{{
                      selectedUser.suggestionTranslation ||
                      $t('onAir.gettingTranslation') }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 桌面端布局 -->
        <div class="hidden lg:grid grid-cols-12 grid-rows-1 gap-6 p-6">
          <!-- 左侧区域 -->
          <div class="col-span-5 flex flex-col gap-6 h-[calc(100vh-60px)]">
            <!-- 直播活动动态 -->
            <div class="flex-1 bg-white dark:bg-[#111722] rounded-xl overflow-hidden flex flex-col">
            <h2 class="text-slate-900 text-[22px] font-bold leading-tight tracking-[-0.015em] px-4 pt-5">{{ $t('onAir.liveActivityFeed') }}</h2>
              <div class="flex-1 overflow-hidden flex flex-col">
                <div class="px-4 border-b border-slate-200 dark:border-slate-800 shrink-0">
                  <div class="flex -mb-px overflow-x-auto scrollbar-hide" ref="tabContainer"
                    @wheel="handleTabWheel" @mousedown="startDrag" @mousemove="handleDrag" @mouseup="stopDrag"
                    @mouseleave="stopDrag">
                      <button @click="setActiveTab('all')"
                        :class="activeTab === 'all' ? 'text-text-main dark:text-white border-b-2 border-primary' : 'text-text-secondary dark:text-slate-400 border-b-2 border-transparent hover:text-text-main dark:hover:text-white'"
                        class="flex items-center gap-2 px-4 py-3 text-sm font-semibold whitespace-nowrap">
                        <span>{{ $t('onAir.all') }}</span>
                        <span :class="activeTab === 'all' ? 'bg-primary/20 text-primary' : 'bg-slate-200 dark:bg-slate-700 text-text-secondary dark:text-slate-300'"
                          class="px-2 py-0.5 rounded-full text-xs">{{ tabCounts.all }}</span>
                      </button>
                    <button @click="setActiveTab('messages')"
                      :class="activeTab === 'messages' ? 'text-text-main dark:text-white border-b-2 border-primary' : 'text-text-secondary dark:text-slate-400 border-b-2 border-transparent hover:text-text-main dark:hover:text-white'"
                      class="flex items-center gap-2 px-4 py-3 text-sm font-semibold whitespace-nowrap">
                      <span>{{ $t('onAir.messages') }}</span>
                      <span
                        :class="activeTab === 'messages' ? 'bg-primary/20 text-primary' : 'bg-slate-200 dark:bg-slate-700 text-text-secondary dark:text-slate-300'"
                        class="px-2 py-0.5 rounded-full text-xs">{{ tabCounts.messages }}</span>
                    </button>
                    <button @click="setActiveTab('gifts')"
                      :class="activeTab === 'gifts' ? 'text-text-main dark:text-white border-b-2 border-primary' : 'text-text-secondary dark:text-slate-400 border-b-2 border-transparent hover:text-text-main dark:hover:text-white'"
                      class="flex items-center gap-2 px-4 py-3 text-sm font-semibold whitespace-nowrap">
                      <span>{{ $t('onAir.gifts') }}</span>
                      <span :class="activeTab === 'gifts' ? 'bg-primary/20 text-primary' : 'bg-slate-200 dark:bg-slate-700 text-text-secondary dark:text-slate-300'"
                        class="px-2 py-0.5 rounded-full text-xs">{{ tabCounts.gifts }}</span>
                    </button>
                    <button @click="setActiveTab('interactions')"
                      :class="activeTab === 'interactions' ? 'text-text-main dark:text-white border-b-2 border-primary' : 'text-text-secondary dark:text-slate-400 border-b-2 border-transparent hover:text-text-main dark:hover:text-white'"
                      class="flex items-center gap-2 px-4 py-3 text-sm font-semibold whitespace-nowrap">
                      <span>{{ $t('onAir.interactions') }}</span>
                      <span
                        :class="activeTab === 'interactions' ? 'bg-primary/20 text-primary' : 'bg-slate-200 dark:bg-slate-700 text-text-secondary dark:text-slate-300'"
                        class="px-2 py-0.5 rounded-full text-xs">{{ tabCounts.interactions }}</span>
                    </button>
                  </div>
                </div>
                <div ref="activityScrollContainer"
                  class="p-2 space-y-2 overflow-y-auto custom-scrollbar flex-1" @scroll="handleActivityScroll">
                  <!-- Loading indicator for historical comments -->
                  <div v-if="historicalLoading && historicalComments.length === 0" class="text-center py-4">
                    <div
                      class="w-4 h-4 border-2 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-2">
                    </div>
                    <p class="text-slate-400 text-xs">{{ $t('onAir.loadingHistoricalComments') }}</p>
                  </div>

                  <!-- Unified Activity Feed Content -->
                  <div v-for="(activity, index) in filteredActivities" :key="activity.id">
                    <!-- Historical Comments Separator -->
                  <div v-if="historicalSeparatorIndex >= 0 && index === historicalSeparatorIndex"
                    class="flex items-center gap-3 px-3 py-2">
                    <div class="flex-1 h-px bg-gradient-to-r from-transparent via-slate-300 dark:via-slate-600 to-transparent"></div>
                    <div class="bg-slate-200/50 dark:bg-slate-700/50 text-slate-600 dark:text-slate-400 text-xs px-3 py-1 rounded-full font-medium">
                      {{ $t('onAir.historicalComments') }}
                    </div>
                    <div class="flex-1 h-px bg-gradient-to-r from-transparent via-slate-300 dark:via-slate-600 to-transparent"></div>
                  </div>

                    <!-- Message Type -->
                    <div v-if="activity.type === 'message'" :class="activity.isHistorical ? 'opacity-75' : ''">
                      <div
                        :class="selectedUserId === activity.id ? 'flex items-start gap-2 p-2 rounded-md bg-green-500/10 border border-green-500 cursor-pointer hover:bg-green-500/20 transition-colors border-b border-slate-200 dark:border-slate-700' : 'flex items-start gap-2 p-2 rounded-md hover:bg-white/5 cursor-pointer transition-colors border-b border-slate-200 dark:border-slate-700'"
                        @click="handleSingleMessageSuggestion(activity)">
                        <div class="bg-center bg-no-repeat aspect-square bg-cover rounded-full w-8 shrink-0 mt-1"
                          :data-alt="'User avatar for ' + activity.name"
                          :style="{ backgroundImage: 'url(' + activity.avatar + ')' }"></div>
                        <div>
                    <div class="flex items-baseline gap-2">
                      <p class="text-text-main dark:text-white text-sm font-bold">{{ activity.name }}</p>
                      <p class="text-text-secondary dark:text-slate-400 text-xs">{{ activity.time }}</p>
                    </div>
                    <p class="text-text-secondary dark:text-slate-300 text-sm">{{ activity.content }}</p>
                          <p v-if="activity.translatedContent && languageMode === 'different'"
                            class="text-green-600 dark:text-green-300/80 text-xs italic mt-1">
                            {{ activity.translatedContent }}
                          </p>
                        </div>
                      </div>
                    </div>

                    <!-- Gift Type -->
                    <div v-else-if="activity.type === 'gift'" :class="activity.isHistorical ? 'opacity-75' : ''">
                      <div
                        :class="selectedUserId === activity.id ? 'p-2 rounded-md bg-green-500/10 border border-green-500 cursor-pointer hover:bg-green-500/20 transition-colors border-b border-slate-200 dark:border-slate-700' : 'p-2 rounded-md hover:bg-white/5 cursor-pointer transition-colors border-b border-slate-200 dark:border-slate-700'"
                        @click="handleSingleMessageSuggestion(activity)">
                        <div class="flex items-start gap-2">
                          <div class="bg-center bg-no-repeat aspect-square bg-cover rounded-full w-8 shrink-0 mt-1"
                            :data-alt="'User avatar for ' + activity.name"
                            :style="{ backgroundImage: 'url(' + activity.avatar + ')' }"></div>
                          <div class="flex-1">
                            <div class="flex items-baseline gap-2">
                              <p class="text-text-main dark:text-white text-sm font-bold">{{ activity.name }}</p>
                              <p class="text-text-secondary dark:text-slate-400 text-xs">{{ activity.time }}</p>
                            </div>
                            <div class="flex items-center gap-2 text-text-secondary dark:text-slate-300 text-sm">
                              <span>{{ $t('onAir.sent') }} <strong>{{ activity.giftName }}</strong></span>
                              <span>x{{ activity.giftCount }}</span>
                              <span class="font-semibold text-yellow-400">🪙{{ activity.giftValue }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Interaction Types (enter, follow, like, share) -->
                    <div v-else-if="['enter', 'follow', 'like', 'share'].includes(activity.type)"
                      :class="activity.isHistorical ? 'opacity-75' : ''">
                      <div
                        :class="selectedUserId === activity.id ? 'flex items-start gap-2 p-2 rounded-md bg-green-500/10 border border-green-500 cursor-pointer hover:bg-green-500/20 transition-colors border-b border-slate-200 dark:border-slate-700' : 'flex items-start gap-2 p-2 rounded-md hover:bg-white/5 cursor-pointer transition-colors border-b border-slate-200 dark:border-slate-700'"
                        @click="handleSingleMessageSuggestion(activity)">
                        <div class="bg-center bg-no-repeat aspect-square bg-cover rounded-full w-8 shrink-0 mt-1"
                          :data-alt="'User avatar for ' + activity.name"
                          :style="{ backgroundImage: 'url(' + activity.avatar + ')' }"></div>
                        <div>
                            <div class="flex items-baseline gap-2">
                              <p class="text-text-main dark:text-white text-sm font-bold">{{ activity.name }}</p>
                              <p class="text-text-secondary dark:text-slate-400 text-xs">{{ activity.time }}</p>
                            </div>
                            <p class="text-text-secondary dark:text-slate-300 text-sm">{{ activity.content }}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Loading more historical comments indicator -->
                  <div v-if="historicalLoadingMore" class="text-center py-4">
                    <div
                      class="w-4 h-4 border-2 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-2">
                    </div>
                    <p class="text-slate-400 text-xs">{{ $t('onAir.loadingMoreHistoricalComments') }}</p>
                  </div>

                  <!-- End of historical comments -->
                  <div v-if="!hasMoreHistorical && historicalComments.length > 0" class="text-center py-4">
                    <p class="text-text-secondary dark:text-slate-500 text-xs">{{ $t('onAir.noMoreHistoricalComments') }}</p>
                  </div>
                </div>
              </div>
            </div>

            <!-- 脚本生成器 -->
            <div class="bg-white dark:bg-[#111722] rounded-xl p-4">
              <div class="relative">
                <input v-model="scriptPrompt"
                  class="w-full h-12 px-4 pr-28 bg-slate-100 dark:bg-[#232f48] border border-slate-200 dark:border-slate-700 text-text-main dark:text-white rounded-lg placeholder:text-slate-400 dark:placeholder:text-slate-400 cursor-pointer focus:outline-none focus:ring-2 focus:ring-primary"
                  :placeholder="$t('onAir.generateScriptFor')" type="text" readonly @focus="goToScriptGenerator" />
                <button @click="goToScriptGenerator"
                  class="absolute right-2 top-1/2 -translate-y-1/2 flex items-center justify-center gap-2 h-9 px-4 bg-primary text-white text-sm font-bold rounded-md">
                  <span class="material-symbols-outlined" style="font-size: 18px;">auto_awesome</span>
                  <span>{{ $t('onAir.generate') }}</span>
                </button>
              </div>
            </div>
          </div>

          <!-- 右侧区域 -->
          <div class="col-span-7 flex flex-col h-[calc(100vh-60px)] overflow-y-auto pr-2 custom-scrollbar">
            <div class="flex flex-col gap-6">
              <!-- 优先目标 -->
              <div class="bg-white dark:bg-[#111722] rounded-xl border border-primary/50 shadow-lg shadow-primary/10">
                <h2 class="text-slate-900 text-[22px] font-bold leading-tight tracking-[-0.015em] px-4 pb-3 pt-5">{{ $t('onAir.priorityTarget') }}</h2>
                <div class="p-4 flex flex-col gap-4">
                  <div class="flex items-start gap-4">
                    <div class="bg-center bg-no-repeat aspect-square bg-cover rounded-full size-16 shrink-0"
                      :data-alt="'User avatar for ' + selectedUser.name"
                      :style="{ backgroundImage: 'url(' + selectedUser.avatar + ')' }"></div>
                    <div class="flex-1">
                      <p class="text-text-main dark:text-white text-lg font-bold">{{ selectedUser.name }}</p>
                  <div class="flex items-center gap-4 text-sm text-text-secondary dark:text-slate-400 mb-2">
                    <span>{{ $t('onAir.interactionProbability') }}: <span class="font-bold text-primary">{{
                            selectedUser.interactionProbability }}</span></span>
                        <span>{{ $t('onAir.previousAppearances') }}: <span class="font-bold text-text-main dark:text-white">{{ selectedUser.previousAppearances
                            }}</span></span>
                      </div>
                  <button @click="openHistoryModal"
                    class="flex items-center gap-1.5 text-sm text-text-secondary dark:text-slate-400 hover:text-primary dark:hover:text-white">
                    <span class="material-symbols-outlined text-base">history</span>
                    <span>{{ $t('onAir.viewHistoricalContext') }}</span>
                  </button>
                    </div>
                    <div class="bg-primary/20 text-primary px-3 py-1 rounded-full text-xs font-semibold">{{
                      selectedUser.tag }}</div>
                  </div>
                  <div>
                    <div class="flex justify-between items-center mb-3">
                      <div class="flex border-b border-slate-300 dark:border-slate-700">
                        <button @click="setLanguageMode('same')"
                          :class="languageMode === 'same' ? 'text-text-main dark:text-white border-b-2 border-primary' : 'text-text-secondary dark:text-slate-400 border-b-2 border-transparent hover:text-text-main dark:hover:text-white'"
                          class="px-4 py-2 text-sm font-medium">
                          {{ $t('onAir.sameLanguage') }}
                        </button>
                        <button @click="setLanguageMode('different')"
                          :class="languageMode === 'different' ? 'text-text-main dark:text-white border-b-2 border-primary' : 'text-text-secondary dark:text-slate-400 border-b-2 border-transparent hover:text-text-main dark:hover:text-white'"
                          class="px-4 py-2 text-sm font-medium">
                          {{ $t('onAir.differentLanguage') }}
                        </button>
                      </div>
                      <!-- <button @click="openHistoryModal"
                        class="flex items-center gap-1.5 text-sm text-text-secondary dark:text-slate-400 hover:text-primary dark:hover:text-white bg-primary/20 px-3 py-1 rounded-full hover:bg-primary/30 transition-colors">
                        <span class="material-symbols-outlined text-base">history</span>
                        <span>View Historical Context</span>
                      </button> -->
                      <div class="flex items-center gap-2">
                        <button @click="decreaseFontSize"
                          class="flex items-center justify-center size-7 rounded-md bg-slate-100 dark:bg-[#232f48] text-text-secondary dark:text-slate-400 hover:bg-slate-200 dark:hover:bg-slate-700"
                          :disabled="fontSize <= minFontSize">
                          <span class="material-symbols-outlined" style="font-size: 20px;">zoom_out</span>
                        </button>
                        <button @click="increaseFontSize"
                          class="flex items-center justify-center size-7 rounded-md bg-slate-100 dark:bg-[#232f48] text-text-secondary dark:text-slate-400 hover:bg-slate-200 dark:hover:bg-slate-700"
                          :disabled="fontSize >= maxFontSize">
                          <span class="material-symbols-outlined" style="font-size: 20px;">zoom_in</span>
                        </button>
                      </div>
                    </div>

                    <!-- Same Language Response -->
                    <div v-if="languageMode === 'same'" class="bg-slate-100 dark:bg-[#232f48] p-4 rounded-lg space-y-4">
                      <div>
                        <p class="text-green-400 text-sm font-semibold mb-2">{{ $t('onAir.originalMessageLabel') }}</p>
                        <p class="text-text-main dark:text-white" :style="{ fontSize: fontSize + 'px' }">{{ selectedUser.message }}</p>
                      </div>
                      <div class="border-t pt-4">
                        <div class="flex justify-between items-start mb-1">
                          <p class="text-text-secondary dark:text-slate-300 text-sm font-semibold">{{ $t('onAir.suggestedResponseLabel') }}</p>
                          <div v-if="selectedUser.priorityRating > 0" class="flex items-center gap-1 text-yellow-500 dark:text-yellow-400">
                            <span class="text-sm font-semibold">{{ selectedUser.priorityRating }}/5</span>
                            <span class="text-lg">{{ '★'.repeat(selectedUser.priorityRating) }}{{ '☆'.repeat(5 -
                              selectedUser.priorityRating) }}</span>
                          </div>
                        </div>
                        <div class="text-text-main dark:text-white" :style="{ fontSize: fontSize + 'px' }"
                          v-html="selectedUser.sameLanguageResponse"></div>
                        <div v-if="selectedUser.phoneticGuide && selectedUser.phoneticGuide.trim()"
                          class="mt-3 pt-3 border-t">
                          <p class="text-text-secondary dark:text-slate-400 text-xs font-medium mb-1">{{ $t('onAir.phoneticGuideLabel') }}</p>
                          <p class="text-green-600 dark:text-green-300/80" :style="{ fontSize: (fontSize - 2) + 'px' }">{{
                            selectedUser.phoneticGuide }}</p>
                        </div>
                      </div>
                    </div>

                    <!-- Different Language Response -->
                    <div v-else class="flex flex-col gap-4">
                      <div class="bg-slate-100 dark:bg-[#232f48] p-4 rounded-lg">
                        <div class="flex justify-between items-center mb-2">
                          <p class="text-green-400 text-sm font-semibold">{{ $t('onAir.originalMessageLabel') }}</p>
                          <div class="flex items-center gap-2">
                            <span class="text-text-secondary dark:text-slate-400 text-xs">{{ $t('onAir.translateFrom') }}</span>
                            <select v-model="selectedSourceLanguage" @change="handleLanguageChange"
                              class="bg-white dark:bg-[#111722] border-slate-300 dark:border-slate-700 text-text-main dark:text-white text-xs rounded-md p-1 pr-6 focus:ring-primary focus:border-primary">
                              <option value="ja">{{ $t('onAir.japanese') }}</option>
                              <option value="zh">{{ $t('onAir.chinese') }}</option>
                              <option value="en">{{ $t('onAir.english') }}</option>
                            </select>
                            <span class="text-text-secondary dark:text-slate-400 text-xs">{{ $t('onAir.to') }}</span>
                            <select v-model="selectedTargetLanguage" @change="handleLanguageChange"
                              class="bg-white dark:bg-[#111722] border-slate-300 dark:border-slate-700 text-text-main dark:text-white text-xs rounded-md p-1 pr-6 focus:ring-primary focus:border-primary">
                              <option value="zh">{{ $t('onAir.chinese') }}</option>
                              <option value="en">{{ $t('onAir.english') }}</option>
                              <option value="ja">{{ $t('onAir.japanese') }}</option>
                            </select>
                          </div>
                        </div>
                        <p class="text-text-main dark:text-white" :style="{ fontSize: fontSize + 'px' }">{{ selectedUser.message }}</p>
                        <div class="border-t border-slate-300/50 dark:border-slate-700/50 mt-3 pt-3">
                          <p class="text-text-secondary dark:text-slate-400 text-sm mb-1">{{ $t('onAir.translationLabel') }} ({{
                            getLanguageDisplayName(selectedTargetLanguage) }}):</p>
                          <p class="text-text-main dark:text-white" :style="{ fontSize: fontSize + 'px' }">{{ selectedUser.originalTranslation
                            || $t('onAir.gettingTranslation')
                            }}</p>
                        </div>
                      </div>
                      <div class="bg-slate-100 dark:bg-[#232f48] p-4 rounded-lg">
                        <p class="text-text-secondary dark:text-slate-300 text-sm font-semibold mb-2">{{ $t('onAir.recommendedResponseLabel') }} ({{
                          getLanguageDisplayName(selectedSourceLanguage) }}):</p>
                        <p class="text-text-main dark:text-white font-semibold leading-snug" :style="{ fontSize: fontSize + 'px' }">{{
                          selectedUser.differentLanguageResponse }}</p>
                        <div class="mt-2 mb-3">
                          <p class="text-text-secondary dark:text-slate-400 text-xs font-medium">{{ $t('onAir.phoneticGuideLabel') }}</p>
                          <p class="text-green-600 dark:text-green-300/80" :style="{ fontSize: fontSize + 'px' }">{{
                            selectedUser.phoneticGuide }}</p>
                        </div>
                        <div class="border-t border-slate-300/50 dark:border-slate-700/50 pt-3">
                          <p class="text-text-secondary dark:text-slate-400 text-sm mb-1">{{ $t('onAir.translationLabel') }} ({{
                            getLanguageDisplayName(selectedTargetLanguage) }}):</p>
                          <p class="text-text-main dark:text-white" :style="{ fontSize: fontSize + 'px' }">{{
                            selectedUser.suggestionTranslation ||
                            $t('onAir.gettingTranslation') }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            <!-- 潜在赞助者列表 -->
            <div class="bg-white dark:bg-[#111722] rounded-xl overflow-hidden">
                <h2
                  class="text-slate-900 text-[22px] font-bold leading-tight tracking-[-0.015em] px-4 pb-3 pt-5 border-b border-slate-200 dark:border-slate-800">
                  {{ $t('onAir.topPatrons') }}</h2>
                <div>
                  <!-- 加载状态 -->
                  <div v-if="potentialPatrons.length === 0" class="p-8 text-center">
                    <div
                      class="w-6 h-6 border-2 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-3">
                    </div>
                    <p class="text-slate-400 text-sm">{{ $t('onAir.loadingPotentialPatrons') }}</p>
                  </div>

                  <!-- 赞助者列表 -->
                  <ul v-else class="divide-y divide-slate-200 dark:divide-slate-800">
                    <li v-for="(patron, index) in potentialPatrons.slice(0, 20)" :key="patron.userInfoId || index"
                      class="p-4 flex items-center gap-4 hover:bg-white/5">
                      <span class="text-lg font-bold text-slate-400 w-5 text-center">{{ index + 1 }}</span>
                      <div class="bg-center bg-no-repeat aspect-square bg-cover rounded-full size-10"
                        :data-alt="'User avatar for ' + (patron.userName || $t('onAir.unknownUser'))"
                        :style="{ backgroundImage: 'url(' + getUserAvatarUrl(patron.userInfoId) + ')' }"></div>
                      <div class="flex-1">
                  <p class="text-text-main dark:text-white font-semibold">{{ patron.userName || $t('onAir.unknownUser') }}</p>
                  <p class="text-text-secondary dark:text-slate-400 text-sm truncate">{{ patron.rewardUserType || $t('onAir.potentialPatron') }}</p>
                      </div>
                    <div class="text-right">
                      <p class="text-green-400 font-bold text-lg">{{ formatProbability(patron.rewardProbability) }}</p>
                      <p class="text-text-secondary dark:text-slate-500 text-xs">{{ $t('onAir.rewardProbability') }}</p>
                    </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>

          <!-- 脚本生成器模态框 -->
          <div v-if="showScriptGeneratorModal" class="fixed inset-0 z-50">
            <!-- 背景遮罩 -->
            <div class="absolute inset-0 bg-black/60 backdrop-blur-sm" @click="closeScriptGeneratorModal"></div>

            <!-- 模态框内容 -->
            <div
              class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl max-h-[90vh] overflow-y-auto bg-white dark:bg-[#111722] border border-slate-200 dark:border-slate-800 rounded-lg shadow-2xl">
              <div class="p-6">
                <!-- 头部 -->
                <div class="flex items-center justify-between mb-6">
                  <h2 class="text-text-main dark:text-white text-xl font-bold">{{ $t('onAir.aiScriptGenerator') }}</h2>
                  <button @click="closeScriptGeneratorModal" class="text-text-secondary dark:text-slate-400 hover:text-text-main dark:hover:text-white">
                    <span class="material-symbols-outlined text-2xl">close</span>
                  </button>
                </div>

                <!-- 生成结果显示区域 -->
                <div v-if="generatedScript" class="mb-6">
                  <div class="flex flex-col items-stretch justify-start rounded-lg bg-slate-100 dark:bg-[#1A1A1D] p-4">
                    <div class="flex min-w-72 grow flex-col items-stretch justify-center gap-2">
                      <div class="flex items-center justify-between">
                        <p class="text-lg font-bold leading-tight tracking-[-0.015em] text-text-main dark:text-white">{{ $t('onAir.generatedScript') }}</p>
                        <div class="flex gap-2">
                          <button @click="copyGeneratedScript"
                            class="flex h-8 cursor-pointer items-center justify-center overflow-hidden rounded-md bg-slate-200 dark:bg-[#2C2F33] px-3 text-text-main dark:text-white text-sm font-medium leading-normal hover:bg-slate-300 dark:hover:bg-[#3a3e42]">
                            <span class="material-symbols-outlined text-base mr-1">content_copy</span>
                            <span class="truncate">{{ $t('onAir.copy') }}</span>
                          </button>
                        </div>
                      </div>
                      <p class="text-text-secondary dark:text-slate-300 text-base font-normal leading-normal whitespace-pre-line">{{ generatedScript }}
                      </p>
                    </div>
                  </div>
                </div>

                <!-- 输入区域 -->
                <div class="flex max-w-full flex-col items-end gap-4 px-0 py-3">
                  <div class="relative w-full">
                    <textarea v-model="scriptPrompt"
                      class="form-input flex w-full min-w-0 flex-1 resize-none overflow-auto rounded-lg border-none bg-slate-100 dark:bg-[#1A1A1D] p-4 pr-12 text-base font-normal leading-normal text-text-main dark:text-white placeholder:text-text-secondary dark:placeholder:text-slate-400 focus:outline-0 focus:ring-2 focus:ring-primary min-h-36"
                      :placeholder="$t('onAir.describeWhatYouWant')" maxlength="500" @keydown="handleKeyDown"></textarea>
                    <button @click="startVoiceRecording"
                      :class="isRecording ? 'bg-red-500' : 'bg-slate-200 dark:bg-[#2C2F33] hover:bg-slate-300 dark:hover:bg-[#3a3e42]'"
                      class="absolute bottom-3 right-3 flex h-8 w-8 cursor-pointer items-center justify-center rounded-full text-text-main dark:text-white">
                      <span v-if="!isRecording" class="material-symbols-outlined text-xl">mic</span>
                      <span v-else class="flex h-4 w-4">
                        <span
                          class="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                        <span class="relative inline-flex rounded-full h-4 w-4 bg-red-500"></span>
                      </span>
                    </button>
                  </div>
                  <div class="flex w-full items-center justify-between">
                    <button @click="closeScriptGeneratorModal"
                      class="flex items-center gap-2 px-4 py-2 text-text-secondary dark:text-slate-400 hover:text-text-main dark:hover:text-white hover:bg-slate-100 dark:hover:bg-white/5 rounded-lg transition-colors">
                      <span class="material-symbols-outlined text-base">arrow_back</span>
                      <span class="text-sm font-medium">{{ $t('onAir.cancel') }}</span>
                    </button>
                    <div class="flex items-center gap-3">
                      <p class="text-text-secondary dark:text-slate-400 text-sm font-normal leading-normal">{{ scriptPrompt.length }}/500</p>
                      <button @click="generateScriptInModal" :disabled="!canGenerateInModal"
                        class="flex min-w-[140px] max-w-[480px] cursor-pointer items-center justify-center overflow-hidden rounded-lg h-10 px-4 text-black text-sm font-bold leading-normal tracking-[0.015em]"
                        :class="canGenerateInModal ? 'bg-primary hover:bg-[#00A065]' : 'bg-slate-300 dark:bg-slate-600 cursor-not-allowed'">
                        <span class="truncate">{{ isGenerating ? $t('onAir.generating') : $t('onAir.generateScript') }}</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

      <!-- 历史信息浮层 -->
      <div v-if="showHistoryModal" class="fixed inset-0 z-50">
      <!-- 背景遮罩 - 动态模糊效果 -->
      <div class="absolute inset-0 bg-black/60 transition-all duration-300 ease-out"
        :class="modalAnimation ? 'backdrop-blur-md' : 'backdrop-blur-none'" @click="closeHistoryModal"></div>

      <!-- 浮层内容 - 移动端全屏，桌面端侧边栏 -->
      <div
        class="absolute top-0 left-0 h-full bg-white dark:bg-[#0A0F19] z-20 shadow-2xl flex flex-col transition-transform duration-300 ease-out lg:w-[900px] w-full"
        :class="modalAnimation ? 'translate-x-0' : '-translate-x-full'">
        <div class="flex items-center justify-between p-4 border-b border-slate-200 dark:border-slate-800 shrink-0">
          <div class="flex items-center gap-4">
            <div class="bg-center bg-no-repeat aspect-square bg-cover rounded-full size-10"
              :data-alt="'User avatar for ' + selectedUser.name"
              :style="{ backgroundImage: 'url(' + selectedUser.avatar + ')' }"></div>
            <div>
              <h3 class="text-lg font-bold text-text-main dark:text-white">{{ selectedUser.name || $t('onAir.waitingForInteraction') }}</h3>
              <p class="text-sm text-text-secondary dark:text-slate-400">{{ $t('onAir.fullInteractionHistory') }}</p>
            </div>
          </div>
          <button @click="closeHistoryModal" class="text-text-secondary dark:text-slate-400 hover:text-text-main dark:hover:text-white transition-colors duration-200">
            <span class="material-symbols-outlined">close</span>
          </button>
        </div>
        <div class="flex-1 overflow-y-auto custom-scrollbar" ref="userHistoryScrollContainer"
          @scroll="handleUserHistoryScroll">
          <div class="p-6 grid grid-cols-1 lg:grid-cols-2 gap-6">
            <!-- 第一列：Current Live Stream Info 和 Interaction History -->
            <div class="space-y-6">
              <!-- Current Live Stream Info 模块 -->
              <div class="bg-surface-light dark:bg-[#111722] rounded-xl p-6">
                <h4 class="text-white font-semibold mb-6 text-lg">{{ $t('onAir.currentLiveStreamInfo') }}</h4>
                <div class="space-y-4">
                  <!-- 转换概率 -->
                  <div class="flex justify-between items-center bg-slate-100 dark:bg-[#232f48] p-4 rounded-lg">
                    <div class="text-center flex-1">
                      <p class="text-sm text-text-secondary dark:text-slate-400">{{ $t('onAir.conversionProbability') }}</p>
                      <p class="text-2xl font-bold text-green-400" id="conversion-prob">{{
                        currentStats.rewardProbability
                        || 'N/A' }}</p>
                      <p class="text-sm text-text-secondary dark:text-slate-500">{{ $t('onAir.ticketPurchaseIntent') }}</p>
                    </div>
                  </div>
                  <!-- 消息数、礼物数、进入时间 -->
                  <div class="grid grid-cols-3 gap-4 text-center">
                    <div class="bg-slate-100 dark:bg-[#232f48] p-4 rounded-lg">
                      <p class="text-3xl font-bold text-text-main dark:text-white">{{ currentStats.messageCount || 0 }}</p>
                      <p class="text-sm text-text-secondary dark:text-slate-400">{{ $t('onAir.messages') }}</p>
                    </div>
                    <div class="bg-slate-100 dark:bg-[#232f48] p-4 rounded-lg">
                      <p class="text-3xl font-bold text-text-main dark:text-white">{{ currentStats.giftCount || 0 }}</p>
                      <p class="text-sm text-text-secondary dark:text-slate-400">{{ $t('onAir.gifts') }}</p>
                    </div>
                    <div class="bg-slate-100 dark:bg-[#232f48] p-4 rounded-lg">
                      <p class="text-3xl font-bold text-text-main dark:text-white">{{ currentStats.enterTime ?
                        formatLastInteractionTime(currentStats.enterTime) : 'N/A' }}</p>
                      <p class="text-sm text-text-secondary dark:text-slate-500">{{ $t('onAir.entryTime') }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <!-- 用户历史访问日历 -->
              <div class="bg-surface-light dark:bg-[#111722] rounded-xl p-4">
                <h4 class="text-white font-semibold mb-4">{{ $t('onAir.attendanceHistory') }}</h4>

                <!-- 日历头部：月份导航 -->
                <div class="flex justify-between items-center mb-3">
                  <button @click="prevMonth"
                    class="flex items-center justify-center size-7 rounded-md bg-slate-100 dark:bg-[#232f48] text-text-secondary dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-700">
                    <span class="material-symbols-outlined text-base">chevron_left</span>
                  </button>
                  <span class="text-text-main dark:text-white text-sm font-medium">{{ calendarTitle }}</span>
                  <button @click="nextMonth"
                    class="flex items-center justify-center size-7 rounded-md bg-slate-100 dark:bg-[#232f48] text-text-secondary dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-700">
                    <span class="material-symbols-outlined text-base">chevron_right</span>
                  </button>
                </div>

                <!-- 日历星期标题 -->
                <div class="grid grid-cols-7 gap-y-1 text-center text-[10px] mb-1">
                  <div class="text-text-secondary dark:text-slate-500 font-medium">S</div>
                  <div class="text-text-secondary dark:text-slate-500 font-medium">M</div>
                  <div class="text-text-secondary dark:text-slate-500 font-medium">T</div>
                  <div class="text-text-secondary dark:text-slate-500 font-medium">W</div>
                  <div class="text-text-secondary dark:text-slate-500 font-medium">T</div>
                  <div class="text-text-secondary dark:text-slate-500 font-medium">F</div>
                  <div class="text-text-secondary dark:text-slate-500 font-medium">S</div>
                </div>

                <!-- 日历日期 -->
                <div class="grid grid-cols-7 gap-y-1 text-center text-[10px]">
                  <div v-for="(day, index) in calendarDays" :key="index" :class="[
                    'relative py-1',
                    day.isCurrentMonth ? 'text-text-main dark:text-white' : 'text-text-secondary dark:text-slate-600',
                    day.isToday ? 'font-bold' : ''
                  ]">
                    <template v-if="day.date">
                      {{ day.date.getDate() }}
                      <!-- 标记用户访问过的日期 -->
                      <div v-if="day.hasAttendance" :class="[
                        'absolute inset-px rounded-full',
                        day.attendanceCount > 1 ? 'border-2 border-green-500' : 'border border-green-500'
                      ]"></div>
                    </template>
                  </div>
                </div>

                <!-- 加载状态 -->
                <div v-if="attendanceLoading" class="text-center py-4">
                  <div
                    class="w-4 h-4 border-2 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-2">
                  </div>
                  <p class="text-text-secondary dark:text-slate-400 text-xs">{{ $t('onAir.loadingAttendanceHistory') }}</p>
                </div>

                <!-- 无数据状态 -->
                <div v-else-if="attendanceData.length === 0" class="text-center py-4">
                  <span class="material-symbols-outlined text-text-secondary dark:text-slate-600 text-4xl mb-3">calendar_today</span>
                  <p class="text-text-secondary dark:text-slate-400 text-sm">{{ $t('onAir.noAttendanceHistory') }}</p>
                </div>
              </div>
            </div>
          </div>
          <div>
            <!-- 用户历史互动记录 -->
            <div class="bg-surface-light dark:bg-[#111722] rounded-xl p-4">
              <h4 class="text-white font-semibold mb-4">{{ $t('onAir.interactionHistory') }}</h4>

              <!-- 加载状态 -->
              <!-- 加载状态 -->
              <div v-if="userHistoryLoading" class="text-center py-8">
                <div
                  class="w-6 h-6 border-2 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-3">
                </div>
                <p class="text-text-secondary dark:text-slate-400 text-sm">{{ $t('onAir.loadingInteractionHistory') }}</p>
              </div>

              <!-- 无数据状态 -->
              <div v-else-if="userHistoryData.length === 0" class="text-center py-8">
                <span class="material-symbols-outlined text-text-secondary dark:text-slate-600 text-4xl mb-3">history</span>
                <p class="text-text-secondary dark:text-slate-400 text-sm">{{ $t('onAir.noInteractionHistory') }}</p>
              </div>

              <!-- 历史记录列表 -->
              <div v-else class="space-y-3 pr-2">
                <div v-for="history in userHistoryData" :key="history.id"
                  class="bg-slate-100 dark:bg-[#232f48] rounded-lg p-3 border border-slate-300 dark:border-slate-700 hover:border-slate-400 dark:hover:border-slate-600 transition-colors">
                  <!-- 聊天消息类型 -->
                  <div v-if="history.type === 'chat'" class="flex items-start gap-3">
                    <div class="bg-primary/20 text-primary p-2 rounded-full">
                      <span class="material-symbols-outlined text-sm">chat</span>
                    </div>
                    <div class="flex-1">
                      <div class="flex items-center gap-2 mb-1">
                        <p class="text-text-main dark:text-white text-sm font-medium">{{ $t('onAir.chat') }}</p>
                        <div v-if="history.userLevel"
                          class="bg-yellow-500/20 text-yellow-400 px-2 py-0.5 rounded-full text-xs font-medium">
                          Lv.{{ history.userLevel }}
                        </div>
                      </div>
                      <p class="text-text-secondary dark:text-slate-300 text-sm">{{ history.content }}</p>
                      <!-- 显示话术建议 -->
                      <div v-if="history.scripts && history.scripts.length > 0" class="mt-2">
                        <div v-for="(script, scriptIndex) in history.scripts" :key="scriptIndex"
                          class="bg-green-500/10 border border-green-500/30 rounded-lg p-3 mb-2">
                          <p class="text-green-300 text-xs font-medium mb-1">{{ $t('onAir.scriptSuggestion') }}</p>
                          <p class="text-white text-sm">{{ script.scriptText }}</p>
                        </div>
                      </div>
                      <p class="text-text-secondary dark:text-slate-500 text-xs mt-1">{{ formatTimeSince(history.timestamp) }}</p>
                    </div>
                  </div>

                  <!-- 礼物类型 -->
                  <div v-else-if="history.type === 'gift'" class="flex items-start gap-3">
                    <div class="bg-yellow-500/20 text-yellow-400 p-2 rounded-full">
                      <span class="material-symbols-outlined text-sm">redeem</span>
                    </div>
                    <div class="flex-1">
                      <p class="text-text-main dark:text-white text-sm font-medium mb-1">{{ $t('onAir.gift') }}</p>
                      <div class="flex items-center gap-2 text-text-secondary dark:text-slate-300 text-sm">
                        <span>{{ $t('onAir.sent') }} <strong>{{ history.giftName }}</strong></span>
                        <span>x{{ history.giftCount }}</span>
                        <span class="font-semibold text-yellow-400">🪙{{ history.giftValue }}</span>
                      </div>
                      <!-- 显示话术建议 -->
                      <div v-if="history.scripts && history.scripts.length > 0" class="mt-2">
                        <div v-for="(script, scriptIndex) in history.scripts" :key="scriptIndex"
                          class="bg-green-500/10 border border-green-500/30 rounded-lg p-3 mb-2">
                          <p class="text-green-300 text-xs font-medium mb-1">{{ $t('onAir.scriptSuggestion') }}</p>
                          <p class="text-white text-sm">{{ script.scriptText }}</p>
                        </div>
                      </div>
                      <p class="text-text-secondary dark:text-slate-500 text-xs mt-1">{{ formatTimeSince(history.timestamp) }}</p>
                    </div>
                  </div>

                  <!-- 进入直播间类型 -->
                  <div v-else-if="history.type === 'enter'" class="flex items-start gap-3">
                    <div class="bg-green-500/20 text-green-400 p-2 rounded-full">
                      <span class="material-symbols-outlined text-sm">login</span>
                    </div>
                    <div class="flex-1">
                      <p class="text-text-main dark:text-white text-sm font-medium mb-1">{{ $t('onAir.enteredRoom') }}</p>
                      <!-- 显示话术建议 -->
                      <div v-if="history.scripts && history.scripts.length > 0" class="mt-2">
                        <div v-for="(script, scriptIndex) in history.scripts" :key="scriptIndex"
                          class="bg-green-500/10 border border-green-500/30 rounded-lg p-3 mb-2">
                          <p class="text-green-300 text-xs font-medium mb-1">{{ $t('onAir.scriptSuggestion') }}</p>
                          <p class="text-white text-sm">{{ script.scriptText }}</p>
                        </div>
                      </div>
                      <p class="text-text-secondary dark:text-slate-500 text-xs mt-1">{{ formatTimeSince(history.timestamp) }}</p>
                    </div>
                  </div>

                  <!-- 关注类型 -->
                  <div v-else-if="history.type === 'follow'" class="flex items-start gap-3">
                    <div class="bg-blue-500/20 text-blue-400 p-2 rounded-full">
                      <span class="material-symbols-outlined text-sm">person_add</span>
                    </div>
                    <div class="flex-1">
                      <p class="text-text-main dark:text-white text-sm font-medium mb-1">{{ $t('onAir.followed') }}</p>
                      <p class="text-text-secondary dark:text-slate-300 text-sm">{{ $t('onAir.startedFollowing') }}</p>
                      <!-- 显示话术建议 -->
                      <div v-if="history.scripts && history.scripts.length > 0" class="mt-2">
                        <div v-for="(script, scriptIndex) in history.scripts" :key="scriptIndex"
                          class="bg-green-500/10 border border-green-500/30 rounded-lg p-3 mb-2">
                          <p class="text-green-300 text-xs font-medium mb-1">{{ $t('onAir.scriptSuggestion') }}</p>
                          <p class="text-white text-sm">{{ script.scriptText }}</p>
                        </div>
                      </div>
                      <p class="text-text-secondary dark:text-slate-500 text-xs mt-1">{{ formatTimeSince(history.timestamp) }}</p>
                    </div>
                  </div>

                  <!-- 点赞类型 -->
                  <div v-else-if="history.type === 'like'" class="flex items-start gap-3">
                    <div class="bg-red-500/20 text-red-400 p-2 rounded-full">
                      <span class="material-symbols-outlined text-sm">favorite</span>
                    </div>
                    <div class="flex-1">
                      <p class="text-text-main dark:text-white text-sm font-medium mb-1">{{ $t('onAir.liked') }}</p>
                      <p class="text-text-secondary dark:text-slate-300 text-sm">{{ $t('onAir.sentALike') }}</p>
                      <!-- 显示话术建议 -->
                      <div v-if="history.scripts && history.scripts.length > 0" class="mt-2">
                        <div v-for="(script, scriptIndex) in history.scripts" :key="scriptIndex"
                          class="bg-green-500/10 border border-green-500/30 rounded-lg p-3 mb-2">
                          <p class="text-green-300 text-xs font-medium mb-1">{{ $t('onAir.scriptSuggestion') }}</p>
                          <p class="text-white text-sm">{{ script.scriptText }}</p>
                        </div>
                      </div>
                      <p class="text-text-secondary dark:text-slate-500 text-xs mt-1">{{ formatTimeSince(history.timestamp) }}</p>
                    </div>
                  </div>

                  <!-- 分享类型 -->
                  <div v-else-if="history.type === 'share'" class="flex items-start gap-3">
                    <div class="bg-purple-500/20 text-purple-400 p-2 rounded-full">
                      <span class="material-symbols-outlined text-sm">share</span>
                    </div>
                    <div class="flex-1">
                      <p class="text-text-main dark:text-white text-sm font-medium mb-1">{{ $t('onAir.shared') }}</p>
                      <p class="text-text-secondary dark:text-slate-300 text-sm">{{ $t('onAir.sharedTheLiveStream') }}</p>
                      <!-- 显示话术建议 -->
                      <div v-if="history.scripts && history.scripts.length > 0" class="mt-2">
                        <div v-for="(script, scriptIndex) in history.scripts" :key="scriptIndex"
                          class="bg-green-500/10 border border-green-500/30 rounded-lg p-3 mb-2">
                          <p class="text-green-300 text-xs font-medium mb-1">{{ $t('onAir.scriptSuggestion') }}</p>
                          <p class="text-white text-sm">{{ script.scriptText }}</p>
                        </div>
                      </div>
                      <p class="text-text-secondary dark:text-slate-500 text-xs mt-1">{{ formatTimeSince(history.timestamp) }}</p>
                    </div>
                  </div>

                  <!-- 其他类型 -->
                  <div v-else class="flex items-start gap-3">
                    <div class="bg-slate-500/20 text-slate-400 p-2 rounded-full">
                      <span class="material-symbols-outlined text-sm">help</span>
                    </div>
                    <div class="flex-1">
                      <p class="text-text-main dark:text-white text-sm font-medium mb-1">{{ history.type || $t('onAir.interaction') }}</p>
                      <p class="text-text-secondary dark:text-slate-300 text-sm">{{ history.content || $t('onAir.unknownInteraction') }}</p>
                      <!-- 显示话术建议 -->
                      <div v-if="history.scripts && history.scripts.length > 0" class="mt-2">
                        <div v-for="(script, scriptIndex) in history.scripts" :key="scriptIndex"
                          class="bg-green-500/10 border border-green-500/30 rounded-lg p-3 mb-2">
                          <p class="text-green-300 text-xs font-medium mb-1">{{ $t('onAir.scriptSuggestion') }}</p>
                          <p class="text-white text-sm">{{ script.scriptText }}</p>
                        </div>
                      </div>
                      <p class="text-text-secondary dark:text-slate-500 text-xs mt-1">{{ formatTimeSince(history.timestamp) }}</p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 滚动加载提示 -->
              <div v-if="userHistoryLoadingMore" class="text-center py-4">
                <div
                  class="w-4 h-4 border-2 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-2">
                </div>
                <p class="text-slate-400 text-xs">{{ $t('onAir.loadingMoreHistory') }}</p>
              </div>

              <!-- 没有更多数据提示 -->
              <div v-if="!hasMoreUserHistory && userHistoryData.length > 0" class="text-center py-4">
                <p class="text-text-secondary dark:text-slate-500 text-xs">{{ $t('onAir.noMoreHistory') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getApiUrl } from '@/config/apiConfig';

export default {
  name: 'Dashboard',
  inject: ['isLive', 'toggleLiveStatus', 'setLiveStatus', 'liveStreamData', 'updateLiveSessionData', 'sidebarExpanded'],
  computed: {
    hasRoomConnected() {
      return this.roomConnectedState;
    },
    // 获取实际的 isLive 状态
    actualIsLive() {
      return this.isLive();
    },
    // 合并历史评论和实时评论，并根据当前tab筛选
    filteredActivities() {
      // 添加调用计数器来调试重复渲染问题
      if (!window.filteredActivitiesCallCount) {
        window.filteredActivitiesCallCount = 0;
      }
      window.filteredActivitiesCallCount++;
      console.log(`=== 第${window.filteredActivitiesCallCount}次计算 filteredActivities ===`);
      console.log('实时评论数量:', this.activities.length);
      console.log('历史评论数量:', this.historicalComments.length);
      
      // 辅助函数：获取原始ID（移除_historical后缀）
      const getOriginalId = (id) => {
        if (typeof id === 'string' && id.includes('_historical')) {
          return id.replace('_historical', '');
        }
        return id;
      };
      
      // 检查数据源是否有重复
      const activityIds = new Set();
      const historicalIds = new Set();
      
      this.activities.forEach(activity => {
        const originalId = getOriginalId(activity.id);
        if (activityIds.has(originalId)) {
          console.log('实时评论中发现重复ID:', activity.id, '原始ID:', originalId, activity.name, activity.content);
        }
        activityIds.add(originalId);
      });
      
      this.historicalComments.forEach(activity => {
        const originalId = getOriginalId(activity.id);
        if (historicalIds.has(originalId)) {
          console.log('历史评论中发现重复ID:', activity.id, '原始ID:', originalId, activity.name, activity.content);
        }
        historicalIds.add(originalId);
      });

      // 检查实时评论和历史评论之间的重复（基于原始ID）
      const duplicateIds = new Set();
      this.activities.forEach(activity => {
        const originalId = getOriginalId(activity.id);
        if (historicalIds.has(originalId)) {
          console.log('发现实时评论和历史评论重复ID:', activity.id, '原始ID:', originalId, activity.name, activity.content);
          duplicateIds.add(originalId);
        }
      });

      // 合并所有评论数据：实时评论在前，历史评论在后
      // 但排除在历史评论中已经存在的实时评论（基于原始ID）
      const allActivities = [
        ...this.activities, // 实时评论
        ...this.historicalComments.filter(activity => {
          const originalId = getOriginalId(activity.id);
          return !activityIds.has(originalId); // 历史评论中不包含实时评论的部分
        })
      ];

      // 特别处理Gifts标签：确保有足够的礼物历史数据
      if (this.activeTab === 'gifts' && allActivities.filter(a => a.type === 'gift').length <= 3) {
        console.log('Gifts标签显示数据不足，触发历史数据加载');
        // 异步加载更多历史数据，但不阻塞当前渲染
        this.$nextTick(() => {
          if (!this.historicalLoading && this.hasMoreHistorical) {
            this.loadHistoricalComments(false);
          }
        });
      }

      console.log('合并后总数:', allActivities.length);
      console.log('发现重复消息数量:', duplicateIds.size);

      // 根据当前tab筛选活动数据
      let filtered;
      switch (this.activeTab) {
        case 'messages':
          filtered = allActivities.filter(activity => activity.type === 'message');
          break;
        case 'gifts':
          filtered = allActivities.filter(activity => activity.type === 'gift');
          break;
        case 'interactions':
          filtered = allActivities.filter(activity => ['enter', 'follow', 'like', 'share', 'social'].includes(activity.type));
          break;
        case 'all':
        default:
          filtered = allActivities;
          break;
      }

      console.log('筛选后数量:', filtered.length);

      // 去重：基于原始ID去重，避免重复显示
      const seenIds = new Set();
      const deduplicated = filtered.filter(activity => {
        const originalId = getOriginalId(activity.id);
        if (seenIds.has(originalId)) {
          console.log('发现重复消息，跳过:', activity.id, '原始ID:', originalId, activity.name, activity.content);
          return false;
        }
        seenIds.add(originalId);
        return true;
      });

      console.log('去重后数量:', deduplicated.length);
      console.log('=== 结束计算 filteredActivities ===');
      
      return deduplicated;
    },

    // 获取历史评论的分割器位置
    historicalSeparatorIndex() {
      const filtered = this.filteredActivities;
      // 找到第一个历史评论的位置
      for (let i = 0; i < filtered.length; i++) {
        if (filtered[i].isHistorical) {
          return i;
        }
      }
      return -1; // 如果没有历史评论，返回-1
    },
    // 获取各tab的数量 - 使用WebSocket返回的statistics数据
    tabCounts() {
      return {
        all: this.statistics.totalMessages || 0,
        messages: this.statistics.chatCount || 0,
        gifts: this.statistics.giftCount || 0,
        interactions: (this.statistics.enterCount || 0) + (this.statistics.socialCount || 0)
      };
    },
    // 是否为开发模式
    isDevelopment() {
      return process.env.NODE_ENV === 'development';
    },
    // ScriptGenerator modal计算属性
    canGenerateInModal() {
      return this.scriptPrompt.trim().length > 0 && !this.isGenerating && !this.isRecording;
    }
  },
  watch: {
    actualIsLive(newVal, oldVal) {
      // 当直播状态改变时，重置右栏内容
      if (newVal !== oldVal) {
        this.resetRightColumn();
      }
    }
  },
    data() {
      // 从本地存储加载语言选择状态，如果没有则使用默认值
      const savedSourceLanguage = localStorage.getItem('dashboard_source_language') || 'ja';
      const savedTargetLanguage = localStorage.getItem('dashboard_target_language') || 'zh';
      
      return {
        scriptPrompt: '',
        isRoomConnected: false,
        roomConnectedState: false, // 直播间连接状态
        languageMode: 'same', // 'same' or 'different'
        isDragging: false,
        startX: 0,
        scrollLeft: 0,
        activeTab: 'all', // 'all', 'messages', 'gifts', 'interactions'
        selectedUserId: 'creativecoder', // 当前选中的用户ID
        showHistoryModal: false, // 控制历史信息浮层显示
        modalAnimation: false, // 控制浮层动画状态
        // 字体大小控制
        fontSize: 16, // 默认字体大小
        minFontSize: 12, // 最小字体大小
        maxFontSize: 24, // 最大字体大小
        selectedUser: {
          name: 'CreativeCoder',
          avatar: '',
          message: 'Do the VIP tickets come with backstage access?',
          interactionProbability: '85%',
          previousAppearances: '4',
          tag: 'TICKET PURCHASE',
          sameLanguageResponse: '"Hey CreativeCoder, great to see you again! Absolutely, the VIP tickets get you backstage access. I can drop the link in the chat for you right now."',
          differentLanguageResponse: '「はい、クリエイティブコーダーさん！VIPチケットにはバックステージパスが含まれていますよ。」',
          phoneticGuide: '"Hai, Kurieitibu Kōdā-san! VIP chiketto ni wa bakku sutēji pasu ga fukuma rete imasu yo."',
          translation: '"Yes, CreativeCoder! The VIP tickets do include a backstage pass."'
        },
        // WebSocket相关数据
        websocket: null, // WebSocket连接实例
        websocketConnected: false, // WebSocket连接状态
        currentRoomId: null, // 当前订阅的直播间ID
        currentSessionId: null, // 当前直播会话ID
        // 其他数据字段
        activities: [], // 实时活动数据
        historicalComments: [], // 历史评论数据
        historicalLoading: false, // 历史评论加载状态
        historicalLoadingMore: false, // 加载更多历史评论状态
        historicalPageIndex: 1, // 历史评论页码
        historicalPageSize: 20, // 历史评论每页大小
        hasMoreHistorical: true, // 是否有更多历史评论
        statistics: { // 统计信息
          totalMessages: 0,
          chatCount: 0,
          enterCount: 0,
          giftCount: 0,
          socialCount: 0
        },
        lastCommentTime: null, // 最后评论时间
        // 脚本生成器相关
        showScriptGeneratorModal: false, // 脚本生成器模态框显示状态
        generatedScript: '', // 生成的脚本
        isRecording: false, // 录音状态
        recognition: null, // 语音识别对象
        isGenerating: false, // 脚本生成状态
        scriptPlaceholder: 'Describe what you want to say...', // 脚本输入框占位符
        // 翻译相关
        selectedSourceLanguage: savedSourceLanguage, // 源语言
        selectedTargetLanguage: savedTargetLanguage, // 目标语言
        originalTranslation: '', // 原文翻译
        suggestionTranslation: '', // 建议翻译
        isTranslating: false, // 翻译状态
        // 潜在赞助者相关
        potentialPatrons: [], // 潜在赞助者列表
        potentialPatronsTimer: null, // 潜在赞助者定时器
        // 用户历史记录相关
        userHistoryData: [], // 用户历史记录数据
        userHistoryLoading: false, // 用户历史记录加载状态
        userHistoryLoadingMore: false, // 加载更多用户历史记录状态
        userHistoryPageIndex: 1, // 用户历史记录页码
        userHistoryPageSize: 20, // 用户历史记录每页大小
        hasMoreUserHistory: true, // 是否有更多用户历史记录
        // 话术建议相关
        suggestionQueue: [], // 话术建议队列
        isShowingSuggestion: false, // 是否正在显示话术建议
        currentSuggestionTimer: null, // 当前话术建议定时器
        referencedComments: [], // 引用评论
        // 当前统计信息
        currentStats: {
          rewardProbability: 'N/A',
          messageCount: 0,
          giftCount: 0,
          enterTime: null
        },
        // 定时器相关
        periodicCheckInterval: null, // 定期检查定时器
        timeUpdateInterval: null, // 时间更新定时器
        // 话术建议WebSocket相关
        scriptWebSocket: null, // 话术建议WebSocket连接实例
        scriptWebSocketConnected: false, // 话术建议WebSocket连接状态
        // 日历相关数据
        attendanceData: [], // 用户历史访问数据
        attendanceLoading: false, // 用户历史访问数据加载状态
        calendarDays: [], // 日历日期数组
        currentMonth: new Date(), // 当前显示的月份
        calendarTitle: '', // 日历标题
        // 移动端浮层相关
        showChatOverlay: true, // 聊天浮层显示状态（默认打开）
        showPatronsOverlay: false, // 赞助者列表浮层显示状态
        userScrolled: false // 用户是否手动滚动过聊天容器
      };
    },
    methods: {
    // 切换聊天浮层显示状态
    toggleChatOverlay() {
      this.showChatOverlay = !this.showChatOverlay;
      // 如果打开聊天浮层，关闭赞助者浮层
      if (this.showChatOverlay) {
        this.showPatronsOverlay = false;
      }
    },
    // 切换赞助者列表浮层显示状态
    togglePatronsOverlay() {
      this.showPatronsOverlay = !this.showPatronsOverlay;
      // 如果打开赞助者浮层，关闭聊天浮层
      if (this.showPatronsOverlay) {
        this.showChatOverlay = false;
      }
    },
    // 初始化聊天自动滚动
    startChatAutoScroll() {
      console.log('初始化聊天自动滚动');
      // 添加滚动事件监听器，用于检测用户手动滚动
      this.addChatScrollListener();
      // 监听活动数据变化，自动滚动到顶部（最新消息）
      this.$watch('filteredActivities', this.scrollChatToTop, { deep: true });
    },
    // 添加聊天容器滚动事件监听器
    addChatScrollListener() {
      this.$nextTick(() => {
        const chatContainer = this.$refs.chatScrollContainer;
        if (chatContainer) {
          // 监听滚动事件，检测用户手动滚动
          chatContainer.addEventListener('scroll', this.handleChatScroll);
          console.log('聊天滚动事件监听器已添加');
        }
      });
    },
    // 处理聊天容器滚动事件
    handleChatScroll() {
      const chatContainer = this.$refs.chatScrollContainer;
      if (chatContainer) {
        const scrollTop = chatContainer.scrollTop;
        const scrollHeight = chatContainer.scrollHeight;
        const clientHeight = chatContainer.clientHeight;

        // 如果用户滚动到距离顶部50px以内，认为是回到了顶部，重置滚动状态
        if (scrollTop <= 50) {
          this.userScrolled = false;
          console.log('用户滚动到顶部附近，重置滚动状态');
        }
        // 如果用户向下滚动超过50px，标记为已手动滚动
        else if (scrollTop > 50) {
          this.userScrolled = true;
          console.log('用户手动滚动聊天容器');
        }
      }
    },
    // 自动滚动聊天到最新消息（滚动到顶部，因为最新消息在数组开头）
    scrollChatToTop() {
      this.$nextTick(() => {
        const chatContainer = this.$refs.chatScrollContainer;
        if (chatContainer && this.showChatOverlay) {
          const scrollTop = chatContainer.scrollTop;

          // 如果用户已经向下滚动超过50px，或者手动标记为已滚动，则不自动滚动
          if (scrollTop > 50 || this.userScrolled) {
            console.log('用户已手动滚动，跳过自动滚动', { scrollTop, userScrolled: this.userScrolled });
            return;
          }

          // 只有当用户在顶部附近时，才自动滚动到最新消息
          console.log('用户在顶部附近，自动滚动到最新消息');
          // 使用 requestAnimationFrame 确保 DOM 更新完成后再滚动
          requestAnimationFrame(() => {
            chatContainer.scrollTop = 0;
          });
        }
      });
    },
    goToOnboarding() {
      this.$router.push('/onboarding');
    },
    goToScriptGenerator() {
      this.showScriptGeneratorModal = true;
    },
    generateScript() {
      if (this.scriptPrompt.trim()) {
        alert(`${this.$t('onAir.generatingScriptFor')} ${this.scriptPrompt}`);
      }
    },
    // ScriptGenerator Modal相关方法
    closeScriptGeneratorModal() {
      this.showScriptGeneratorModal = false;
      this.generatedScript = '';
      this.scriptPrompt = '';
      this.isRecording = false;
      if (this.recognition) {
        this.recognition.stop();
      }
      this.isGenerating = false;
    },
    copyGeneratedScript() {
      if (!this.generatedScript) return;

      navigator.clipboard.writeText(this.generatedScript).then(() => {
        // 简单的成功反馈
        alert(this.$t('onAir.scriptCopied'));
      }).catch(() => {
        // Fallback for older browsers
        const textArea = document.createElement('textarea');
        textArea.value = this.generatedScript;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
          document.execCommand('copy');
          alert(this.$t('onAir.scriptCopied'));
        } catch (err) {
          alert(this.$t('onAir.failedToCopyScript'));
        }
        document.body.removeChild(textArea);
      });
    },
    startVoiceRecording() {
      if (this.isRecording) {
        this.stopVoiceRecording();
        return;
      }

      // 检查浏览器支持
      if (!('webkitSpeechRecognition' in window) && !('SpeechRecognition' in window)) {
        alert(this.$t('onAir.voiceInputNotSupported'));
        return;
      }

      this.isRecording = true;

      const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
      this.recognition = new SpeechRecognition();

      this.recognition.continuous = false;
      this.recognition.interimResults = false;
      this.recognition.lang = 'en-US';

      this.recognition.onresult = (event) => {
        const transcript = event.results[0][0].transcript;
        this.scriptPrompt += (this.scriptPrompt ? ' ' : '') + transcript;
      };

      this.recognition.onerror = (event) => {
        console.error('Speech recognition error:', event.error);
        alert(this.$t('onAir.voiceInputFailed'));
        this.isRecording = false;
      };

      this.recognition.onend = () => {
        this.isRecording = false;
      };

      try {
        this.recognition.start();
      } catch (error) {
        console.error('Failed to start speech recognition:', error);
        this.isRecording = false;
      }
    },
    stopVoiceRecording() {
      if (this.recognition) {
        this.recognition.stop();
      }
      this.isRecording = false;
    },
    handleKeyDown(event) {
      if (event.key === 'Enter' && (event.ctrlKey || event.metaKey)) {
        event.preventDefault();
        this.generateScriptInModal();
      }
    },
    async generateScriptInModal() {
      if (!this.canGenerateInModal) return;

      console.log('开始生成脚本，当前scriptPrompt值:', this.scriptPrompt);

      // 先获取用户输入的值，因为closeScriptGeneratorModal会清空scriptPrompt
      const userPrompt = this.scriptPrompt;

      console.log('保存的用户输入值:', userPrompt);

      // 先关闭模态框
      this.closeScriptGeneratorModal();
      this.isGenerating = true;

      try {
        // 立即显示用户填写的内容到Priority Target区域，即使API可能失败
        this.displayUserPromptInPriorityTarget(userPrompt);

        // 调用SCRIPT_GENERATION_GENERATE_BY_DESCRIPTION接口（使用保存的用户输入）
        const response = await this.callScriptGenerationAPI(userPrompt);

        if (response.success && response.data) {
          // 处理新的API响应格式
          const scriptText = response.data.scripts && response.data.scripts.length > 0
            ? response.data.scripts[0]
            : '生成脚本失败，无法获取脚本内容';

          console.log('脚本生成成功:', scriptText);

          // 将生成的脚本显示在Priority Target区域，使用主播的信息
          this.displayGeneratedScriptInPriorityTarget(scriptText, userPrompt);

          // 保存数据到localStorage以供其他组件使用（可选）
          localStorage.setItem('generatedScriptData', JSON.stringify({
            prompt: userPrompt,
            script: scriptText
          }));
        } else {
          console.error('脚本生成失败，但用户输入已显示');
        }
      } catch (error) {
        console.error('Error generating script:', error);
        // 即使API调用失败，用户输入的内容也已经显示在Priority Target区域
      } finally {
        this.isGenerating = false;
      }
    },
    setLanguageMode(mode) {
      this.languageMode = mode;
      
      // 当切换到Different Language模式时，自动触发翻译
      if (mode === 'different') {
        console.log('切换到Different Language模式，自动触发翻译');
        this.$nextTick(() => {
          // 延迟执行以确保DOM已更新
          setTimeout(() => {
            this.autoTranslateOnModeChange();
          }, 100);
        });
      }
    },
    // Tab 栏滚轮滑动
    handleTabWheel(event) {
      const container = this.$refs.tabContainer;
      if (container) {
        container.scrollLeft += event.deltaY;
        event.preventDefault();
      }
    },
    // 开始拖动
    startDrag(event) {
      const container = this.$refs.tabContainer;
      if (container) {
        this.isDragging = true;
        this.startX = event.pageX - container.offsetLeft;
        this.scrollLeft = container.scrollLeft;
        container.style.cursor = 'grabbing';
        container.style.userSelect = 'none';
      }
    },
    // 处理拖动
    handleDrag(event) {
      if (!this.isDragging) return;
      event.preventDefault();
      const container = this.$refs.tabContainer;
      if (container) {
        const x = event.pageX - container.offsetLeft;
        const walk = (x - this.startX) * 2;
        container.scrollLeft = this.scrollLeft - walk;
      }
    },
    // 停止拖动
    stopDrag() {
      this.isDragging = false;
      const container = this.$refs.tabContainer;
      if (container) {
        container.style.cursor = 'grab';
        container.style.removeProperty('user-select');
      }
    },
    // 设置活动 tab
    setActiveTab(tab) {
      this.activeTab = tab;
    },
    // 选择用户并更新右栏内容
    selectUser(userData) {
      this.selectedUserId = userData.id;
      this.selectedUser = userData;
    },
    // 获取用户的直播会话统计信息
    async fetchUserSessionStats() {
      try {
        console.log('开始获取用户直播会话统计信息');

        // 获取katoken用于认证
        const katoken = localStorage.getItem('katoken');
        if (!katoken) {
          console.error('未找到katoken，无法获取用户会话统计信息');
          return;
        }

        // 检查是否有必要的参数
        if (!this.currentSessionId) {
          console.warn('当前会话ID不存在，无法获取用户会话统计信息');
          return;
        }

        // 尝试从当前选中的用户消息中获取userInfoId
        let userInfoId = null;
        if (this.selectedUser.userInfoId) {
          userInfoId = this.selectedUser.userInfoId;
        } else {
          // 尝试从activities或historicalComments中查找该用户的userInfoId
          const allActivities = [...this.activities, ...this.historicalComments];
          const userActivity = allActivities.find(activity =>
            activity.name === this.selectedUser.name
          );
          if (userActivity && userActivity.userInfoId) {
            userInfoId = userActivity.userInfoId;
            console.log('从活动数据中找到userInfoId:', userInfoId);
          } else {
            console.warn('无法获取用户的userInfoId，使用默认值');
            userInfoId = 'default'; // 使用默认值避免API调用失败
          }
        }

        // 构建API请求参数
        const requestBody = {
          sessionId: this.currentSessionId,
          userInfoId: userInfoId,
          liveRoomId: this.currentRoomId
        };

        console.log('用户会话统计信息请求参数:', requestBody);

        // 调用用户会话统计信息API
        const response = await fetch(getApiUrl('USER_SESSION_STATS_QUERY'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'req_app_id': 'LivePlugin',
            'req_app_secret': 'ewMpjg7t4vX5bK13oRZzSB8mEuNGr2Yy',
            'katoken': katoken
          },
          body: JSON.stringify(requestBody)
        });

        console.log('用户会话统计信息API响应状态:', response.status);

        if (!response.ok) {
          const errorText = await response.text();
          console.error('获取用户会话统计信息API请求失败:', response.status, errorText);
          return;
        }

        const data = await response.json();
        console.log('用户会话统计信息API响应数据:', data);

        if (data.success && data.data) {
          // 更新currentStats数据
          this.currentStats = {
            rewardProbability: this.formatProbability(data.data.rewardProbability || 0),
            messageCount: data.data.messageCount || 0,
            giftCount: data.data.giftCount || 0,
            enterTime: data.data.enterTime ? this.formatTimeSinceEntry(data.data.enterTime) : null
          };

          console.log('成功获取用户会话统计信息:', this.currentStats);
        } else {
          console.warn('获取用户会话统计信息失败或无数据:', data);
          // 重置为默认值
          this.currentStats = {
            rewardProbability: 'N/A',
            messageCount: 0,
            giftCount: 0,
            enterTime: null
          };
        }

      } catch (error) {
        console.error('获取用户直播会话统计信息失败:', error);
        // 设置默认值
        this.currentStats = {
          rewardProbability: 'N/A',
          messageCount: 0,
          giftCount: 0,
          enterTime: null
        };
      }
    },

    // 打开历史信息浮层
    openHistoryModal() {
      this.showHistoryModal = true;
      this.$nextTick(() => {
        setTimeout(() => {
          this.modalAnimation = true;
          // 打开浮层时加载用户历史记录
          this.loadUserHistory();
          // 获取用户的直播会话统计信息
          this.fetchUserSessionStats();
          // 获取用户历史访问数据并生成日历
          this.fetchAttendanceHistory();
          this.generateCalendarDays();
        }, 50);
      });
    },
    // 关闭历史信息浮层
    closeHistoryModal() {
      this.modalAnimation = false;
      setTimeout(() => {
        this.showHistoryModal = false;
      }, 300);
    },
    // 重置右栏内容
    resetRightColumn() {
      this.selectedUserId = '';
      this.selectedUser = {
        name: this.$t('onAir.waitingForInteraction'),
        avatar: '',
        message: this.$t('onAir.noData'),
        interactionProbability: '0%',
        previousAppearances: '0',
        tag: this.$t('onAir.waiting'),
        sameLanguageResponse: this.$t('onAir.noScriptSuggestion'),
        differentLanguageResponse: this.$t('onAir.noScriptSuggestion'),
        phoneticGuide: '',
        translation: ''
      };
      this.languageMode = 'same';
      this.activeTab = 'all';
    },
    // 检查直播间连接状态
    async checkRoomConnection() {
      try {
        // 在所有环境下都使用真实的token
        let katoken = localStorage.getItem('katoken');
        console.log('使用真实token:', katoken ? '已获取' : '未获取');

        // 检查本地存储的直播间ID - 支持多种存储方式
        const bindingInfo = localStorage.getItem('tiktok-binding-info');
        const roomId = localStorage.getItem('tiktok-live-room-id');
        const currentStreamer = localStorage.getItem('currentStreamer');

        console.log('检查直播间连接状态 - bindingInfo:', bindingInfo, 'roomId:', roomId, 'currentStreamer:', currentStreamer);

        // 如果没有任何直播间信息，显示欢迎界面
        if (!bindingInfo && !roomId && !currentStreamer) {
          console.log('没有找到任何直播间绑定信息，显示欢迎界面');
          this.roomConnectedState = false;
          // 设置直播状态为false
          this.setLiveStatus(false);
          // 断开所有WebSocket连接
          this.disconnectWebSocket();
          return;
        }

        // 获取直播间ID - 优先级：bindingInfo > roomId > currentStreamer
        let targetRoomId = null;
        if (bindingInfo) {
          try {
            const binding = JSON.parse(bindingInfo);
            targetRoomId = binding.roomId || binding.bindingSource;
            console.log('从bindingInfo获取直播间ID:', targetRoomId);
          } catch (error) {
            console.error('解析bindingInfo失败:', error);
          }
        } else if (roomId) {
          targetRoomId = roomId;
          console.log('从roomId获取直播间ID:', targetRoomId);
        } else if (currentStreamer) {
          try {
            // 尝试解析currentStreamer，可能是JSON对象或字符串
            const streamerData = JSON.parse(currentStreamer);
            targetRoomId = streamerData.roomId || streamerData.name || currentStreamer;
            console.log('从currentStreamer解析获取直播间ID:', targetRoomId);
          } catch (error) {
            // 如果解析失败，说明currentStreamer本身就是直播间ID字符串
            targetRoomId = currentStreamer;
            console.log('从currentStreamer直接获取直播间ID:', targetRoomId);
          }
        }

        // 检查是否切换了直播间
        const isRoomChanged = this.currentRoomId && this.currentRoomId !== targetRoomId;
        if (isRoomChanged) {
          console.log('检测到直播间切换，从', this.currentRoomId, '切换到', targetRoomId);
          // 断开之前的WebSocket连接
          this.disconnectWebSocket();
          // 清空活动数据
          this.activities = [];
          this.historicalComments = [];
          this.historicalPageIndex = 1;
          this.hasMoreHistorical = true;
          // 重置右栏内容
          this.resetRightColumn();
        }

        console.log('开始查询直播间状态，房间ID:', targetRoomId);

        // 查询直播状态，使用已有的katoken
        const response = await fetch(`${getApiUrl('LIVE_SESSIONS_ROOM_CURRENT')}/${targetRoomId}/current`, {
          method: 'GET',
          headers: {
            'req_app_id': 'LivePlugin',
            'req_app_secret': 'ewMpjg7t4vX5bK13oRZzSB8mEuNGr2Yy',
            'katoken': katoken
          }
        });

        const data = await response.json();
        console.log('直播间状态API响应:', data);

        // 检查API响应
        if (!data) {
          console.error('Invalid API response for room:', targetRoomId);
          this.roomConnectedState = false;
          return;
        }

        // 分析API返回结果来判断直播间连接状态
        if (data.success && data.data && data.data.status === 1) {
          // 有直播正在进行中，显示直播界面
          this.roomConnectedState = true;
          this.setLiveStatus(true); // 切换到直播状态
          console.log('直播间正在直播中，切换到直播界面:', targetRoomId);

          // 获取当前直播的sessionId并建立WebSocket连接
          const sessionId = data.data.sessionId;
          if (sessionId) {
            console.log('获取到当前直播的sessionId:', sessionId);
            this.connectWebSocket(targetRoomId, sessionId);
          } else {
            console.warn('无法获取当前直播的sessionId，无法建立WebSocket连接');
          }
          
          // 获取直播统计数据并更新Live Activity Feed标签计数
          await this.fetchLiveStatisticsForTabs(targetRoomId, katoken);
        } else if (data.errCode === '404') {
          // 房间存在但当前没有直播，需要切换到欢迎界面
          this.roomConnectedState = false; // 设置为false，显示欢迎界面
          this.setLiveStatus(false); // 切换到无直播状态
          console.log('直播间存在但当前没有直播，切换到欢迎界面:', targetRoomId);
          
          // 断开WebSocket连接，因为直播已停止
          this.disconnectWebSocket();
          
          // 清空活动数据
          this.activities = [];
          this.historicalComments = [];
          this.historicalPageIndex = 1;
          this.hasMoreHistorical = true;
          
          // 重置右栏内容
          this.resetRightColumn();
          
          // 清空潜在赞助者列表
          this.potentialPatrons = [];
        } else {
          // 其他错误情况，视为连接失败
          console.log('直播间连接失败:', targetRoomId, data);
          this.roomConnectedState = false;
        }

        console.log('直播间连接状态更新为:', this.roomConnectedState);

        // 无论直播状态如何，只要有房间ID就立即请求潜在赞助者数据
        if (targetRoomId) {
          console.log('立即请求潜在赞助者数据，房间ID:', targetRoomId);
          // 清空之前的潜在赞助者列表，避免显示旧数据
          this.potentialPatrons = [];
          this.fetchPotentialPatrons();
        }

      } catch (error) {
        console.error('检查直播间连接状态失败:', error);
        this.roomConnectedState = false;
      }
    },

    // 获取直播会话统计数据
    async fetchLiveSessionData(roomId, katoken) {
      try {
        console.log('Fetching live session data for room:', roomId);
        // 调用直播会话详情统计接口（获取本场统计数据）- 使用POST请求
        const requestBody = {
          liveRoomId: roomId,
          sessionId: currentSessionId
        };
        const response = await fetch(getApiUrl('LIVE_SESSION_STATS_DETAIL'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'req_app_id': 'LivePlugin',
            'req_app_secret': 'ewMpjg7t4vX5bK13oRZzSB8mEuNGr2Yy',
            'katoken': katoken
          },
          body: JSON.stringify(requestBody)
        });

        console.log('直播场次详情统计数据:', data);

        if (data.success && data.data) {
          console.log('直播统计数据获取成功:', data.data.messageTypeStats);

          // 更新Live Activity Feed的标签计数
          this.statistics = {
            totalMessages: data.data.messageTypeStats[0].count + data.data.messageTypeStats[1].count + data.data.messageTypeStats[2].count + data.data.messageTypeStats[3].count || 0,
            chatCount: data.data.messageTypeStats[0].count || 0,
            enterCount: data.data.messageTypeStats[1].count || 0,
            giftCount: data.data.messageTypeStats[2].count || 0,
            socialCount: data.data.messageTypeStats[3].count || 0
          };

          console.log('Live Activity Feed标签计数已更新:', this.statistics);
        } else {
          console.warn('获取直播统计数据失败或无数据:', data);
        }

        const data = await response.json();

        if (data.success && data.data) {
          // 获取第一条数据（当前直播的统计信息）
          const currentSession = data.data
          console.log('Live session data fetched successfully:', currentSession);

          // 传递数据给App.vue的直播状态面板
          // 使用inject的updateLiveSessionData方法
          this.updateLiveSessionData && this.updateLiveSessionData(data);

          // 使用获取到的sessionId建立WebSocket连接来监听实时评论
          if (currentSession.sessionId && currentSession.roomId) {
            console.log('开始建立WebSocket连接来监听实时评论');
            this.connectWebSocket(currentSession.roomId, currentSession.sessionId);
          }
        } else {
          console.warn('No live session data available or invalid response:', data);
        }
      } catch (error) {
        console.error('Error fetching live session data:', error);
      }
    },

    // 获取直播统计数据并更新Live Activity Feed标签计数
    async fetchLiveStatisticsForTabs(roomId, katoken) {
      try {
        console.log('获取直播统计数据用于更新标签计数，房间ID:', roomId);

        // 先获取当前直播的sessionId
        const currentResponse = await fetch(`${getApiUrl('LIVE_SESSIONS_ROOM_CURRENT')}/${roomId}/current`, {
          method: 'GET',
          headers: {
            'req_app_id': 'LivePlugin',
            'req_app_secret': 'ewMpjg7t4vX5bK13oRZzSB8mEuNGr2Yy',
            'katoken': katoken
          }
        });

        const currentData = await currentResponse.json();
        console.log('当前直播状态数据:', currentData);

        let currentSessionId = null;
        if (currentData.success && currentData.data && currentData.data.sessionId) {
          currentSessionId = currentData.data.sessionId;
          console.log('当前直播的sessionId:', currentSessionId);
        }

        // 如果没有获取到sessionId，无法获取统计数据
        if (!currentSessionId) {
          console.log('未获取到当前直播的sessionId，无法获取统计数据');
          return;
        }

        // 调用直播会话详情统计接口（获取本场统计数据）- 使用POST请求
        const requestBody = {
          liveRoomId: roomId,
          sessionId: currentSessionId
        };

        console.log('请求直播场次详情统计，参数:', requestBody);

        const response = await fetch(getApiUrl('LIVE_SESSION_STATS_DETAIL'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'req_app_id': 'LivePlugin',
            'req_app_secret': 'ewMpjg7t4vX5bK13oRZzSB8mEuNGr2Yy',
            'katoken': katoken
          },
          body: JSON.stringify(requestBody)
        });

        const data = await response.json();
        console.log('直播场次详情统计数据:', data);

        if (data.success && data.data) {
          console.log('直播统计数据获取成功:', data.data);

          // 更新Live Activity Feed的标签计数
          this.statistics = {
            totalMessages: data.data.messageTypeStats[0].count + data.data.messageTypeStats[1].count + data.data.messageTypeStats[2].count + data.data.messageTypeStats[3].count || 0,
            chatCount: data.data.messageTypeStats[0].count || 0,
            enterCount: data.data.messageTypeStats[1].count || 0,
            giftCount: data.data.messageTypeStats[2].count || 0,
            socialCount: data.data.messageTypeStats[3].count || 0
          };

          console.log('Live Activity Feed标签计数已更新:', this.statistics);
        } else {
          console.warn('获取直播统计数据失败或无数据:', data);
        }
      } catch (error) {
        console.error('获取直播统计数据失败:', error);
      }
    },

    // 建立WebSocket连接
    connectWebSocket(roomId, sessionId) {
      try {
        // 检查是否已经是相同的房间和会话，避免重复连接
        if (this.websocket && this.websocketConnected && 
            this.currentRoomId === roomId && this.currentSessionId === sessionId) {
          console.log('已经是相同的直播间连接，无需重新连接');
          return;
        }

        // 如果已经有连接，先断开
        if (this.websocket && this.websocketConnected) {
          console.log('已有WebSocket连接，先断开...');
          this.disconnectWebSocket();
        }

        console.log('尝试建立WebSocket连接:', roomId, sessionId);

        // 只有在切换不同直播间时才清空活动数据
        if (this.currentRoomId !== roomId || this.currentSessionId !== sessionId) {
          console.log('切换直播间，清空Live Activity Feed数据');
          this.activities = [];
          this.historicalComments = [];
          this.historicalPageIndex = 1;
          this.hasMoreHistorical = true;
        }

        // 更新当前直播间参数，确保话术生成功能使用新的参数
        this.currentRoomId = roomId;
        this.currentSessionId = sessionId;
        console.log('更新当前直播间参数 - roomId:', roomId, 'sessionId:', sessionId);

        // 建立WebSocket连接
        const wsUrl = 'wss://creator.withflows.com:9007/ws/live/comment';
        this.websocket = new WebSocket(wsUrl);

        // 连接打开
        this.websocket.onopen = (event) => {
          console.log('WebSocket连接已建立');
          this.websocketConnected = true;
          this.currentRoomId = roomId;
          this.currentSessionId = sessionId;

          // 将sessionId存储到localStorage供其他组件使用
          localStorage.setItem('currentSessionId', sessionId);

          this.subscribeToLiveComments(roomId, sessionId);

          // WebSocket连接建立后，立即加载历史评论作为缓冲
          console.log('开始加载历史评论作为缓冲');
          this.loadHistoricalComments(false);

          // 建立话术建议WebSocket连接
          console.log('开始建立话术建议WebSocket连接');
          this.connectScriptWebSocket(roomId, sessionId);

          this.fetchPotentialPatrons();

          // 启动潜在赞助者列表更新定时器
          this.startPotentialPatronsTimer();
        };

        // 接收消息
        this.websocket.onmessage = (event) => {
          try {
            const message = JSON.parse(event.data);
            this.handleWebSocketMessage(message);
          } catch (error) {
            console.error('解析WebSocket消息失败:', error);
          }
        };

        // 连接错误
        this.websocket.onerror = (error) => {
          console.error('WebSocket连接出错:', error);
          this.websocketConnected = false;
        };

        // 连接关闭
        this.websocket.onclose = (event) => {
          console.log('WebSocket连接已关闭:', event.code, event.reason);
          this.websocketConnected = false;
          this.currentRoomId = null;
          this.currentSessionId = null;
        };

      } catch (error) {
        console.error('建立WebSocket连接失败:', error);
        this.websocketConnected = false;
      }
    },

    // 发送订阅评论的请求
    subscribeToLiveComments(roomId, sessionId) {
      if (!this.websocket || !this.websocketConnected) {
        console.warn('WebSocket未连接，无法发送订阅请求');
        return;
      }

      const subscribeMessage = {
        action: 'subscribe',
        roomId: roomId,
        sessionId: sessionId
      };

      console.log('发送订阅请求:', subscribeMessage);
      this.websocket.send(JSON.stringify(subscribeMessage));
    },

    // 处理接收到的WebSocket消息
    handleWebSocketMessage(message) {
      // 处理订阅响应
      if (message.status) {
        if (message.status === 'success') {
          console.log('成功订阅直播评论:', message.message);
        } else {
          console.error('订阅直播评论失败:', message.message);
        }
        return;
      }

      // 处理直播评论消息
      if (message.type === 'comment') {
        this.processLiveComment(message);
        
        // 更新统计信息
        if (message.statistics) {
          console.log('接收到统计信息:', message.statistics);
          this.updateStatistics(message.statistics);
        }
      }
    },

    // 更新统计信息
    updateStatistics(statistics) {
      console.log('更新统计信息:', statistics);
      
      // 更新statistics对象
      this.statistics = {
        totalMessages: statistics.totalMessages || 0,
        chatCount: statistics.chatCount || 0,
        enterCount: statistics.enterCount || 0,
        giftCount: statistics.giftCount || 0,
        socialCount: statistics.socialCount || 0
      };
      
      console.log('统计信息已更新:', this.statistics);
    },

    // 处理直播评论数据
    processLiveComment(message) {
      try {
        const commentData = message.data;
        console.log('接收到直播评论:', commentData);

        // 根据messageType确定活动类型
        let activityType = 'message'; // 默认是消息
        if (commentData.messageType === 'gift') {
          activityType = 'gift';
        } else if (commentData.messageType === 'chat') {
          activityType = 'message'; // chat类型的消息是聊天消息
        } else if (['enter', 'follow', 'like', 'share', 'social'].includes(commentData.messageType)) {
          activityType = commentData.messageType; // 其他互动类型包括social
        }

        // 将评论数据转换为activities格式，包含所有必要的字段
        const activity = {
          id: commentData.id,
          type: activityType,
          name: commentData.nickname || 'Unknown',
          avatar: commentData.avatarUrl || this.getUserAvatarUrl(),
          timestamp: new Date(commentData.commentTime).getTime(), // 存储原始时间戳
          content: commentData.content || '',
          heat: commentData.userLevel || 0,
          // 添加WebSocket消息中的完整字段，用于话术建议接口
          roomId: commentData.roomId,
          sessionId: commentData.sessionId,
          userInfoId: commentData.userInfoId, // 确保获取userInfoId
          messageType: commentData.messageType,
          sequence: message.sequence,
          userId: commentData.userId
        };
        
        console.log('处理实时评论 - userInfoId:', commentData.userInfoId, '昵称:', commentData.nickname);

        // 如果是礼物消息，添加礼物相关信息
        if (commentData.messageType === 'gift') {
          activity.giftName = commentData.giftType;
          activity.giftCount = commentData.giftNum;
          activity.giftValue = commentData.giftValue;
        }

        // 添加到activities数组的开头
        this.activities.unshift(activity);

        // 更新最后评论时间
        this.lastCommentTime = Date.now();
        console.log('更新最后评论时间:', new Date(this.lastCommentTime).toLocaleTimeString());

        console.log('已添加新活动:', activity.type, '总数:', this.activities.length);

        // 如果当前是Different Language模式，自动翻译新评论
        if (this.languageMode === 'different') {
          this.$nextTick(() => {
            setTimeout(() => {
              this.translateCommentImmediately(activity.content, activity.id);
            }, 100);
          });
        }

      } catch (error) {
        console.error('处理直播评论数据失败:', error);
      }
    },

    // 格式化时间显示
    formatTimeSince(timestamp) {
      try {
        const now = new Date();
        const commentTime = new Date(timestamp);
        const diffSeconds = Math.floor((now - commentTime) / 1000);

        if (diffSeconds < 60) {
          return `${diffSeconds}s`;
        } else if (diffSeconds < 3600) {
          const minutes = Math.floor(diffSeconds / 60);
          const seconds = diffSeconds % 60;
          return `${minutes}m ${seconds}s`;
        } else {
          const hours = Math.floor(diffSeconds / 3600);
          const minutes = Math.floor((diffSeconds % 3600) / 60);
          return `${hours}h ${minutes}m`;
        }
      } catch (error) {
        console.error('格式化时间失败:', error);
        return 'now';
      }
    },

    // 格式化历史时间显示 - 使用与实时消息相同的相对时间格式
    formatHistoricalTime(timestamp) {
      // 直接使用现有的formatTimeSince方法，让历史消息也显示相对时间
      return this.formatTimeSince(timestamp);
    },

    // 建立话术建议WebSocket连接
    connectScriptWebSocket(roomId, sessionId) {
      try {
        // 如果已经有连接，先断开
        if (this.scriptWebSocket && this.scriptWebSocketConnected) {
          console.log('已有话术建议WebSocket连接，先断开...');
          this.disconnectScriptWebSocket();
        }

        console.log('尝试建立话术建议WebSocket连接:', roomId, sessionId);

        // 建立话术建议WebSocket连接
        const scriptWsUrl = 'wss://creator.withflows.com:9006/ws/live/comment-script';
        this.scriptWebSocket = new WebSocket(scriptWsUrl);

        // 连接打开
        this.scriptWebSocket.onopen = (event) => {
          console.log('话术建议WebSocket连接已建立');
          this.scriptWebSocketConnected = true;
          this.sendScriptSubscription(roomId, sessionId);
        };

        // 接收消息
        this.scriptWebSocket.onmessage = (event) => {
          try {
            const message = JSON.parse(event.data);
            this.handleScriptWebSocketMessage(message);
          } catch (error) {
            console.error('解析话术建议WebSocket消息失败:', error);
          }
        };

        // 连接错误
        this.scriptWebSocket.onerror = (error) => {
          console.error('话术建议WebSocket连接出错:', error);
          this.scriptWebSocketConnected = false;
        };

        // 连接关闭
        this.scriptWebSocket.onclose = (event) => {
          console.log('话术建议WebSocket连接已关闭:', event.code, event.reason);
          this.scriptWebSocketConnected = false;
        };

      } catch (error) {
        console.error('建立话术建议WebSocket连接失败:', error);
        this.scriptWebSocketConnected = false;
      }
    },

    // 发送话术建议订阅请求
    sendScriptSubscription(roomId, sessionId) {
      if (!this.scriptWebSocket || !this.scriptWebSocketConnected) {
        console.warn('话术建议WebSocket未连接，无法发送订阅请求');
        return;
      }

      const subscribeMessage = {
        action: 'subscribe',
        roomId: roomId,
        sessionId: sessionId
      };

      console.log('发送话术建议订阅请求:', subscribeMessage);
      this.scriptWebSocket.send(JSON.stringify(subscribeMessage));
    },

    // 处理话术建议WebSocket消息
    handleScriptWebSocketMessage(message) {
      // 处理订阅响应
      if (message.status) {
        if (message.status === 'success') {
          console.log('成功订阅话术建议:', message.message);
        } else {
          console.error('订阅话术建议失败:', message.message);
        }
        return;
      }

      // 处理话术建议消息 - 新的消息格式
      if (message.type === 'script') {
        console.log('=== 收到WebSocket话术建议消息 ===');
        console.log('完整接口返回内容:', JSON.stringify(message, null, 2));
        console.log('消息类型:', message.type);
        console.log('建议数据:', message.data);
        console.log('=====================================');

        // 处理新的话术建议数据格式
        this.processNewScriptSuggestion(message.data);
      }
    },

    // 处理新的话术建议数据格式
    processNewScriptSuggestion(scriptData) {
      try {
        console.log('处理新的话术建议数据:', scriptData);
        
        if (!scriptData || !scriptData.scripts || !Array.isArray(scriptData.scripts) || scriptData.scripts.length === 0) {
          console.warn('话术建议数据格式不正确或为空');
          return;
        }

        // 获取第一条话术建议
        const firstScript = scriptData.scripts[0];
        if (!firstScript.scriptText) {
          console.warn('话术建议内容为空');
          return;
        }

        // 解析话术文本，提取话术和罗马音
        const { japaneseText, phoneticText } = this.extractJapaneseAndPhonetic(firstScript.scriptText);
        
        console.log('解析话术文本结果:', {
          originalScriptText: firstScript.scriptText,
          japaneseText: japaneseText,
          phoneticText: phoneticText
        });

        // 构建话术建议对象
        const suggestionItem = {
          id: scriptData.userInfoId + '_' + Date.now(), // 生成唯一ID
          userInfoId: scriptData.userInfoId,
          nickname: scriptData.nickname || '用户',
          avatarUrl: scriptData.avatarUrl || this.getUserAvatarUrl(),
          roomId: scriptData.roomId,
          sessionId: scriptData.sessionId,
          originalComment: firstScript.referencedComments && firstScript.referencedComments.length > 0 
            ? firstScript.referencedComments[0] 
            : '暂无评论内容',
          scriptText: firstScript.scriptText,
          japaneseText: japaneseText, // 日文话术
          phoneticText: phoneticText, // 罗马音
          rewardProbability: scriptData.rewardProbability || 0,
          timestamp: Date.now()
        };

        console.log('构建的话术建议对象:', suggestionItem);

        // 设置引用评论数据 - 从scripts[0]中获取
        this.referencedComments = firstScript.referencedComments || [];

        // 将话术建议添加到队列中
        this.addToSuggestionQueue(suggestionItem);

      } catch (error) {
        console.error('处理新的话术建议数据失败:', error);
      }
    },

    // 话术建议队列相关方法

    // 添加话术建议到队列
    addToSuggestionQueue(suggestionItem) {
      console.log('添加话术建议到队列:', suggestionItem);
      
      // 添加到队列
      this.suggestionQueue.push(suggestionItem);
      
      // 如果没有正在显示的话术建议，立即显示
      if (!this.isShowingSuggestion) {
        this.showNextSuggestion();
      }
    },

    // 显示下一条话术建议
    showNextSuggestion() {
      if (this.suggestionQueue.length === 0) {
        this.isShowingSuggestion = false;
        return;
      }

      this.isShowingSuggestion = true;
      
      // 从队列中取出第一条建议
      const suggestionItem = this.suggestionQueue.shift();
      console.log('显示话术建议:', suggestionItem);

      // 显示话术建议到Priority Target区域
      this.displaySuggestionInPriorityTarget(suggestionItem);

      // 设置定时器，15秒后显示下一条建议
      if (this.currentSuggestionTimer) {
        clearTimeout(this.currentSuggestionTimer);
      }
      
      this.currentSuggestionTimer = setTimeout(() => {
        console.log('15秒时间到，显示下一条话术建议');
        this.showNextSuggestion();
      }, 15000); // 15秒
    },

    // 在Priority Target区域显示话术建议
    async displaySuggestionInPriorityTarget(suggestionItem) {
      try {
        console.log('在Priority Target区域显示话术建议:', suggestionItem);

        // 优先使用referencedComments中的内容作为用户消息
        let userMessage = '暂无评论内容';
        if (this.referencedComments && this.referencedComments.length > 0) {
          userMessage = this.referencedComments[0];
          console.log('使用referencedComments作为用户消息:', userMessage);
        } else if (suggestionItem.originalComment && suggestionItem.originalComment !== '暂无评论内容') {
          userMessage = suggestionItem.originalComment;
          console.log('使用originalComment作为用户消息:', userMessage);
        }

        // 处理话术文本中的换行符
        const processedScriptText = this.processScriptLineBreaks(suggestionItem.japaneseText);

        // 智能获取用户概率：如果接口返回0，则从潜在赞助者列表中查找
        let userProbability = this.formatProbability(suggestionItem.rewardProbability);
        if (suggestionItem.rewardProbability === 0) {
          console.log('接口返回概率为0，尝试从潜在赞助者列表中查找真实概率');
          const realProbability = this.findUserProbability(suggestionItem.nickname);
          if (realProbability !== '0%') {
            userProbability = realProbability;
            console.log('从潜在赞助者列表中找到真实概率:', userProbability);
          } else {
            console.log('潜在赞助者列表中也没有找到该用户，保持0%');
          }
        }

        // 更新Priority Target区域
        this.selectedUserId = suggestionItem.id;
        this.selectedUser = {
          name: suggestionItem.nickname,
          avatar: suggestionItem.avatarUrl,
          message: userMessage,
          interactionProbability: userProbability,
          previousAppearances: '1',
          tag: '话术建议',
          sameLanguageResponse: processedScriptText,
          differentLanguageResponse: suggestionItem.japaneseText,
          phoneticGuide: suggestionItem.phoneticText || '',
          translation: '',
          priorityRating: 0
        };

        console.log('成功更新Priority Target区域，用户消息:', userMessage);
        console.log('话术内容:', suggestionItem.japaneseText);
        console.log('罗马音:', suggestionItem.phoneticText);
        console.log('最终显示的概率:', userProbability);

        // 自动翻译用户的评论和话术建议
        await this.translateSuggestionContent(suggestionItem);

      } catch (error) {
        console.error('在Priority Target区域显示话术建议失败:', error);
      }
    },

    // 翻译话术建议内容（用户评论和话术建议）- 独立方法，不与实时翻译混在一起
    async translateSuggestionContent(suggestionItem) {
      try {
        console.log('=== 开始独立翻译话术建议内容 ===');

        // 翻译用户评论 - 独立处理，不与其他翻译混在一起
        if (suggestionItem.originalComment && suggestionItem.originalComment !== '暂无评论内容') {
          console.log('独立翻译用户评论:', suggestionItem.originalComment);
          const commentTranslation = await this.callTranslationAPI(
            suggestionItem.originalComment,
            this.selectedSourceLanguage,
            this.selectedTargetLanguage
          );
          
          if (commentTranslation) {
            // 只更新当前话术建议的用户评论翻译，不修改其他翻译
            this.selectedUser.originalTranslation = commentTranslation;
            console.log('✅ 用户评论独立翻译成功:', commentTranslation);
          } else {
            this.selectedUser.originalTranslation = '翻译失败';
            console.error('❌ 用户评论独立翻译失败');
          }
        }

        // 翻译话术建议 - 独立处理，不与其他翻译混在一起
        if (suggestionItem.scriptText) {
          console.log('独立翻译话术建议:', suggestionItem.scriptText);
          const scriptTranslation = await this.callTranslationAPI(
            suggestionItem.scriptText,
            this.selectedSourceLanguage,
            this.selectedTargetLanguage
          );
          
          if (scriptTranslation) {
            // 只更新当前话术建议的翻译，不修改其他翻译
            this.selectedUser.suggestionTranslation = scriptTranslation;
            console.log('✅ 话术建议独立翻译成功:', scriptTranslation);
          } else {
            this.selectedUser.suggestionTranslation = '翻译失败';
            console.error('❌ 话术建议独立翻译失败');
          }
        }

        console.log('=== 话术建议内容独立翻译完成 ===');

      } catch (error) {
        console.error('❌ 独立翻译话术建议内容失败:', error);
      }
    },

    // 断开话术建议WebSocket连接
    disconnectScriptWebSocket() {
      if (this.scriptWebSocket) {
        console.log('正在断开话术建议WebSocket连接...');
        this.scriptWebSocket.close();
        this.scriptWebSocket = null;
        this.scriptWebSocketConnected = false;
      }
    },

    // 断开WebSocket连接
    disconnectWebSocket() {
      if (this.websocket) {
        console.log('正在断开WebSocket连接...');
        this.websocket.close();
        this.websocket = null;
        this.websocketConnected = false;
        this.currentRoomId = null;
        this.currentSessionId = null;
      }

      // 同时断开话术建议WebSocket连接
      this.disconnectScriptWebSocket();
      
      // 停止潜在赞助者定时器
      if (this.potentialPatronsTimer) {
        clearInterval(this.potentialPatronsTimer);
        this.potentialPatronsTimer = null;
        console.log('WebSocket断开时清理潜在赞助者定时器');
      }
    },

    // 开始定期检查
    startPeriodicChecking() {
      // 立即执行一次检查
      console.log('立即执行直播状态检查');
      this.checkRoomConnection();
      
      // 然后每隔60秒（1分钟）执行一次，但只在没有WebSocket连接时才重新连接
      this.periodicCheckInterval = setInterval(() => {
        console.log('执行定期直播状态检查');
        
        // 如果已经有WebSocket连接，只检查状态但不重新连接
        if (this.websocket && this.websocketConnected) {
          console.log('已有WebSocket连接，只检查状态不重新连接');
          // 这里可以添加其他状态检查逻辑，但不重新连接WebSocket
        } else {
          console.log('没有WebSocket连接，执行完整连接检查');
          this.checkRoomConnection();
        }
      }, 60 * 1000); // 60秒
    },

    // 停止定期检查
    stopPeriodicChecking() {
      if (this.periodicCheckInterval) {
        clearInterval(this.periodicCheckInterval);
        this.periodicCheckInterval = null;
      }

      // 同时断开WebSocket连接
      this.disconnectWebSocket();
    },

    // 开始时间更新定时器
    startTimeUpdateTimer() {
      console.log('=== 启动时间更新定时器 ===');
      
      // 先停止可能存在的旧定时器
      if (this.timeUpdateInterval) {
        clearInterval(this.timeUpdateInterval);
        this.timeUpdateInterval = null;
      }
      
      // 立即执行一次时间更新
      this.updateAllActivitiesTime();
      
      // 每隔5秒更新所有活动的时间显示（减少频率，避免不必要的重新渲染）
      this.timeUpdateInterval = setInterval(() => {
        console.log('时间更新定时器执行中...');
        this.updateAllActivitiesTime();
      }, 5000); // 改为5秒
      
      console.log('时间更新定时器已启动，间隔：5秒');
    },

    // 停止时间更新定时器
    stopTimeUpdateTimer() {
      if (this.timeUpdateInterval) {
        clearInterval(this.timeUpdateInterval);
        this.timeUpdateInterval = null;
      }
    },

    // 更新所有活动的时间显示（包括实时消息和历史消息）
    updateAllActivitiesTime() {
      console.log('=== 开始更新所有活动时间 ===');
      
      let hasChanges = false;
      
      // 遍历所有实时活动，根据存储的原始时间戳重新计算时间显示
      this.activities.forEach(activity => {
        if (activity.timestamp) {
          const newTime = this.formatTimeSince(activity.timestamp);
          // 只有当时间发生变化时才更新，避免不必要的重新渲染
          if (activity.time !== newTime) {
            activity.time = newTime;
            hasChanges = true;
          }
        }
      });

      // 遍历所有历史活动，根据存储的原始时间戳重新计算时间显示
      this.historicalComments.forEach(activity => {
        if (activity.timestamp) {
          const newTime = this.formatTimeSince(activity.timestamp);
          // 只有当时间发生变化时才更新，避免不必要的重新渲染
          if (activity.time !== newTime) {
            activity.time = newTime;
            hasChanges = true;
          }
        }
      });
      
      // 如果有变化，强制触发Vue的响应式更新
      if (hasChanges) {
        console.log('检测到时间变化，强制触发Vue响应式更新');
        // 强制触发数组更新
        this.activities = [...this.activities];
        this.historicalComments = [...this.historicalComments];
      }
      
      console.log('=== 完成更新所有活动时间 ===');
    },

    // 获取历史评论数据
    async loadHistoricalComments(appendMore = false) {
      if (!this.currentSessionId || !this.currentRoomId) {
        console.log('没有有效的直播会话，无法加载历史评论');
        return;
      }

      if (!appendMore) {
        this.historicalLoading = true;
        this.historicalPageIndex = 1; // 重置页码
        this.historicalComments = []; // 清空历史评论
        this.hasMoreHistorical = true;
      } else {
        if (this.historicalLoadingMore || !this.hasMoreHistorical) {
          return;
        }
        this.historicalLoadingMore = true;
      }

      try {
        console.log(`加载历史评论 - 房间: ${this.currentRoomId}, 会话: ${this.currentSessionId}, 页码: ${this.historicalPageIndex}`);

          // 根据当前tab决定messageType参数
        let messageTypeParam = '';
        if (this.activeTab === 'gifts') {
          // Gifts标签：只获取gift类型
          messageTypeParam = '&messageType=gift';
        } else if (this.activeTab === 'messages') {
          // Messages标签：只获取chat类型
          messageTypeParam = '&messageType=chat';
        } else if (this.activeTab === 'interactions') {
          // Interactions标签：获取所有除chat和gift外的其他类型（social, enter, follow, like, share等）
          // 由于API参数不支持多个类型，我们可以获取所有类型并在前端过滤
          // 或者让API直接返回所有非chat非gift类型的消息（需要后端支持）
          messageTypeParam = ''; // 暂时获取所有，后端过滤
        }
        // All标签不指定messageType，让后端返回所有类型的消息

        const response = await fetch(`${getApiUrl('LIVE_COMMENTS')}?sessionId=${this.currentSessionId}&roomId=${this.currentRoomId}&pageIndex=${this.historicalPageIndex}&pageSize=${this.historicalPageSize}${messageTypeParam}`, {
          method: 'GET',
          headers: {
            'req_app_id': 'LivePlugin',
            'req_app_secret': 'ewMpjg7t4vX5bK13oRZzSB8mEuNGr2Yy'
          }
        });

        const data = await response.json();

        if (data.success && data.data && Array.isArray(data.data)) {
          console.log('获取历史评论成功:', data.data.length, '条');

          // 处理历史评论数据，转换为activities格式
          const newHistoricalComments = data.data.map((comment, index) => {
            // 根据messageType确定活动类型
            let activityType = 'message'; // 默认是消息
            if (comment.messageType === 'gift') {
              activityType = 'gift';
            } else if (comment.messageType === 'enter' || comment.messageType === 'follow' || comment.messageType === 'like' || comment.messageType === 'share') {
              activityType = comment.messageType;
            }

            // 生成唯一ID：优先使用服务器返回的ID，否则使用时间戳+随机数确保唯一性
            const commentTimestamp = new Date(comment.commentTime || comment.createdAt).getTime();
            const uniqueId = comment.id ? `${comment.id}_historical` : `hist_${commentTimestamp}_${Math.random().toString(36).substr(2, 9)}`;

            // 将评论数据转换为activities格式
            const activity = {
              id: uniqueId,
              type: activityType,
              name: comment.nickname || comment.userId || 'Unknown',
              avatar: comment.avatarUrl || '',
              timestamp: commentTimestamp,
              content: comment.content || '',
              heat: comment.userLevel || 0,
              isHistorical: true, // 标记为历史评论
              // 添加历史评论中的userInfoId
              userInfoId: comment.userInfoId,
              roomId: comment.roomId,
              sessionId: comment.sessionId,
              // 添加翻译相关字段
              translatedContent: '', // 翻译后的内容
              isTranslating: false // 是否正在翻译
            };
            
            console.log('处理历史评论 - userInfoId:', comment.userInfoId, '昵称:', comment.nickname);

            // 如果是礼物消息，添加礼物相关信息
            if (comment.messageType === 'gift') {
              activity.giftName = comment.giftType;
              activity.giftCount = comment.giftNum;
              activity.giftValue = comment.giftValue;
            }

            return activity;
          });

          if (appendMore) {
            // 添加到历史评论数组末尾
            this.historicalComments.push(...newHistoricalComments);
            console.log('追加历史评论，当前总数:', this.historicalComments.length);
          } else {
            // 直接赋值给历史评论数组
            this.historicalComments = newHistoricalComments;
            console.log('设置历史评论，总数:', this.historicalComments.length);
          }

          // 检查是否还有更多数据
          this.hasMoreHistorical = data.data.length >= this.historicalPageSize;

          if (appendMore && data.data.length > 0) {
            this.historicalPageIndex++; // 只有在成功加载更多数据时才增加页码
          } else if (!appendMore && data.data.length > 0) {
            this.historicalPageIndex++; // 首次加载成功后，将页码设置为2（下次加载第2页）
          }

          // 如果当前是Different Language模式，自动翻译历史评论
          if (this.languageMode === 'different') {
            this.$nextTick(() => {
              setTimeout(() => {
                this.translateHistoricalComments();
              }, 500);
            });
          }
        } else {
          console.warn('获取历史评论失败或无数据:', data);
          this.hasMoreHistorical = false;
        }

        console.log('历史评论加载完成 - 当前页码:', this.historicalPageIndex, '总数:', this.historicalComments.length);

      } catch (error) {
        console.error('加载历史评论失败:', error);
        this.hasMoreHistorical = false;
      } finally {
        this.historicalLoading = false;
        this.historicalLoadingMore = false;
      }
    },

    // 翻译历史评论
    async translateHistoricalComments() {
      try {
        console.log('开始翻译历史评论，总数量:', this.historicalComments.length);
        
        // 找出所有未翻译的历史评论
        const commentsToTranslate = this.historicalComments.filter(comment => 
          comment.content && 
          comment.content.trim() && 
          !comment.translatedContent && 
          !comment.isTranslating
        );
        
        console.log('需要翻译的评论数量:', commentsToTranslate.length);
        
        // 分批翻译，避免一次性请求过多
        const batchSize = 10;
        for (let i = 0; i < commentsToTranslate.length; i += batchSize) {
          const batch = commentsToTranslate.slice(i, i + batchSize);
          const batchNumber = Math.floor(i / batchSize) + 1;
          console.log(`翻译批次 ${batchNumber}: ${batch.length} 条评论`);
          
          // 并行翻译批次中的评论
          const translationPromises = batch.map(async (comment) => {
            try {
              comment.isTranslating = true;
              const translation = await this.callTranslationAPI(
                comment.content,
                this.selectedSourceLanguage,
                this.selectedTargetLanguage
              );
              
              if (translation) {
                comment.translatedContent = translation;
                console.log('历史评论翻译成功:', comment.content.substring(0, 50), '->', translation.substring(0, 50));
              } else {
                comment.translatedContent = '翻译失败';
              }
            } catch (error) {
              console.error('翻译历史评论失败:', error);
              comment.translatedContent = '翻译失败';
            } finally {
              comment.isTranslating = false;
            }
          });
          
          // 等待当前批次翻译完成
          await Promise.all(translationPromises);
          
          // 每翻译完一个批次就更新一次UI
          this.historicalComments = [...this.historicalComments];
          
          // 批次之间稍微延迟，避免API限流
          if (i + batchSize < commentsToTranslate.length) {
            await new Promise(resolve => setTimeout(resolve, 500));
          }
        }
        
        console.log('历史评论翻译完成');
        
        // 最终强制触发Vue响应式更新
        this.historicalComments = [...this.historicalComments];
      } catch (error) {
        console.error('翻译历史评论过程失败:', error);
      }
    },

    // 处理活动 feed 的滚动事件，用于加载更多历史评论
    handleActivityScroll() {
      const scrollContainer = this.$refs.activityScrollContainer;
      if (!scrollContainer) return;

      const scrollTop = scrollContainer.scrollTop;
      const scrollHeight = scrollContainer.scrollHeight;
      const clientHeight = scrollContainer.clientHeight;

      // 当滚动到距离底部100px时触发加载更多
      if (scrollTop + clientHeight >= scrollHeight - 100) {
        console.log('滚动到接近底部，触发加载更多历史评论');
        this.loadHistoricalComments(true); // 加载更多
      }
    },

    // 处理用户历史记录列表的滚动事件，用于加载更多历史记录
    handleUserHistoryScroll() {
      const scrollContainer = this.$refs.userHistoryScrollContainer;
      if (!scrollContainer) return;

      const scrollTop = scrollContainer.scrollTop;
      const scrollHeight = scrollContainer.scrollHeight;
      const clientHeight = scrollContainer.clientHeight;

      // 当滚动到距离底部100px时触发加载更多用户历史记录
      if (scrollTop + clientHeight >= scrollHeight - 100) {
        console.log('滚动到用户历史记录列表底部，触发加载更多历史记录');
        this.loadMoreUserHistory(); // 加载更多用户历史记录
      }
    },

    // ===== 话术建议相关方法 =====
    
    // 获取AI话术建议
    async getAIResponse(messageObj) {
      try {
        console.log('发送AI响应请求:', messageObj);
        
        const requestBody = {
          inputs: {
            target_lang: '英文',
            reply_pronounce_lang: '罗马音配音',
            broadcast_style: '幽默、专业且风趣',
            image_consiousness: '友好',
          },
          query: (messageObj && messageObj.text) || '没有新的评论，随便聊点什么吧',
          response_mode: 'blocking',
          user: (messageObj && messageObj.userName) || 'live-plugin-user',
          conversation_id: '',
        };

        console.log('请求体:', JSON.stringify(requestBody, null, 2));

        const response = await fetch('https://api.dify.ai/v1/chat-messages', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer app-65FthrSOVGEXTmHBoWL4Ultn',
          },
          body: JSON.stringify(requestBody),
        });

        console.log('API响应状态:', response.status, response.statusText);

        if (!response.ok) {
          const errorText = await response.text();
          console.error('API响应错误内容:', errorText);
          throw new Error(`HTTP error! status: ${response.status}, body: ${errorText}`);
        }

        const data = await response.json();
        console.log('AI响应数据:', data);

        if (data.answer) {
          console.log('成功获取AI响应，内容长度:', data.answer.length);
          return data.answer;
        } else {
          console.error('API响应格式错误，缺少answer字段:', data);
          return null;
        }
      } catch (error) {
        console.error('获取AI响应失败:', error);
        return null;
      }
    },

    // 分割话术建议为多条记录
    splitSuggestions(answer) {
      if (!answer) return [];
      
      // 使用正则表达式分割，匹配"【原文 - "但不匹配"【原文 - 翻译-"
      const suggestionParts = answer.split(/(?=【原文 - (?!翻译-))/);
      return suggestionParts.filter(part => part.trim().length > 0);
    },

    // 处理AI响应并显示话术建议
    handleAIResponse(answer, isSingleSuggestion = false) {
      console.log('handleAIResponse被调用，参数:', { 
        answerLength: answer ? answer.length : 0, 
        isSingleSuggestion,
        answerPreview: answer ? answer.substring(0, 100) + '...' : 'null'
      });
      
      if (!answer || answer.trim() === '') {
        console.error('handleAIResponse: 答案内容为空');
        this.showSuggestion('获取话术建议失败：内容为空');
        return;
      }
      
      this.suggestions = this.splitSuggestions(answer);
      this.currentSuggestionIndex = 0;
      
      console.log('分割后的建议数量:', this.suggestions.length);
      if (this.suggestions.length > 0) {
        console.log('第一条建议内容:', this.suggestions[0].substring(0, 100) + '...');
      }
      
      if (this.suggestions.length > 0) {
        this.showSuggestion(this.suggestions[0]);
        
        // 如果是单条建议，设置计时器保护显示
        if (isSingleSuggestion) {
          this.isShowingSingleSuggestion = true;
          console.log('设置单条建议保护期，25秒');
          
          // 清除之前的计时器
          if (this.singleSuggestionTimer) {
            clearTimeout(this.singleSuggestionTimer);
          }
          
          // 设置25秒的保护时间
          this.singleSuggestionTimer = setTimeout(() => {
            this.isShowingSingleSuggestion = false;
            console.log('单条话术建议保护期结束');
            
            // 检查是否有待处理的批量建议
            if (this.pendingBatchSuggestion) {
              console.log('处理缓存的批量话术建议');
              this.handleAIResponse(this.pendingBatchSuggestion);
              this.pendingBatchSuggestion = null;
            }
          }, 25000); // 25秒
        }
      } else {
        console.log('没有有效的建议内容，显示默认消息');
        this.showSuggestion('暂无话术建议');
      }
    },

    // 显示话术建议到右栏
    showSuggestion(suggestion) {
      if (!suggestion) {
        // 清空话术建议显示
        this.selectedUser.sameLanguageResponse = '暂无话术建议';
        this.selectedUser.differentLanguageResponse = '暂无话术建议';
        this.selectedUser.phoneticGuide = '';
        this.selectedUser.translation = '';
        return;
      }

      // 提取优先级评分
      const priorityMatch = suggestion.match(/【优先级】([0-9.]+)/);
      let priorityRating = 0;
      if (priorityMatch) {
        priorityRating = Math.round(parseFloat(priorityMatch[1]));
      }

      // 提取用户原文
      const originalMessageMatch = suggestion.match(/【原文 - (?!翻译)(.*?)】([^【]+)/);
      if (originalMessageMatch) {
        // 提取纯文本内容，去除HTML标签
        const cleanMessage = originalMessageMatch[2].trim().replace(/<[^>]*>/g, '');
        this.selectedUser.message = cleanMessage;
      }

      // 提取用户翻译
      const translationMatch = suggestion.match(/【原文 - 翻译-(.*?)】([^【]+)/);
      if (translationMatch) {
        // 提取纯文本内容，去除HTML标签
        const cleanTranslation = translationMatch[2].trim().replace(/<[^>]*>/g, '');
        this.selectedUser.translation = cleanTranslation;
      }

      // 提取建议话术原文
      const suggestionMatch = suggestion.match(/【建议话术 - 原文 - (.*?)】([^【]+)/);
      if (suggestionMatch) {
        // 提取纯文本内容，去除HTML标签
        const cleanText = suggestionMatch[2].trim().replace(/<[^>]*>/g, '');
        this.selectedUser.differentLanguageResponse = cleanText;
      }

      // 提取罗马音
      const phoneticMatch = suggestion.match(/【建议话术 - 原文 - 罗马音配音】([^【]+)/);
      if (phoneticMatch) {
        // 提取纯文本内容，去除HTML标签
        const cleanPhonetic = phoneticMatch[1].trim().replace(/<[^>]*>/g, '');
        this.selectedUser.phoneticGuide = cleanPhonetic;
      }

      // 提取建议话术翻译
      const suggestionTranslationMatch = suggestion.match(/【建议话术 - 翻译 - (.*?)】([^【]+)/);
      if (suggestionTranslationMatch) {
        // 提取纯文本内容，去除HTML标签
        const cleanTranslation = suggestionTranslationMatch[2].trim().replace(/<[^>]*>/g, '');
        this.selectedUser.translation = cleanTranslation;
      }

      // 构建 Same Language 响应 - 使用纯文本
      let sameLanguageResponse = '';
      if (priorityRating > 0) {
        sameLanguageResponse += `优先级: ${'★'.repeat(priorityRating)}${'☆'.repeat(5 - priorityRating)}\n\n`;
      }
      if (suggestionMatch) {
        const cleanSuggestion = suggestionMatch[2].trim().replace(/<[^>]*>/g, '');
        sameLanguageResponse += cleanSuggestion;
      }

      // 构建 Different Language 响应 - 使用纯文本
      let differentLanguageResponse = '';
      if (priorityRating > 0) {
        differentLanguageResponse += `优先级: ${'★'.repeat(priorityRating)}${'☆'.repeat(5 - priorityRating)}\n\n`;
      }
      if (suggestionMatch) {
        const cleanSuggestion = suggestionMatch[2].trim().replace(/<[^>]*>/g, '');
        differentLanguageResponse += cleanSuggestion;
      }

      // 保存优先级评分到selectedUser对象
      this.selectedUser.priorityRating = priorityRating;
      
      // 更新右栏内容
      this.selectedUser.sameLanguageResponse = sameLanguageResponse || '暂无话术建议';
      this.selectedUser.differentLanguageResponse = differentLanguageResponse || '暂无话术建议';
    },

    // 处理单条消息的话术建议
    async handleSingleMessageSuggestion(message) {
      console.log('=== 开始处理单条消息话术建议 ===');
      console.log('消息对象:', message);
      
      // 立即更新Priority Target区域显示用户信息
      this.updatePriorityTargetWithUserInfo(message);
      
      // 立即翻译评论原文，无需等待话术建议接口返回
      if (message.content && message.content !== '暂无消息内容') {
        console.log('立即翻译评论原文:', message.content);
        this.translateSingleComment(message.content);
      }
      
      try {
        // 获取katoken
        const katoken = localStorage.getItem('katoken');
        if (!katoken) {
          console.error('未找到katoken，无法调用话术建议接口');
          this.showSuggestion('请先登录后再获取话术建议');
          return;
        }

        // 构建新的接口请求体格式 - 使用新的generate-by-comment接口
        // 处理commentId，移除可能存在的"_historical"后缀
        let commentId = message.id || 0;
        if (typeof commentId === 'string' && commentId.includes('_historical')) {
          commentId = commentId.replace('_historical', '');
          console.log('处理历史评论ID，移除_historical后缀，原始ID:', message.id, '处理后ID:', commentId);
        }
        
        const requestBody = {
          liveRoomId: message.roomId || this.currentRoomId,
          sessionId: message.sessionId || this.currentSessionId,
          commentId: commentId // 使用处理后的评论ID
          // llmModelName: 'gemini-2.5-flash' // 后台自动选择大模型，无需指定
        };
        
        console.log('构建的请求体:', JSON.stringify(requestBody, null, 2));

        // 调用新的话术建议接口
        console.log('发送fetch请求到新的话术建议接口...');
        const response = await fetch(getApiUrl('SCRIPT_GENERATION_GENERATE_BY_COMMENT'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'req_app_id': 'LivePlugin',
            'req_app_secret': 'ewMpjg7t4vX5bK13oRZzSB8mEuNGr2Yy',
            'katoken': katoken
          },
          body: JSON.stringify(requestBody),
        });

        console.log('API响应状态:', response.status, response.statusText);

        if (!response.ok) {
          const errorText = await response.text();
          console.error('API响应错误内容:', errorText);
          throw new Error(`HTTP error! status: ${response.status}, body: ${errorText}`);
        }

        console.log('开始解析API响应JSON...');
        const data = await response.json();
        console.log('单条建议API响应数据:', data);
        
        // 详细检查API响应结构
        console.log('API响应结构检查:');
        console.log('- data.success:', data.success);
        console.log('- data.data:', data.data);
        console.log('- data.data.success:', data.data && data.data.success);
        console.log('- data.data.scripts:', data.data && data.data.scripts);
        console.log('- data.data.scripts类型:', data.data && data.data.scripts ? typeof data.data.scripts : 'undefined');
        console.log('- data.data.scripts长度:', data.data && data.data.scripts ? data.data.scripts.length : 0);
        console.log('- data.data.errorMessage:', data.data && data.data.errorMessage);
        
        // 检查API响应是否成功（外层success为true，内层data.success也为true）
        if (data.success && data.data && data.data.success === true && data.data.scripts && Array.isArray(data.data.scripts) && data.data.scripts.length > 0) {
          console.log('API响应包含话术数据，脚本数量:', data.data.scripts.length);
          
          // 处理第一个脚本数据
          const scriptText = data.data.scripts[0];
          console.log('话术内容类型:', typeof scriptText);
          console.log('话术内容长度:', scriptText ? scriptText.length : 0);
          console.log('话术内容:', scriptText);
          
          // 解析新的话术格式并显示到Priority Target区域
          this.parseAndDisplayScriptSuggestion(scriptText, message);
          
        } else if (data.success && data.data && data.data.success === false) {
          // API调用失败，显示错误信息
          console.error('API调用失败:', data.data.errorMessage);
          const errorMessage = data.data.errorMessage || '获取话术建议失败';

          // 即使API失败，也显示用户的完整信息
          // 如果API返回了userDescription，使用它作为额外的上下文信息
          let extraContext = '';
          if (data.data.description && data.data.description !== message.content) {
            extraContext = ` (请求内容: ${data.data.description})`;
          }

          // 用户友好的错误信息处理
          let userFriendlyErrorMessage = '获取话术建议失败';
          if (data.data.errorMessage && data.data.errorMessage.includes('429 Too Many Requests')) {
            userFriendlyErrorMessage = '生成频率过快，请稍后再试';
          } else if (data.data.errorMessage && data.data.errorMessage.includes('Quota exceeded')) {
            userFriendlyErrorMessage = 'API调用额度不足，请检查配额';
          } else if (data.data.errorMessage && data.data.errorMessage.length > 50) {
            // 如果错误信息太长，只显示开头部分
            userFriendlyErrorMessage = data.data.errorMessage.substring(0, 50) + '...';
          } else {
            userFriendlyErrorMessage = data.data.errorMessage || '获取话术建议失败';
          }

          // 确保Priority Target区域显示完整的用户信息
          // 使用当前已存在的selectedUser信息，仅更新响应内容
          this.selectedUser.sameLanguageResponse = `❌ ${userFriendlyErrorMessage}${extraContext}`;
          this.selectedUser.differentLanguageResponse = `❌ ${userFriendlyErrorMessage}${extraContext}`;
          this.selectedUser.phoneticGuide = '';
          this.selectedUser.translation = '';
          this.selectedUser.tag = '查看话术建议';
          this.selectedUser.priorityRating = 0;

          console.log('API调用失败，已在现有用户信息基础上显示错误信息');

        } else {
          console.error('API响应格式错误或无数据:', data);
          console.error('可能的原因:');
          console.error('- data.success 为 false:', !data.success);
          console.error('- data.data 不存在:', !data.data);
          console.error('- data.data.success 为 false:', data.data && data.data.success === false);
          console.error('- data.data.scripts 不存在:', !(data.data && data.data.scripts));
          console.error('- data.data.scripts 不是数组:', !(data.data && data.data.scripts && Array.isArray(data.data.scripts)));
          console.error('- data.data.scripts 为空数组:', data.data && data.data.scripts && data.data.scripts.length === 0);
          
          // 显示通用的错误信息
          this.showSuggestion('获取话术建议失败，请重试');
        }
      } catch (error) {
        console.error('获取单条消息话术建议失败:', error);
        console.error('错误类型:', error.constructor.name);
        console.error('错误消息:', error.message);
        console.error('错误堆栈:', error.stack);
        this.showSuggestion('请求话术建议时出错: ' + error.message);
      }
      
      console.log('=== 单条消息话术建议处理结束 ===');
    },

    // 立即更新Priority Target区域显示用户信息
    updatePriorityTargetWithUserInfo(message) {
      console.log('立即更新Priority Target区域用户信息:', message.name, message.avatar);
      
      this.selectedUserId = message.id;
      this.selectedUser = {
        name: message.name || '用户',
        avatar: message.avatar || this.getUserAvatarUrl(),
        message: message.content || '暂无消息内容',
        interactionProbability: '-',
        previousAppearances: '-',
        tag: '等待话术建议',
        sameLanguageResponse: '正在获取话术建议...',
        differentLanguageResponse: '正在获取话术建议...',
        phoneticGuide: '',
        translation: '',
        priorityRating: 0
      };
      
      console.log('Priority Target区域已更新用户信息');
    },

    // 解析并显示话术建议到Priority Target区域
    parseAndDisplayScriptSuggestion(scriptText, message) {
      try {
        console.log('开始解析话术建议文本:', scriptText);
        
        // 先提取罗马音，然后再处理HTML格式
        const { japaneseText, phoneticText } = this.extractJapaneseAndPhonetic(scriptText);
        
        // 处理话术建议中的换行符
        const processedScriptText = this.processScriptLineBreaks(japaneseText);
        
        console.log('解析结果:', {
          originalScriptText: scriptText,
          japaneseText: japaneseText,
          phoneticText: phoneticText,
          processedScriptText: processedScriptText,
          originalMessage: message.content
        });
        
        // 查找用户在潜在赞助者列表中的真实概率
        const userProbability = this.findUserProbability(message.name);
        
        // 更新Priority Target区域
        this.selectedUserId = message.id;
        this.selectedUser = {
          name: message.name || '用户',
          avatar: message.avatar || this.getUserAvatarUrl(),
          message: message.content || '暂无消息内容',
          interactionProbability: userProbability,
          previousAppearances: '1',
          tag: '话术建议',
          sameLanguageResponse: processedScriptText,
          differentLanguageResponse: japaneseText, // 使用原始日文文本，不包含HTML标签
          phoneticGuide: phoneticText || '',
          translation: '',
          priorityRating: 0 // 设置为0，表示没有评分
        };
        
        console.log('成功更新Priority Target区域');
        
        // 修复：话术建议显示完成后，如果当前是Different Language模式，自动触发翻译
        if (this.languageMode === 'different') {
          console.log('话术建议已显示，自动触发翻译');
          this.$nextTick(() => {
            setTimeout(() => {
              this.translateSuggestion();
            }, 500); // 延迟500ms确保DOM已更新
          });
        }
        
      } catch (error) {
        console.error('解析话术建议失败:', error);
        this.showSuggestion('解析话术建议时出错: ' + error.message);
      }
    },
    
    // 提取日文文本和罗马音
    extractJapaneseAndPhonetic(scriptText) {
      if (!scriptText) return { japaneseText: '', phoneticText: '' };
      
      console.log('提取日文和罗马音，原始文本:', scriptText);
      
      let japaneseText = scriptText;
      let phoneticText = '';
      
      // 尝试多种格式的解析
      
      // 格式1：日文格式 [話術]：内容\n[ローマ字]：内容
      const japaneseScriptMatch = scriptText.match(/\[話術\]：(.*?)(?:\n|$)/);
      const japanesePhoneticMatch = scriptText.match(/\[ローマ字\]：(.*?)(?:\n|$)/);
      
      if (japaneseScriptMatch && japanesePhoneticMatch) {
        // 日文格式，分别提取话术和罗马音
        japaneseText = japaneseScriptMatch[1].trim();
        phoneticText = japanesePhoneticMatch[1].trim();
        console.log('日文格式提取成功 - 话术:', japaneseText, '罗马音:', phoneticText);
      } 
      // 格式2：中文格式 [话术]：内容\n[罗马音]：内容
      else if (scriptText.match(/\[话术\]：(.*?)(?:\n|$)/) && scriptText.match(/\[罗马音\]：(.*?)(?:\n|$)/)) {
        const chineseScriptMatch = scriptText.match(/\[话术\]：(.*?)(?:\n|$)/);
        const chinesePhoneticMatch = scriptText.match(/\[罗马音\]：(.*?)(?:\n|$)/);
        
        japaneseText = chineseScriptMatch[1].trim();
        phoneticText = chinesePhoneticMatch[1].trim();
        console.log('中文格式提取成功 - 话术:', japaneseText, '罗马音:', phoneticText);
      }
      // 格式3：只有话术，没有罗马音
      else if (scriptText.match(/\[話術\]：(.*?)(?:\n|$)/)) {
        japaneseText = scriptText.match(/\[話術\]：(.*?)(?:\n|$)/)[1].trim();
        console.log('只有话术格式提取成功 - 话术:', japaneseText);
      }
      else if (scriptText.match(/\[话术\]：(.*?)(?:\n|$)/)) {
        japaneseText = scriptText.match(/\[话术\]：(.*?)(?:\n|$)/)[1].trim();
        console.log('只有话术格式提取成功 - 话术:', japaneseText);
      }
      // 格式4：尝试其他可能的格式
      else {
        console.log('非标准格式，尝试其他解析方式');
        // 如果无法解析，将整个文本作为话术内容
        japaneseText = scriptText;
        console.log('使用完整文本作为话术:', japaneseText);
      }
      
      return { japaneseText, phoneticText };
    },

    // 处理话术建议中的换行符
    processScriptLineBreaks(scriptText) {
      if (!scriptText) return '暂无话术建议';
      
      console.log('处理话术建议换行符，原始文本:', scriptText);
      
      // 处理常见的格式：[话术]：内容\n[罗马音]：内容
      // 将换行符转换为HTML换行标签，以便在页面上正确显示
      let processedText = scriptText;
      
      // 首先检查是否是标准格式：[话术]：内容\n[罗马音]：内容
      const scriptMatch = scriptText.match(/\[话术\]：(.*?)(?:\n|$)/);
      const phoneticMatch = scriptText.match(/\[罗马音\]：(.*?)(?:\n|$)/);
      
      if (scriptMatch && phoneticMatch) {
        // 标准格式，分别提取话术和罗马音
        const scriptContent = scriptMatch[1].trim();
        const phoneticContent = phoneticMatch[1].trim();
        
        processedText = `${scriptContent}<br><br><span style="color: #94a3b8; font-size: 14px;">罗马音: ${phoneticContent}</span>`;
        console.log('标准格式处理完成:', processedText);
      } else {
        // 非标准格式，直接处理换行符
        processedText = scriptText.replace(/\n/g, '<br>');
        console.log('非标准格式处理完成:', processedText);
      }
      
      return processedText;
    },

    // 检查是否有等待处理脚本生成请求
    checkScriptGenerationPending() {
      try {
        const scriptGenerationPending = localStorage.getItem('scriptGenerationPending');
        if (scriptGenerationPending) {
          console.log('检测到等待处理的脚本生成请求:', scriptGenerationPending);

          const userInfo = JSON.parse(scriptGenerationPending);

          // 立即显示用户信息到Priority Target区域
          this.selectedUserId = 'script_generation_' + Date.now();
          this.selectedUser = {
            name: userInfo.userName || '用户',
            avatar: userInfo.userAvatar || this.getUserAvatarUrl(),
            message: userInfo.prompt || '暂无消息内容',
            interactionProbability: '-',
            previousAppearances: '-',
            tag: '脚本生成',
            sameLanguageResponse: '正在生成脚本...',
            differentLanguageResponse: '正在生成脚本...',
            phoneticGuide: '',
            translation: '',
            priorityRating: 0
          };

          console.log('已显示用户信息和Original Message，准备调用API');

          // 清除localStorage中的数据，避免重复处理
          localStorage.removeItem('scriptGenerationPending');

          // 异步调用API并更新Suggested Response
          this.callScriptGenerationAPIForPriorityTarget(userInfo.prompt);
        }
      } catch (error) {
        console.error('检查脚本生成请求失败:', error);
      }
    },

    // 字体大小控制方法
    increaseFontSize() {
      if (this.fontSize < this.maxFontSize) {
        this.fontSize += 2;
      }
    },
    decreaseFontSize() {
      if (this.fontSize > this.minFontSize) {
        this.fontSize -= 2;
      }
    },

    // 语言显示名称
    getLanguageDisplayName(languageCode) {
      const languageMap = {
        'zh': '中文',
        'en': '英文',
        'ja': '日文'
      };
      return languageMap[languageCode] || languageCode;
    },

    // 处理语言切换
    handleLanguageChange() {
      console.log('语言切换:', this.selectedSourceLanguage, '->', this.selectedTargetLanguage);
      
      // 保存语言选择到本地存储
      localStorage.setItem('dashboard_source_language', this.selectedSourceLanguage);
      localStorage.setItem('dashboard_target_language', this.selectedTargetLanguage);
      console.log('语言选择已保存到本地存储');
      
      // 触发翻译更新
      this.autoTranslateOnModeChange();
    },

    // 模式切换时自动翻译
    async autoTranslateOnModeChange() {
      console.log('自动翻译模式切换，触发翻译');
      
      if (this.languageMode === 'different') {
        // 当切换到Different Language模式时，立即翻译当前显示的内容
        await this.translateCurrentContent();
        
        // 同时翻译所有现有的评论（实时评论和历史评论）
        console.log('开始翻译所有现有评论');
        await this.translateAllExistingComments();
      }
    },
    
    // 翻译所有现有评论
    async translateAllExistingComments() {
      try {
        console.log('开始翻译所有现有评论');
        console.log('实时评论数量:', this.activities.length);
        console.log('历史评论数量:', this.historicalComments.length);
        
        // 翻译实时评论
        for (const activity of this.activities) {
          if (activity.content && activity.content.trim() && !activity.translatedContent) {
            console.log('翻译实时评论:', activity.content.substring(0, 50));
            await this.translateCommentImmediately(activity.content, activity.id);
          }
        }
        
        // 翻译历史评论
        for (const comment of this.historicalComments) {
          if (comment.content && comment.content.trim() && !comment.translatedContent) {
            console.log('翻译历史评论:', comment.content.substring(0, 50));
            comment.isTranslating = true;
            try {
              const translation = await this.callTranslationAPI(
                comment.content,
                this.selectedSourceLanguage,
                this.selectedTargetLanguage
              );
              
              if (translation) {
                comment.translatedContent = translation;
                console.log('历史评论翻译成功:', comment.content.substring(0, 50), '->', translation.substring(0, 50));
              }
            } catch (error) {
              console.error('翻译历史评论失败:', error);
              comment.translatedContent = '翻译失败';
            } finally {
              comment.isTranslating = false;
            }
          }
        }
        
        // 强制触发Vue响应式更新
        this.activities = [...this.activities];
        this.historicalComments = [...this.historicalComments];
        
        console.log('所有现有评论翻译完成');
      } catch (error) {
        console.error('翻译所有现有评论失败:', error);
      }
    },

    // 翻译话术建议 - 独立方法，不与实时翻译混在一起
    async translateSuggestion() {
      try {
        console.log('=== 开始独立翻译话术建议 ===');
        
        // 只翻译话术建议，不翻译用户消息
        if (this.selectedUser.differentLanguageResponse &&
            this.selectedUser.differentLanguageResponse !== '暂无话术建议' &&
            this.selectedUser.differentLanguageResponse !== '正在获取话术建议...') {
          console.log('翻译话术建议:', this.selectedUser.differentLanguageResponse);
          const suggestionTranslation = await this.callTranslationAPI(
            this.selectedUser.differentLanguageResponse,
            this.selectedSourceLanguage,
            this.selectedTargetLanguage
          );
          
          if (suggestionTranslation) {
            this.selectedUser.suggestionTranslation = suggestionTranslation;
            console.log('✅ 话术建议翻译成功:', suggestionTranslation);
          } else {
            this.selectedUser.suggestionTranslation = '翻译失败';
            console.error('❌ 话术建议翻译失败');
          }
        } else {
          console.log('跳过话术建议翻译 - 话术为空或默认话术');
        }

        console.log('=== 话术建议独立翻译完成 ===');

      } catch (error) {
        console.error('❌ 独立翻译话术建议失败:', error);
      }
    },

      // 立即翻译评论原文
      async translateCommentImmediately(commentText, commentId = null) {
        try {
          console.log('立即翻译评论原文:', commentText, '评论ID:', commentId);

          if (!commentText || commentText.trim() === '') {
            console.log('评论内容为空，跳过翻译');
            return;
          }

          // 立即调用翻译API翻译评论原文
          const commentTranslation = await this.callTranslationAPI(
            commentText,
            this.selectedSourceLanguage,
            this.selectedTargetLanguage
          );

          if (commentTranslation) {
            console.log('✅ 评论原文立即翻译成功:', commentTranslation);

            // 如果提供了评论ID，更新对应的活动对象的翻译内容
            if (commentId) {
              // 在实时评论中查找
              const activityIndex = this.activities.findIndex(a => a.id === commentId);
              if (activityIndex !== -1) {
                this.activities[activityIndex].translatedContent = commentTranslation;
                console.log('✅ 实时评论翻译内容已更新');
              } else {
                // 在历史评论中查找
                const historicalIndex = this.historicalComments.findIndex(a => a.id === commentId);
                if (historicalIndex !== -1) {
                  this.historicalComments[historicalIndex].translatedContent = commentTranslation;
                  console.log('✅ 历史评论翻译内容已更新');
                } else {
                  console.log('⚠️ 未找到对应的评论，无法更新翻译内容');
                }
              }
            }

            // 同时更新originalTranslation，用于Priority Target区域
            // this.selectedUser.originalTranslation = commentTranslation;
          } else {
            console.error('❌ 评论原文立即翻译失败');
            // this.selectedUser.originalTranslation = '翻译失败';
          }
        } catch (error) {
          console.error('立即翻译评论原文失败:', error);
          // this.selectedUser.originalTranslation = '翻译失败';
        }
      },

    // 立即翻译提供给话术建议的原文
    async translateSingleComment(commentText, commentId = null) {
      try {
        console.log('立即翻译评论原文:', commentText, '评论ID:', commentId);
        
        if (!commentText || commentText.trim() === '') {
          console.log('评论内容为空，跳过翻译');
          return;
        }

        // 立即调用翻译API翻译评论原文
        const commentTranslation = await this.callTranslationAPI(
          commentText,
          this.selectedSourceLanguage,
          this.selectedTargetLanguage
        );
        
        if (commentTranslation) {
          console.log('✅ 评论原文立即翻译成功:', commentTranslation);
          
          // 如果提供了评论ID，更新对应的活动对象的翻译内容
          if (commentId) {
            // 在实时评论中查找
            const activityIndex = this.activities.findIndex(a => a.id === commentId);
            if (activityIndex !== -1) {
              this.activities[activityIndex].translatedContent = commentTranslation;
              console.log('✅ 实时评论翻译内容已更新');
            } else {
              // 在历史评论中查找
              const historicalIndex = this.historicalComments.findIndex(a => a.id === commentId);
              if (historicalIndex !== -1) {
                this.historicalComments[historicalIndex].translatedContent = commentTranslation;
                console.log('✅ 历史评论翻译内容已更新');
              } else {
                console.log('⚠️ 未找到对应的评论，无法更新翻译内容');
              }
            }
          }
          
          // 同时更新originalTranslation，用于Priority Target区域
          this.selectedUser.originalTranslation = commentTranslation;
        } else {
          console.error('❌ 评论原文立即翻译失败');
          // this.selectedUser.originalTranslation = '翻译失败';
        }
      } catch (error) {
        console.error('立即翻译评论原文失败:', error);
        this.selectedUser.originalTranslation = '翻译失败';
      }
    },

    // 翻译当前显示的内容
    async translateCurrentContent() {
      try {
        console.log('=== 开始翻译当前显示的内容 ===');
        
        // 翻译用户消息
        if (this.selectedUser.message && this.selectedUser.message !== '暂无用户消息') {
          console.log('翻译用户消息:', this.selectedUser.message);
          const messageTranslation = await this.callTranslationAPI(
            this.selectedUser.message,
            this.selectedSourceLanguage,
            this.selectedTargetLanguage
          );
          
          if (messageTranslation) {
            this.selectedUser.originalTranslation = messageTranslation;
            console.log('✅ 用户消息翻译成功:', messageTranslation);
          } else {
            this.originalTranslation = '翻译失败';
            console.error('❌ 用户消息翻译失败');
          }
        } else {
          console.log('跳过用户消息翻译 - 消息为空或默认消息');
        }

        // 翻译话术建议
        if (this.selectedUser.differentLanguageResponse && 
            this.selectedUser.differentLanguageResponse !== '暂无话术建议' &&
            this.selectedUser.differentLanguageResponse !== '正在获取话术建议...') {
          console.log('翻译话术建议:', this.selectedUser.differentLanguageResponse);
          const suggestionTranslation = await this.callTranslationAPI(
            this.selectedUser.differentLanguageResponse,
            this.selectedSourceLanguage,
            this.selectedTargetLanguage
          );
          
          if (suggestionTranslation) {
            this.selectedUser.suggestionTranslation = suggestionTranslation;
            console.log('✅ 话术建议翻译成功:', suggestionTranslation);
          } else {
            this.selectedUser.suggestionTranslation = '翻译失败';
            console.error('❌ 话术建议翻译失败');
          }
        } else {
          console.log('跳过话术建议翻译 - 话术为空或默认话术');
        }

        console.log('=== 当前内容翻译完成 ===');

      } catch (error) {
        console.error('❌ 翻译当前内容失败:', error);
      }
    },

    // 调用翻译API
    async callTranslationAPI(text, sourceLang, targetLang) {
      console.log('=== 开始调用翻译API ===');
      console.log('翻译文本:', text);
      console.log('源语言:', sourceLang);
      console.log('目标语言:', targetLang);
      
      if (!text || text.trim() === '') {
        console.warn('翻译文本为空');
        return '';
      }
      
      try {
        // 设置翻译状态
        this.isTranslating = true;
        
        // 构建翻译请求 - 使用正确的请求体格式
        const requestBody = {
          sourceText: text,
          source: sourceLang,
          target: targetLang,
          fromProductDTO: {
            productType: "100106"
          },
          accessAppId: "WithIM_WEB",
          accessAppSecret: "Abut9y1Rv45pJCek"
        };
        
        console.log('发送翻译请求体:', requestBody);
        
        // 获取katoken用于认证
        const katoken = localStorage.getItem('katoken');
        console.log('使用的katoken:', katoken ? '已获取' : '未获取');
        
        // 构建完整的API URL
        const apiUrl = getApiUrl('UTIP_TRANS_TEXT');
        console.log('翻译API URL:', apiUrl);
        
        // 调用UTIP翻译API - 使用特殊的认证信息
        console.log('开始发送fetch请求...');
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'req_app_id': 'K_SSO',
            'req_app_secret': 'S4PEisfzlx71yNv2',
            'katoken': katoken || ''
          },
          body: JSON.stringify(requestBody)
        });
        
        console.log('翻译API响应状态:', response.status, response.statusText);
        
        if (!response.ok) {
          const errorText = await response.text();
          console.error('翻译API请求失败:', response.status, errorText);
          throw new Error(`翻译API请求失败: ${response.status}`);
        }
        
        const data = await response.json();
        console.log('翻译API响应数据:', data);
        
        if (data.success && data.data && data.data.targetText) {
          console.log('✅ 翻译成功:', data.data.targetText);
          return data.data.targetText;
        } else {
          console.error('❌ 翻译API返回格式错误:', data);
          // 如果API不可用，返回一个简单的模拟翻译
          return this.getMockTranslation(text, sourceLang, targetLang);
        }
      } catch (error) {
        console.error('❌ 调用翻译API失败:', error);
        console.error('错误详情:', error.message);
        // 如果API调用失败，返回一个模拟翻译
        return this.getMockTranslation(text, sourceLang, targetLang);
      } finally {
        this.isTranslating = false;
        console.log('=== 翻译API调用结束 ===');
      }
    },
    
    // 获取模拟翻译（当真实API不可用时使用）
    getMockTranslation(text, sourceLang, targetLang) {
      const languageNames = {
        'zh': '中文',
        'en': '英文', 
        'ja': '日文'
      };
      
      const sourceName = languageNames[sourceLang] || sourceLang;
      const targetName = languageNames[targetLang] || targetLang;
      
      return `[${sourceName}->${targetName}] ${text}`;
    },

    // 获取潜在赞助者
    async fetchPotentialPatrons() {
      try {
        console.log('开始获取潜在赞助者列表');
        
        // 检查是否有必要的参数
        if (!this.currentRoomId || !this.currentSessionId) {
          console.warn('缺少房间ID或会话ID，无法获取潜在赞助者列表');
          return;
        }

        // 获取katoken用于认证
        const katoken = localStorage.getItem('katoken');
        if (!katoken) {
          console.error('未找到katoken，无法获取潜在赞助者列表');
          return;
        }

        // 构建请求参数 - 使用正确的时间格式
        const currentTime = new Date();
        // 格式化为 YYYY-MM-DD HH:mm:ss
        const year = currentTime.getFullYear();
        const month = String(currentTime.getMonth() + 1).padStart(2, '0');
        const day = String(currentTime.getDate()).padStart(2, '0');
        const hours = String(currentTime.getHours()).padStart(2, '0');
        const minutes = String(currentTime.getMinutes()).padStart(2, '0');
        const seconds = String(currentTime.getSeconds()).padStart(2, '0');
        const timeWindowEnd = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        const timeWindowDuration = 300; // 固定值300

        console.log('获取潜在赞助者参数:', {
          liveRoomId: this.currentRoomId,
          sessionId: this.currentSessionId,
          timeWindowEnd: timeWindowEnd,
          timeWindowDuration: timeWindowDuration
        });

        // 构建API URL - 使用用户打赏概率列表接口，包含timeWindowDuration参数
        const apiUrl = `${getApiUrl('USER_REWARD_PROBABILITY_LIST')}?liveRoomId=${this.currentRoomId}&sessionId=${this.currentSessionId}&timeWindowEnd=${encodeURIComponent(timeWindowEnd)}&timeWindowDuration=${timeWindowDuration}`;
        console.log('潜在赞助者API URL:', apiUrl);

        // 发送请求获取用户打赏概率列表
        const response = await fetch(apiUrl, {
          method: 'GET',
          headers: {
            'req_app_id': 'LivePlugin',
            'req_app_secret': 'ewMpjg7t4vX5bK13oRZzSB8mEuNGr2Yy',
            'katoken': katoken
          }
        });

        console.log('潜在赞助者API响应状态:', response.status);

        if (!response.ok) {
          const errorText = await response.text();
          console.error('获取潜在赞助者API请求失败:', response.status, errorText);
          return;
        }

        const data = await response.json();
        console.log('潜在赞助者API响应数据:', data);

        if (data.success && data.data && Array.isArray(data.data)) {
          // 处理API返回的数据
          this.potentialPatrons = data.data
            .map(item => ({
              userInfoId: item.userInfoId,
              userName: item.userName,
              rewardUserType: item.rewardUserType,
              rewardProbability: item.rewardProbability
            }))
            .sort((a, b) => b.rewardProbability - a.rewardProbability) // 按奖励概率降序排序
            .slice(0, 20); // 只取前20名

          console.log('成功获取潜在赞助者列表，数量:', this.potentialPatrons.length);
        } else {
          console.warn('获取潜在赞助者失败或无数据:', data);
          this.potentialPatrons = [];
        }

      } catch (error) {
        console.error('获取潜在赞助者列表失败:', error);
        this.potentialPatrons = [];
      }
    },

    // 启动潜在赞助者定时器
    startPotentialPatronsTimer() {
      console.log('启动潜在赞助者定时器');
      
      // 先清除可能存在的旧定时器
      if (this.potentialPatronsTimer) {
        clearInterval(this.potentialPatronsTimer);
        this.potentialPatronsTimer = null;
      }
      
      // 立即执行一次获取潜在赞助者列表
      this.fetchPotentialPatrons();
      
      // 设置定时器，每隔1分钟（60000毫秒）获取一次潜在赞助者列表
      this.potentialPatronsTimer = setInterval(() => {
        console.log('定时器触发：获取潜在赞助者列表');
        this.fetchPotentialPatrons();
      }, 60000); // 1分钟 = 60000毫秒
      
      console.log('潜在赞助者定时器已启动，间隔：1分钟');
    },

    // 加载更多用户历史记录
    async loadMoreUserHistory() {
      if (this.userHistoryLoadingMore || !this.hasMoreUserHistory) {
        return;
      }

      try {
        this.userHistoryLoadingMore = true;
        this.userHistoryPageIndex++;

        // 获取katoken用于认证
        const katoken = localStorage.getItem('katoken');
        if (!katoken) {
          console.error('未找到katoken，无法获取更多用户历史记录');
          this.userHistoryLoadingMore = false;
          return;
        }

        // 检查是否有必要的参数
        if (!this.currentRoomId || !this.currentSessionId) {
          console.error('缺少房间ID或会话ID，无法获取更多用户历史记录');
          this.userHistoryLoadingMore = false;
          return;
        }

        // 尝试从当前选中的用户消息中获取userInfoId
        let userInfoId = null;
        if (this.selectedUser.userInfoId) {
          userInfoId = this.selectedUser.userInfoId;
        } else {
          // 尝试从activities或historicalComments中查找该用户的userInfoId
          const allActivities = [...this.activities, ...this.historicalComments];
          const userActivity = allActivities.find(activity => 
            activity.name === this.selectedUser.name
          );
          if (userActivity && userActivity.userInfoId) {
            userInfoId = userActivity.userInfoId;
            console.log('从活动数据中找到userInfoId:', userInfoId);
          }
        }

        // 构建API请求参数 - 使用新的LIVE_COMMENT_LIST接口
        const requestBody = {
          liveRoomId: this.currentRoomId,
          sessionId: this.currentSessionId,
          userInfoId: userInfoId, // 使用找到的userInfoId
          pageSize: this.userHistoryPageSize,
          pageIndex: this.userHistoryPageIndex
        };

        console.log('加载更多用户历史记录请求参数:', requestBody);

        // 调用用户历史记录API - 使用新的LIVE_COMMENT_LIST接口
        const response = await fetch(getApiUrl('LIVE_COMMENT_LIST'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'req_app_id': 'LivePlugin',
            'req_app_secret': 'ewMpjg7t4vX5bK13oRZzSB8mEuNGr2Yy',
            'katoken': katoken
          },
          body: JSON.stringify(requestBody)
        });

        console.log('加载更多用户历史记录API响应状态:', response.status);

        if (!response.ok) {
          const errorText = await response.text();
          console.error('获取更多用户历史记录API请求失败:', response.status, errorText);
          this.userHistoryLoadingMore = false;
          return;
        }

        const data = await response.json();
        console.log('加载更多用户历史记录API响应数据:', data);

        if (data.success && data.data && Array.isArray(data.data)) {
          // 处理新获取的用户历史记录数据 - 根据接口返回的数据格式
          const newUserHistoryData = data.data.map(comment => ({
            id: comment.id || `history_${Date.now()}_${Math.random()}`,
            type: comment.messageType || 'message',
            content: comment.content || '暂无内容',
            timestamp: new Date(comment.commentTime).getTime(),
            giftName: comment.messageType === 'gift' ? this.extractGiftName(comment.content) : null,
            giftCount: comment.messageType === 'gift' ? this.extractGiftCount(comment.content) : null,
            giftValue: comment.messageType === 'gift' ? this.extractGiftValue(comment.content) : null,
            sessionId: this.currentSessionId,
            roomId: this.currentRoomId,
            nickname: comment.nickname,
            avatarUrl: comment.avatarUrl,
            userLevel: comment.userLevel,
            scripts: comment.scripts || []
          }));

          // 将新数据添加到现有数据中
          this.userHistoryData.push(...newUserHistoryData);
          console.log('成功加载更多用户历史记录，当前总数:', this.userHistoryData.length);
          
          // 检查是否还有更多数据
          this.hasMoreUserHistory = data.data.length >= this.userHistoryPageSize;
        } else {
          console.warn('获取更多用户历史记录失败或无数据:', data);
          this.hasMoreUserHistory = false;
        }

      } catch (error) {
        console.error('获取更多用户历史记录失败:', error);
        this.hasMoreUserHistory = false;
      } finally {
        this.userHistoryLoadingMore = false;
      }
    },

    // 加载用户历史互动记录
    async loadUserHistory() {
      try {
        console.log('开始加载用户历史互动记录:', this.selectedUser.name);
        
        // 设置加载状态
        this.userHistoryLoading = true;
        this.userHistoryData = [];
        this.userHistoryPageIndex = 1;
        this.hasMoreUserHistory = true;

        // 获取katoken用于认证
        const katoken = localStorage.getItem('katoken');
        if (!katoken) {
          console.error('未找到katoken，无法获取用户历史记录');
          this.userHistoryLoading = false;
          return;
        }

        // 检查是否有必要的参数
        if (!this.currentRoomId || !this.currentSessionId) {
          console.error('缺少房间ID或会话ID，无法获取用户历史记录');
          this.userHistoryLoading = false;
          return;
        }

        // 尝试从当前选中的用户消息中获取userInfoId
        let userInfoId = null;
        if (this.selectedUser.userInfoId) {
          userInfoId = this.selectedUser.userInfoId;
        } else {
          // 尝试从activities或historicalComments中查找该用户的userInfoId
          const allActivities = [...this.activities, ...this.historicalComments];
          const userActivity = allActivities.find(activity => 
            activity.name === this.selectedUser.name
          );
          if (userActivity && userActivity.userInfoId) {
            userInfoId = userActivity.userInfoId;
            console.log('从活动数据中找到userInfoId:', userInfoId);
          }
        }

        // 构建API请求参数 - 使用新的LIVE_COMMENT_LIST接口
        const requestBody = {
          liveRoomId: this.currentRoomId,
          sessionId: this.currentSessionId,
          userInfoId: userInfoId, // 使用找到的userInfoId
          pageSize: this.userHistoryPageSize,
          pageIndex: this.userHistoryPageIndex
        };

        console.log('用户历史记录请求参数:', requestBody);

        // 调用用户历史记录API - 使用新的LIVE_COMMENT_LIST接口
        const response = await fetch(getApiUrl('LIVE_COMMENT_LIST'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'req_app_id': 'LivePlugin',
            'req_app_secret': 'ewMpjg7t4vX5bK13oRZzSB8mEuNGr2Yy',
            'katoken': katoken
          },
          body: JSON.stringify(requestBody)
        });

        console.log('用户历史记录API响应状态:', response.status);

        if (!response.ok) {
          const errorText = await response.text();
          console.error('获取用户历史记录API请求失败:', response.status, errorText);
          this.userHistoryLoading = false;
          return;
        }

        const data = await response.json();
        console.log('用户历史记录API响应数据:', data);

        if (data.success && data.data && Array.isArray(data.data)) {
          // 处理用户历史记录数据 - 根据接口返回的数据格式
          this.userHistoryData = data.data.map(comment => ({
            id: comment.id || `history_${Date.now()}_${Math.random()}`,
            type: comment.messageType || 'message',
            content: comment.content || '暂无内容',
            timestamp: new Date(comment.commentTime).getTime(),
            giftName: comment.messageType === 'gift' ? this.extractGiftName(comment.content) : null,
            giftCount: comment.messageType === 'gift' ? this.extractGiftCount(comment.content) : null,
            giftValue: comment.messageType === 'gift' ? this.extractGiftValue(comment.content) : null,
            sessionId: this.currentSessionId,
            roomId: this.currentRoomId,
            nickname: comment.nickname,
            avatarUrl: comment.avatarUrl,
            userLevel: comment.userLevel,
            scripts: comment.scripts || []
          }));

          console.log('成功获取用户历史记录，数量:', this.userHistoryData.length);
          
          // 检查是否还有更多数据
          this.hasMoreUserHistory = data.data.length >= this.userHistoryPageSize;
        } else {
          console.warn('获取用户历史记录失败或无数据:', data);
          this.userHistoryData = [];
          this.hasMoreUserHistory = false;
        }

      } catch (error) {
        console.error('获取用户历史记录失败:', error);
        this.userHistoryData = [];
        this.hasMoreUserHistory = false;
      } finally {
        this.userHistoryLoading = false;
      }
    },

    // 立即显示用户填写的内容到Priority Target区域
    displayUserPromptInPriorityTarget(prompt) {
      try {
        console.log('立即显示用户填写的内容到Priority Target区域:', prompt);

        // 获取主播信息 - 使用直播间roomid作为昵称，使用App.vue中的默认头像
        const streamerInfo = this.getStreamerInfo();

        // 更新Priority Target区域，显示主播信息和用户填写的内容
        this.selectedUserId = 'user_prompt_' + Date.now();
        this.selectedUser = {
          name: streamerInfo.name || '主播',
          avatar: streamerInfo.avatar || '/avatar_default.png', // 使用App.vue中的默认头像
          message: prompt || '生成脚本描述',
          interactionProbability: '-',
          previousAppearances: '-',
          tag: '脚本生成',
          sameLanguageResponse: '正在生成脚本...',
          differentLanguageResponse: '正在生成脚本...',
          phoneticGuide: '',
          translation: '',
          priorityRating: 0
        };

        console.log('✅ 用户填写的内容已立即显示在Priority Target区域');

        // 如果当前是Different Language模式，立即翻译用户填写的内容
        if (this.languageMode === 'different') {
          console.log('当前是Different Language模式，立即翻译用户填写的内容');
          this.$nextTick(() => {
            setTimeout(() => {
              this.translateCommentImmediately(prompt);
            }, 100);
          });
        }

      } catch (error) {
        console.error('显示用户填写的内容失败:', error);
      }
    },

    // 将生成的脚本直接显示在Priority Target区域
    displayGeneratedScriptInPriorityTarget(scriptText, prompt) {
      try {
        console.log('将生成的脚本显示在Priority Target区域:', { scriptText, prompt });

        // 获取主播信息 - 从localStorage或其他地方获取
        // 这里暂时使用默认值，用户可以根据实际需求修改
        const streamerInfo = this.getStreamerInfo();

        // 处理脚本内容
        const processedScript = this.extractScriptContent(scriptText);

        // 更新Priority Target区域，显示主播信息
        this.selectedUserId = 'generated_script_' + Date.now();
        this.selectedUser = {
          name: streamerInfo.name || '主播',
          avatar: streamerInfo.avatar || this.getUserAvatarUrl(),
          message: prompt || '生成脚本描述',
          interactionProbability: '-',
          previousAppearances: '-',
          tag: '脚本生成',
          sameLanguageResponse: processedScript.sameLanguage,
          differentLanguageResponse: processedScript.differentLanguage,
          phoneticGuide: processedScript.phoneticGuide || '',
          translation: '',
          priorityRating: 0
        };

        console.log('成功将生成的脚本显示在Priority Target区域');

        // 如果当前是Different Language模式，自动翻译生成的内容
        if (this.languageMode === 'different') {
          console.log('当前是Different Language模式，自动翻译脚本');
          this.$nextTick(() => {
            setTimeout(() => {
              this.translateCurrentScriptContent();
            }, 500);
          });
        }

      } catch (error) {
        console.error('显示生成的脚本失败:', error);
      }
    },

    // 获取主播信息
    getStreamerInfo() {
      try {
        // 从localStorage或其他地方获取主播信息
        const streamerData = localStorage.getItem('currentStreamer') ||
                           localStorage.getItem('streamerInfo') ||
                           JSON.parse(localStorage.getItem('tiktok-binding-info') || '{}');

        // 获取直播间roomid - 优先从当前房间ID获取，如果没有则从streamerData中获取
        let roomId = this.currentRoomId;
        if (!roomId && streamerData && typeof streamerData === 'object') {
          roomId = streamerData.roomId || streamerData.bindingSource;
        }

        // 使用直播间roomid作为主播昵称
        const streamerName = roomId ? `${this.$t('app.room')}: ${roomId}` : this.$t('onAir.streamer');

        if (streamerData && typeof streamerData === 'object') {
          return {
            name: streamerName,
            avatar: streamerData.avatar || streamerData.avatarUrl || '/avatar_default.png',
            id: streamerData.id || streamerData.userId || null
          };
        }

        // 默认返回
        return {
          name: streamerName,
          avatar: '/avatar_default.png',
          id: null
        };
      } catch (error) {
        console.error('获取主播信息失败:', error);
        return { name: '主播', avatar: '/avatar_default.png', id: null };
      }
    },

    // 提取脚本内容
    extractScriptContent(scriptText) {
      if (!scriptText) {
        return {
          sameLanguage: this.$t('onAir.noScriptSuggestion'),
          differentLanguage: this.$t('onAir.noScriptSuggestion'),
          phoneticGuide: ''
        };
      }

      console.log('提取脚本内容，原始文本:', scriptText);

      // 解析generate-by-description接口返回的格式：[话术]：内容\n[罗马音]：内容
      const { japaneseText, phoneticText } = this.extractJapaneseAndPhonetic(scriptText);
      
      console.log('解析结果:', {
        originalScriptText: scriptText,
        japaneseText: japaneseText,
        phoneticText: phoneticText
      });

      // 处理话术文本中的换行符
      const processedScriptText = this.processScriptLineBreaks(japaneseText);

      return {
        sameLanguage: processedScriptText,
        differentLanguage: japaneseText,
        phoneticGuide: phoneticText
      };
    },

    // 为Priority Target区域调用脚本生成API
    async callScriptGenerationAPIForPriorityTarget(prompt) {
      try {
        console.log('开始为Priority Target区域调用脚本生成API, 提示词:', prompt);

        // 获取katoken用于认证
        const katoken = localStorage.getItem('katoken');
        if (!katoken) {
          console.error('未找到katoken，无法调用脚本生成API');

          // 更新Priority Target区域显示错误信息
          this.selectedUser.sameLanguageResponse = '请先登录后再生成脚本';
          this.selectedUser.differentLanguageResponse = '请先登录后再生成脚本';
          return;
        }

        // 确保有当前房间ID和会话ID
        if (!this.currentRoomId || !this.currentSessionId) {
          console.error('当前房间ID或会话ID不存在，无法生成脚本');

          // 更新Priority Target区域显示错误信息
          this.selectedUser.sameLanguageResponse = '请先连接直播间再生成脚本';
          this.selectedUser.differentLanguageResponse = '请先连接直播间再生成脚本';
          return;
        }

        // 更新状态显示正在生成
        this.selectedUser.sameLanguageResponse = '正在生成脚本...';
        this.selectedUser.differentLanguageResponse = '正在生成脚本...';

        // 构建请求体 - 使用正确的参数格式
        const requestBody = {
          liveRoomId: this.currentRoomId,
          sessionId: parseInt(this.currentSessionId), // 转换为数字
          description: prompt // 脚本描述
          // llmModelName: "gemini-2.5-flash" // 后台自动选择大模型，无需指定
        };

        console.log('构建的脚本生成请求体:', JSON.stringify(requestBody, null, 2));

        const apiUrl = getApiUrl('SCRIPT_GENERATION_GENERATE_BY_DESCRIPTION');
        console.log('脚本生成API URL:', apiUrl);

        // 发送请求
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'req_app_id': 'LivePlugin',
            'req_app_secret': 'ewMpjg7t4vX5bK13oRZzSB8mEuNGr2Yy',
            'katoken': katoken
          },
          body: JSON.stringify(requestBody)
        });

        console.log('脚本生成API响应状态:', response.status);

        if (!response.ok) {
          const errorText = await response.text();
          console.error('脚本生成API请求失败:', response.status, errorText);

          // 更新Priority Target区域显示错误信息
          this.selectedUser.sameLanguageResponse = `脚本生成失败: ${response.status}`;
          this.selectedUser.differentLanguageResponse = `脚本生成失败: ${response.status}`;
          throw new Error(`脚本生成API请求失败: ${response.status}`);
        }

        const data = await response.json();
        console.log('脚本生成API完整响应数据:', data);

        // 检查API是否成功
        if (data.success && data.data && data.data.success === true) {
          // API处理成功，检查是否有脚本内容
          let scriptText = null;

          if (data.data.scripts && Array.isArray(data.data.scripts) && data.data.scripts.length > 0) {
            // 新的API响应格式: data.data.scripts[0]
            scriptText = data.data.scripts[0];
            console.log('✅ 使用新的API响应格式获取脚本:', scriptText);
          } else if (data.data.script) {
            // 旧的API响应格式: data.data.script
            scriptText = data.data.script;
            console.log('✅ 使用旧的API响应格式获取脚本:', scriptText);
          }

          if (scriptText) {
            console.log('脚本生成成功，将脚本内容显示在Suggested Response中');

            // 处理脚本内容，处理换行符
            const processedScript = scriptText.replace(/\n/g, '<br>');
            console.log('处理后的脚本内容:', processedScript);

            // 更新Priority Target区域的Suggested Response
            this.selectedUser.sameLanguageResponse = processedScript;
            this.selectedUser.differentLanguageResponse = processedScript;

            console.log('✅ 脚本已成功显示在Priority Target区域的Suggested Response中');

            // 如果当前是Different Language模式，自动翻译生成的内容
            if (this.languageMode === 'different') {
              console.log('当前是Different Language模式，自动翻译脚本');
              this.$nextTick(() => {
                setTimeout(() => {
                  this.translateCurrentScriptContent();
                }, 500);
              });
            }
          } else {
            console.error('脚本生成API返回成功但无脚本内容:', data);

            // 更新Priority Target区域显示无内容提示
            this.selectedUser.sameLanguageResponse = '脚本生成失败：无脚本内容';
            this.selectedUser.differentLanguageResponse = '脚本生成失败：无脚本内容';
          }
        } else if (data.success && data.data && data.data.success === false && data.data.errorMessage) {
          // API处理失败，但有明确的错误信息（比如Gemini API的速率限制）
          console.error('脚本生成API处理失败:', data.data.errorMessage);

          // 提取错误信息的关键部分进行显示
          let errorMessage = '脚本生成失败';
          if (data.data.errorMessage.includes('429 Too Many Requests')) {
            errorMessage = '生成频率过快，请稍后再试';
          } else if (data.data.errorMessage.includes('Quota exceeded')) {
            errorMessage = 'API 调用额度不足，请检查配额';
          } else if (data.data.errorMessage.length > 50) {
            // 如果错误信息太长，只显示开头部分
            errorMessage = data.data.errorMessage.substring(0, 50) + '...';
          } else {
            errorMessage = data.data.errorMessage;
          }

          // 更新Priority Target区域显示具体的错误信息
          this.selectedUser.sameLanguageResponse = `脚本生成失败: ${errorMessage}`;
          this.selectedUser.differentLanguageResponse = `脚本生成失败: ${errorMessage}`;
        } else {
          console.error('脚本生成API返回格式错误或无数据:', data);

          // 更新Priority Target区域显示通用的错误信息
          this.selectedUser.sameLanguageResponse = '脚本生成失败：接口异常';
          this.selectedUser.differentLanguageResponse = '脚本生成失败：接口异常';
        }

      } catch (error) {
        console.error('调用脚本生成API失败:', error);

        // 更新Priority Target区域显示错误信息
        this.selectedUser.sameLanguageResponse = `脚本生成错误: ${error.message}`;
        this.selectedUser.differentLanguageResponse = `脚本生成错误: ${error.message}`;
      }
    },

    // 翻译当前显示的脚本内容
    async translateCurrentScriptContent() {
      try {
        console.log('=== 开始翻译当前显示的脚本内容 ===');

        // 翻译主播发的脚本描述
        if (this.selectedUser.message && this.selectedUser.message !== '生成脚本描述') {
          console.log('翻译脚本描述:', this.selectedUser.message);
          const promptTranslation = await this.callTranslationAPI(
            this.selectedUser.message,
            this.selectedSourceLanguage,
            this.selectedTargetLanguage
          );

          if (promptTranslation) {
            this.selectedUser.originalTranslation = promptTranslation;
            console.log('✅ 脚本描述翻译成功:', promptTranslation);
          } else {
            this.originalTranslation = '翻译失败';
            console.error('❌ 脚本描述翻译失败');
          }
        }

        // 翻译生成的脚本内容
        if (this.selectedUser.differentLanguageResponse &&
            this.selectedUser.differentLanguageResponse !== '暂无脚本内容') {
          console.log('翻译生成的脚本内容');
          // 移除HTML标签进行翻译
          const cleanScript = this.selectedUser.differentLanguageResponse.replace(/<[^>]*>/g, '');

          const scriptTranslation = await this.callTranslationAPI(
            cleanScript,
            this.selectedSourceLanguage,
            this.selectedTargetLanguage
          );

          if (scriptTranslation) {
            this.selectedUser.suggestionTranslation = scriptTranslation;
            console.log('✅ 生成的脚本内容翻译成功:', scriptTranslation);
          } else {
            this.selectedUser.suggestionTranslation = '翻译失败';
            console.error('❌ 生成的脚本内容翻译失败');
          }
        }

        console.log('=== 脚本内容翻译完成 ===');

      } catch (error) {
        console.error('❌ 翻译脚本内容失败:', error);
      }
    },

    // ===== 日历组件相关方法 =====

    // 切换到上一个月
    prevMonth() {
      const newMonth = new Date(this.currentMonth);
      newMonth.setMonth(newMonth.getMonth() - 1);
      this.currentMonth = newMonth;
      // 只更新日历标题，不立即生成日历，等待数据获取完成后再生成
      const monthNames = [
        this.$t('onAir.january'), this.$t('onAir.february'), this.$t('onAir.march'),
        this.$t('onAir.april'), this.$t('onAir.may'), this.$t('onAir.june'),
        this.$t('onAir.july'), this.$t('onAir.august'), this.$t('onAir.september'),
        this.$t('onAir.october'), this.$t('onAir.november'), this.$t('onAir.december')
      ];
      this.calendarTitle = `${monthNames[newMonth.getMonth()]} ${newMonth.getFullYear()}`;
      this.fetchAttendanceHistory();
    },

    // 切换到下一个月
    nextMonth() {
      const newMonth = new Date(this.currentMonth);
      newMonth.setMonth(newMonth.getMonth() + 1);
      this.currentMonth = newMonth;
      // 只更新日历标题，不立即生成日历，等待数据获取完成后再生成
      const monthNames = [
        this.$t('onAir.january'), this.$t('onAir.february'), this.$t('onAir.march'),
        this.$t('onAir.april'), this.$t('onAir.may'), this.$t('onAir.june'),
        this.$t('onAir.july'), this.$t('onAir.august'), this.$t('onAir.september'),
        this.$t('onAir.october'), this.$t('onAir.november'), this.$t('onAir.december')
      ];
      this.calendarTitle = `${monthNames[newMonth.getMonth()]} ${newMonth.getFullYear()}`;
      this.fetchAttendanceHistory();
    },

    // 生成日历日期数组
    generateCalendarDays() {
      const year = this.currentMonth.getFullYear();
      const month = this.currentMonth.getMonth();
      
      // 设置日历标题
      const monthNames = [
        this.$t('onAir.january'), this.$t('onAir.february'), this.$t('onAir.march'),
        this.$t('onAir.april'), this.$t('onAir.may'), this.$t('onAir.june'),
        this.$t('onAir.july'), this.$t('onAir.august'), this.$t('onAir.september'),
        this.$t('onAir.october'), this.$t('onAir.november'), this.$t('onAir.december')
      ];
      this.calendarTitle = `${monthNames[month]} ${year}`;
      
      // 获取当月的第一天和最后一天
      const firstDay = new Date(year, month, 1);
      const lastDay = new Date(year, month + 1, 0);
      
      // 获取第一天是星期几（0 = Sunday, 1 = Monday, ...）
      const firstDayOfWeek = firstDay.getDay();
      
      // 获取上个月的最后几天
      const prevMonthLastDay = new Date(year, month, 0).getDate();
      
      // 清空日历数组
      this.calendarDays = [];
      
      // 添加上个月的日期
      for (let i = firstDayOfWeek - 1; i >= 0; i--) {
        const date = new Date(year, month - 1, prevMonthLastDay - i);
        this.calendarDays.push({
          date: date,
          isCurrentMonth: false,
          isToday: false,
          hasAttendance: false,
          attendanceCount: 0
        });
      }
      
      // 添加当月的日期
      const today = new Date();
      for (let day = 1; day <= lastDay.getDate(); day++) {
        const date = new Date(year, month, day);
        const isToday = date.getDate() === today.getDate() && 
                       date.getMonth() === today.getMonth() && 
                       date.getFullYear() === today.getFullYear();
        
        // 检查这一天是否有用户访问记录
        const hasAttendance = this.checkDateHasAttendance(date);
        const attendanceCount = this.getAttendanceCountForDate(date);
        
        this.calendarDays.push({
          date: date,
          isCurrentMonth: true,
          isToday: isToday,
          hasAttendance: hasAttendance,
          attendanceCount: attendanceCount
        });
      }
      
      // 添加下个月的日期，使日历完整（6行 x 7列 = 42天）
      const totalDays = this.calendarDays.length;
      const remainingDays = 42 - totalDays;
      
      for (let day = 1; day <= remainingDays; day++) {
        const date = new Date(year, month + 1, day);
        this.calendarDays.push({
          date: date,
          isCurrentMonth: false,
          isToday: false,
          hasAttendance: false,
          attendanceCount: 0
        });
      }
    },

    // 检查指定日期是否有用户访问记录
    checkDateHasAttendance(date) {
      if (!this.attendanceData || this.attendanceData.length === 0) {
        return false;
      }
      
      const dateStr = this.formatDateForComparison(date);
      
      return this.attendanceData.some(session => {
        const sessionDate = new Date(session.startTime);
        const sessionDateStr = this.formatDateForComparison(sessionDate);
        return sessionDateStr === dateStr;
      });
    },

    // 获取指定日期的访问次数
    getAttendanceCountForDate(date) {
      if (!this.attendanceData || this.attendanceData.length === 0) {
        return 0;
      }
      
      const dateStr = this.formatDateForComparison(date);
      
      return this.attendanceData.filter(session => {
        const sessionDate = new Date(session.startTime);
        const sessionDateStr = this.formatDateForComparison(sessionDate);
        return sessionDateStr === dateStr;
      }).length;
    },

    // 格式化日期用于比较（YYYY-MM-DD格式）
    formatDateForComparison(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    // 获取用户历史访问数据
    async fetchAttendanceHistory() {
      try {
        console.log('开始获取用户历史访问数据');
        
        // 设置加载状态
        this.attendanceLoading = true;
        
        // 获取katoken用于认证
        const katoken = localStorage.getItem('katoken');
        if (!katoken) {
          console.error('未找到katoken，无法获取用户历史访问数据');
          this.attendanceLoading = false;
          return;
        }

        // 检查是否有必要的参数
        if (!this.currentRoomId) {
          console.error('缺少房间ID，无法获取用户历史访问数据');
          this.attendanceLoading = false;
          return;
        }

        // 尝试从当前选中的用户消息中获取userInfoId
        let userInfoId = null;
        if (this.selectedUser.userInfoId) {
          userInfoId = this.selectedUser.userInfoId;
        } else {
          // 尝试从activities或historicalComments中查找该用户的userInfoId
          const allActivities = [...this.activities, ...this.historicalComments];
          const userActivity = allActivities.find(activity => 
            activity.name === this.selectedUser.name
          );
          if (userActivity && userActivity.userInfoId) {
            userInfoId = userActivity.userInfoId;
            console.log('从活动数据中找到userInfoId:', userInfoId);
          }
        }

        if (!userInfoId) {
          console.warn('无法获取用户的userInfoId，使用默认值');
          userInfoId = 'default';
        }

        // 计算当前月份的开始和结束时间
        const year = this.currentMonth.getFullYear();
        const month = this.currentMonth.getMonth();
        const startDate = new Date(year, month, 1);
        const endDate = new Date(year, month + 1, 0, 23, 59, 59);

        // 格式化时间字符串
        const formatDateTime = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          const hours = String(date.getHours()).padStart(2, '0');
          const minutes = String(date.getMinutes()).padStart(2, '0');
          const seconds = String(date.getSeconds()).padStart(2, '0');
          return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
        };

        const startTime = formatDateTime(startDate);
        const endTime = formatDateTime(endDate);

        // 构建API请求参数
        const requestBody = {
          liveRoomId: this.currentRoomId,
          userInfoId: userInfoId,
          startTime: startTime,
          endTime: endTime,
          pageIndex: 1,
          pageSize: 100 // 获取足够多的数据以显示整个月的访问情况
        };

        console.log('用户历史访问数据请求参数:', requestBody);

        // 调用用户历史访问数据API
        const response = await fetch(getApiUrl('USER_SESSION_STATS_HISTORY'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'req_app_id': 'LivePlugin',
            'req_app_secret': 'ewMpjg7t4vX5bK13oRZzSB8mEuNGr2Yy',
            'katoken': katoken
          },
          body: JSON.stringify(requestBody)
        });

        console.log('用户历史访问数据API响应状态:', response.status);

        if (!response.ok) {
          const errorText = await response.text();
          console.error('获取用户历史访问数据API请求失败:', response.status, errorText);
          // API调用失败时不清空attendanceData，保留之前的数据
          console.warn('API调用失败，保留之前的attendanceData');
        } else {
          const data = await response.json();
          console.log('用户历史访问数据API响应数据:', data);

          if (data.success && data.data && Array.isArray(data.data)) {
            // 处理API返回的数据
            this.attendanceData = data.data.map(session => ({
              sessionId: session.sessionId,
              liveRoomId: session.liveRoomId,
              title: session.title,
              coverUrl: session.coverUrl,
              startTime: session.startTime,
              endTime: session.endTime,
              status: session.status,
              statusDesc: session.statusDesc,
              behaviorStats: session.behaviorStats
            }));

            console.log('成功获取用户历史访问数据，数量:', this.attendanceData.length);
          } else {
            console.warn('获取用户历史访问数据失败或无数据:', data);
            // 不更新attendanceData，保留之前的数据
          }
        }

        // 无论API调用成功与否，都生成日历
        // 如果attendanceData有数据，日历会显示标注；如果没有数据，日历会显示无标注
        this.generateCalendarDays();
        
      } catch (error) {
        console.error('获取用户历史访问数据失败:', error);
        // 发生异常时也不清空attendanceData，保留之前的数据
        // 仍然生成日历
        this.generateCalendarDays();
      } finally {
        this.attendanceLoading = false;
      }
    },

    // 查找用户在潜在赞助者列表中的真实概率
    findUserProbability(userName) {
      if (!userName || !this.potentialPatrons || this.potentialPatrons.length === 0) {
        console.log('未找到用户概率信息，使用默认值:', userName);
        return '0%';
      }
      
      // 在潜在赞助者列表中查找用户
      const user = this.potentialPatrons.find(patron => 
        patron.userName && patron.userName === userName
      );
      
      if (user) {
        console.log(`找到用户 ${userName} 的概率: ${user.rewardProbability}`);
        return this.formatProbability(user.rewardProbability);
      } else {
        console.log(`未在潜在赞助者列表中找到用户: ${userName}`);
        return '0%';
      }
    },

    // 提取礼物名称 - 根据API返回的content格式解析
    extractGiftName(content) {
      if (!content) return '未知礼物';
      
      console.log('提取礼物名称，内容:', content);
      
      // 根据API返回的格式解析：15Jpop🐱からぁげ_🍮🐼No. 2 sent Ice Cream Cone × 1
      // 或者：15Jpop🐱からぁげ_🍮🐼 sent Ice Cream Cone × 1
      const giftMatch = content.match(/(?:No\. \d+ )?sent (.+?) × (\d+)/);
      if (giftMatch && giftMatch[1]) {
        const giftName = giftMatch[1].trim();
        console.log('成功提取礼物名称:', giftName);
        return giftName;
      }
      
      // 尝试其他可能的格式
      const otherMatch = content.match(/sent (.+?)(?: × \d+)?$/);
      if (otherMatch && otherMatch[1]) {
        const giftName = otherMatch[1].trim();
        console.log('其他格式提取礼物名称:', giftName);
        return giftName;
      }
      
      console.log('无法提取礼物名称，使用默认值');
      return '未知礼物';
    },

    // 提取礼物数量 - 根据API返回的content格式解析
    extractGiftCount(content) {
      if (!content) return 1;
      
      console.log('提取礼物数量，内容:', content);
      
      // 根据API返回的格式解析：× 1 或 × 20
      const countMatch = content.match(/× (\d+)/);
      if (countMatch && countMatch[1]) {
        const count = parseInt(countMatch[1]);
        console.log('成功提取礼物数量:', count);
        return count;
      }
      
      console.log('无法提取礼物数量，使用默认值1');
      return 1;
    },

    // 提取礼物价值 - 对于历史记录，暂时返回0，因为API没有提供价值信息
    extractGiftValue(content) {
      // 历史记录API没有提供礼物价值信息，返回0
      return 0;
    },

    // 格式化概率
    formatProbability(probability) {
      if (typeof probability === 'number') {
        return `${(probability * 100).toFixed(1)}%`;
      }
      return '0%';
    },

    // 获取用户头像URL
    getUserAvatarUrl(userInfoId = null) {
      // 返回默认头像URL
      return 'https://via.placeholder.com/40x40?text=User';
    },

    // 格式化最后交互时间
    formatLastInteractionTime(timestamp) {
      if (!timestamp) return 'N/A';

      try {
        // 如果是ISO字符串格式
        if (timestamp.includes('T')) {
          const date = new Date(timestamp);
          return date.toLocaleString('zh-CN', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false
          });
        }

        // 如果已经是格式化的字符串，直接返回
        const date = new Date(timestamp);
        if (!isNaN(date.getTime())) {
          return date.toLocaleString('zh-CN', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false
          });
        }

        return timestamp;
      } catch (error) {
        console.warn('格式化最后交互时间失败:', error);
        return timestamp || 'N/A';
      }
    },

    // 格式化从进入时间到现在的时间间隔
    formatTimeSinceEntry(enterTime) {
      if (!enterTime) return 'N/A';

      try {
        // 解析进入时间字符串 "2025-12-02 22:20:07"
        const enterDate = new Date(enterTime.replace(' ', 'T'));
        const currentDate = new Date();

        // 计算时间差（毫秒）
        const diffMs = currentDate.getTime() - enterDate.getTime();

        if (diffMs <= 0) {
          return '00:00';
        }

        // 将毫秒转换为秒、分钟、小时、天
        const seconds = Math.floor(diffMs / 1000);
        const minutes = Math.floor(seconds / 60);
        const hours = Math.floor(minutes / 60);
        const days = Math.floor(hours / 24);

        if (days > 0) {
          // 如果超过1天，显示 HH:MM 格式（天数转为小时）
          const totalHours = hours % 24;
          const totalMinutes = minutes % 60;
          return `${totalHours.toString().padStart(2, '0')}:${totalMinutes.toString().padStart(2, '0')}`;
        } else if (hours > 0) {
          // 如果超过1小时，显示 HH:MM
          const remainingMinutes = minutes % 60;
          return `${hours.toString().padStart(2, '0')}:${remainingMinutes.toString().padStart(2, '0')}`;
        } else {
          // 如果在1小时以内，显示 MM:SS
          const remainingSeconds = seconds % 60;
          return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
        }

      } catch (error) {
        console.warn('格式化进入时间间隔失败:', error);
        return 'N/A';
      }
    },

    // 从本地存储加载消息列表
    loadMessagesFromStorage() {
      try {
        console.log('从本地存储加载消息列表');
        
        // 加载实时消息
        const savedActivities = localStorage.getItem('dashboard_activities');
        if (savedActivities) {
          const parsedActivities = JSON.parse(savedActivities);
          console.log('从本地存储加载实时消息:', parsedActivities.length);
          this.activities = parsedActivities;
        }

        // 加载历史评论
        const savedHistoricalComments = localStorage.getItem('dashboard_historical_comments');
        if (savedHistoricalComments) {
          const parsedHistoricalComments = JSON.parse(savedHistoricalComments);
          console.log('从本地存储加载历史评论:', parsedHistoricalComments.length);
          this.historicalComments = parsedHistoricalComments;
        }

        console.log('消息列表加载完成');
      } catch (error) {
        console.error('从本地存储加载消息列表失败:', error);
      }
    },

    // 保存消息列表到本地存储
    saveMessagesToStorage() {
      try {
        console.log('保存消息列表到本地存储');
        
        // 保存实时消息（最多100条）
        const activitiesToSave = this.activities.slice(0, 100);
        localStorage.setItem('dashboard_activities', JSON.stringify(activitiesToSave));
        
        // 保存历史评论（最多200条）
        const historicalCommentsToSave = this.historicalComments.slice(0, 200);
        localStorage.setItem('dashboard_historical_comments', JSON.stringify(historicalCommentsToSave));
        
        console.log('消息列表保存完成');
      } catch (error) {
        console.error('保存消息列表到本地存储失败:', error);
      }
    },

    // 调用脚本生成API
    async callScriptGenerationAPI(prompt) {
      try {
        console.log('调用脚本生成API, 提示词长度:', prompt ? prompt.length : 0);

        // 获取katoken用于认证
        const katoken = localStorage.getItem('katoken');
        if (!katoken) {
          console.error('未找到katoken，无法调用脚本生成API');
          throw new Error('未登录，无法生成脚本');
        }

        // 确保有当前房间ID和会话ID
        if (!this.currentRoomId || !this.currentSessionId) {
          console.error('当前房间ID或会话ID不存在，无法生成脚本');
          throw new Error('请先连接直播间再生成脚本');
        }

        // 构建请求体 - 使用正确的参数格式
        const requestBody = {
          liveRoomId: this.currentRoomId,
          sessionId: parseInt(this.currentSessionId), // 转换为数字
          description: prompt // 脚本描述
          // llmModelName: "gemini-2.5-flash" // 后台自动选择大模型，无需指定
        };

        console.log('构建的请求体:', JSON.stringify(requestBody, null, 2));

        const apiUrl = getApiUrl('SCRIPT_GENERATION_GENERATE_BY_DESCRIPTION');
        console.log('脚本生成API URL:', apiUrl);

        // 发送请求
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'req_app_id': 'LivePlugin',
            'req_app_secret': 'ewMpjg7t4vX5bK13oRZzSB8mEuNGr2Yy',
            'katoken': katoken
          },
          body: JSON.stringify(requestBody)
        });

        console.log('脚本生成API响应状态:', response.status);

        if (!response.ok) {
          const errorText = await response.text();
          console.error('脚本生成API请求失败:', response.status, errorText);
          throw new Error(`脚本生成API请求失败: ${response.status}`);
        }

        const data = await response.json();
        console.log('脚本生成API响应数据:', data);

        // 检查API响应格式 - 支持嵌套的success字段
        if (data.success && data.data) {
          // 检查内层的success字段（新API格式）
          if (data.data.success === true) {
            console.log('脚本生成成功');
            return data;
          } else if (data.data.success === false && data.data.errorMessage) {
            // API调用失败，但有明确的错误信息
            console.error('脚本生成API处理失败:', data.data.errorMessage);

            // 根据不同的错误类型提供用户友好的错误信息
            let errorMessage = '脚本生成失败';
            if (data.data.errorMessage.includes('429 Too Many Requests')) {
              errorMessage = '生成频率过快，请稍后再试';
            } else if (data.data.errorMessage.includes('Quota exceeded')) {
              errorMessage = 'API调用额度不足，请检查配额';
            } else if (data.data.errorMessage.length > 50) {
              // 如果错误信息太长，只显示开头部分
              errorMessage = data.data.errorMessage.substring(0, 50) + '...';
            } else {
              errorMessage = data.data.errorMessage;
            }

            throw new Error(errorMessage);
          } else {
            // 内层success字段不存在，检查旧格式
            if (data.data.script) {
              console.log('脚本生成成功（旧格式）');
              return data;
            }
          }
        }

        console.error('脚本生成API返回格式错误:', data);
        throw new Error('脚本生成失败，请重试');
      } catch (error) {
        console.error('调用脚本生成API失败:', error);
        throw error;
      }
    },

    /**
     * 设置直播间切换事件监听器
     */
    setupStreamerChangeListener() {
      console.log('设置直播间切换事件监听器');
      
      // 监听App.vue发出的事件
      if (this.$root && this.$root.$on) {
        this.$root.$on('streamer-changed', this.handleStreamerChanged);
        console.log('直播间切换事件监听器已设置');
      } else {
        console.warn('无法设置直播间切换事件监听器，$root事件总线不可用');
      }
    },

    /**
     * 清理直播间切换事件监听器
     */
    cleanupStreamerChangeListener() {
      console.log('清理直播间切换事件监听器');
      
      if (this.$root && this.$root.$off) {
        this.$root.$off('streamer-changed', this.handleStreamerChanged);
        console.log('直播间切换事件监听器已清理');
      }
    },

    /**
     * 处理直播间切换事件
     */
    handleStreamerChanged(streamer) {
      console.log('=== 收到直播间切换事件 ===');
      console.log('切换到新主播:', streamer.name, '直播间ID:', streamer.roomId);
      
      // 立即断开所有WebSocket连接
      this.disconnectWebSocket();
      
      // 清空所有活动数据
      this.activities = [];
      this.historicalComments = [];
      this.historicalPageIndex = 1;
      this.hasMoreHistorical = true;
      
      // 重置右栏内容
      this.resetRightColumn();
      
      // 清空潜在赞助者列表
      this.potentialPatrons = [];
      
      // 重置话术建议相关状态
      this.suggestionQueue = [];
      this.isShowingSuggestion = false;
      if (this.currentSuggestionTimer) {
        clearTimeout(this.currentSuggestionTimer);
        this.currentSuggestionTimer = null;
      }
      
      // 设置直播状态为false，因为切换主播后需要重新检查直播状态
      this.setLiveStatus(false);
      console.log('直播状态已设置为false，等待重新检查');
      
      console.log('Dashboard数据已重置，准备重新连接新直播间');
      
      // 立即检查新直播间的连接状态
      this.$nextTick(() => {
        setTimeout(() => {
          console.log('开始检查新直播间的连接状态');
          this.checkRoomConnection();
        }, 500);
      });
    },

  },
  mounted() {
    console.log('Dashboard组件已挂载，开始初始化...');

    // 从本地存储加载消息列表
    this.loadMessagesFromStorage();

    // 检查是否有等待处理的脚本生成请求
    this.checkScriptGenerationPending();

    // 启动时间更新定时器
    this.startTimeUpdateTimer();

    // 启动定期检查直播间连接状态
    this.startPeriodicChecking();

    // 监听直播间切换事件
    this.setupStreamerChangeListener();

    // 初始化日历组件
    this.generateCalendarDays();

    // 初始化聊天自动滚动
    this.startChatAutoScroll();
  },
  beforeDestroy() {
    // 清理定时器和WebSocket连接
    this.stopPeriodicChecking();
    this.stopTimeUpdateTimer();
    this.disconnectWebSocket();
    
    // 清理潜在赞助者定时器
    if (this.potentialPatronsTimer) {
      clearInterval(this.potentialPatronsTimer);
      this.potentialPatronsTimer = null;
      console.log('潜在赞助者定时器已清理');
    }
  },
  beforeUnmount() {
    // 清理录音对象
    if (this.recognition) {
      this.recognition.stop();
      this.recognition = null;
    }
    
    // 清理直播间切换事件监听器
    this.cleanupStreamerChangeListener();
  }
}
</script>

<style scoped>
/* 自定义滚动条样式 - 支持浅色/深色模式 */
.custom-scrollbar::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}

/* 深色模式下的滚动条样式 */
.dark .custom-scrollbar::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
}

.dark .custom-scrollbar::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
}

.dark .custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.3);
}

/* Firefox 滚动条样式 */
.custom-scrollbar {
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);
}

.dark .custom-scrollbar {
  scrollbar-color: rgba(255, 255, 255, 0.2) rgba(255, 255, 255, 0.05);
}
</style>
